//import { constants } from 'buffer';
//import { Constantes } from './constantes';

//import { ProjectDataProductoType } from '../entities/project-data-producto-type.interface';

export class DB {
	// Familias.
	public static readonly CERCADO = "CERCADO";
	public static readonly VERJA = "VERJA";

	// Modelos de Cercados.
	public static readonly CERCADO_LUX_EXT = "LUX_EST";
	public static readonly CERCADO_ELECTRO = "LUX_ELECTRO";
	public static readonly CERCADO_ANUDADA = "LUX_ANUDADA";

	// Modelos de Verjas.
	public static readonly VERJA_BRICO_FAX = "BRICO-FAX";
	public static readonly VERJA_FAX = "FAX";
	public static readonly VERJA_FAX_DH = "FAX DH";
	public static readonly VERJA_MAXI_FAX = "MAXI-FAX";
	public static readonly VERJA_RITMO = "RITMO";
	public static readonly VERJA_RITMO_DH = "RITMO DH";
	public static readonly VERJA_RITMO_CLIP = "RITMOCLIP";
	public static readonly VERJA_CLASSIC = "CLASSIC";
	public static readonly VERJA_NATURE = "NATURE";
	public static readonly VERJA_CALITAX = "CALITAX";
	public static readonly VERJA_NOVE = "NOVE";
	public static readonly VERJA_ULTRA = "ULTRA";
	public static readonly VERJA_DECOR = "DECOR";

	constructor() {}

	// Retorna el listado de modelos según familia.
	public paneles(familiaTipo: string) {
		if (familiaTipo === DB.CERCADO) return this.cercados;
		else if (familiaTipo === DB.VERJA) this.verjas;
		return [];
	}

	//
	public panel(familiaTipo: string, idPanel: string) {
		if (familiaTipo === DB.CERCADO) {
			return this.cercados.filter((c) => {
				return c._id == idPanel;
			});
		} else if (familiaTipo === DB.VERJA) {
			return this.verjas.filter((c) => {
				return c._id == idPanel;
			});
		}
		return [];
	}

	// Retorna el listado de paneles según familia y modelo.
	public tipoPanelesPorModelo(familiaTipo: string, modeloId: string): any {
		if (familiaTipo === DB.CERCADO) {
			return this.tiposCercados.filter((p) => {
				return p.modelo == modeloId;
			});
		} else if (familiaTipo === DB.VERJA) {
			return this.tiposVerjas.filter((p) => {
				return p.modelo == modeloId;
			});
		}
		return [];
	}

	// Retorna un panel determinado por familiaTipo y panelId.
	public tipoPanel(familiaTipo: string, panelId: string) {
		if (familiaTipo === DB.CERCADO) {
			return this.tiposCercados.filter((p) => {
				return p._id == panelId;
			});
		} else {
			return this.tiposVerjas.filter((p) => {
				return p._id == panelId;
			});
		}
	}

	public tipoPuerta(tipoPuerta: string) {
		console.log(tipoPuerta);
		console.log(this.tipoPuertas);

		return this.tipoPuertas.filter((p) => {
			return p.modeloPuerta == tipoPuerta;
		});
	}

	public readonly paleta = [
		{
			_id: "595bb930060cda18c1334ed0",
			ral: 0,
			hex: "#DADADA",
			name: "galvanizado",
			check: true,
			desc: {
				es: "Galvanizado",
				ca: "Galvanizat",
				en: "Galvanized",
				fr: "Galvanizado",
			},
		},
		{
			_id: "595bb930060cda18c1334ed2",
			ral: 6005,
			hex: "#004A39",
			name: "verde",
			check: true,
			desc: { es: "Verde", ca: "Verd", en: "Green", fr: "Vert" },
		},
		{
			_id: "595bb930060cda18c1334ed4",
			ral: 1018,
			hex: "#FFD500",
			name: "zinc",
			check: true,
			desc: {
				es: "Amarillo de zinc",
				ca: "Groc de zinc",
				en: "Zinc yellow",
				fr: "Jaune zinc",
			},
		},
		{
			_id: "595bb930060cda18c1334ed6",
			ral: 3005,
			hex: "#751632",
			name: "vino",
			check: true,
			desc: {
				es: "Rojo vino",
				ca: "Vermell vi",
				en: "Wine red",
				fr: "Rouge vin",
			},
		},
		{
			_id: "595bb930060cda18c1334ed8",
			ral: 3020,
			hex: "#D20A11",
			name: "rojo",
			check: true,
			desc: {
				es: "Rojo tráfico",
				ca: "Vermell tràfic",
				en: "Traffic red",
				fr: "Rouge signalisation",
			},
		},
		{
			_id: "595bb930060cda18c1334eda",
			ral: 0,
			hex: "#1B1B1A",
			name: "oxiron",
			check: true,
			desc: { es: "Oxirón", ca: "Oxiron", en: "Oxiron", fr: "Oxiron" },
		},
		{
			_id: "595bb930060cda18c1334edc",
			ral: 9006,
			hex: "#A7A2A0",
			name: "metalico",
			check: true,
			desc: {
				es: "Aluminio blanco (Gris metálico)",
				ca: "Alumini blanc (Gris metàlic)",
				en: "White aluminium (Metallic gray)",
				fr: "Aluminium blanc (Gris métallisé)",
			},
		},
		{
			_id: "595bb930060cda18c1334ede",
			ral: 7030,
			hex: "#96948B",
			name: "piedra",
			check: true,
			desc: {
				es: "Gris piedra",
				ca: "Gris pedra",
				en: "Stone grey",
				fr: "Gris pierre",
			},
		},
		{
			_id: "595bb930060cda18c1334ee0",
			ral: 9005,
			hex: "#00181B",
			name: "negro",
			check: true,
			desc: {
				es: "Negro intenso",
				ca: "Negre intens",
				en: "Jet black",
				fr: "Noir foncé",
			},
		},
		{
			_id: "595bb930060cda18c1334ee2",
			ral: 5001,
			hex: "#004161",
			name: "azul",
			check: true,
			desc: {
				es: "Azul verdoso",
				ca: "Blau verdós",
				en: "Green blue",
				fr: "Bleu vert",
			},
		},
		{
			_id: "5b16ab91ca1df794edf82088",
			ral: 9016,
			hex: "#FFFFFF",
			name: "blanco",
			check: true,
			desc: { es: "Blanco", ca: "Blanc", en: "White", fr: "Blanc" },
		},
		{
			_id: "5b16acd5ca1df794edf82198",
			ral: 7016,
			hex: "#24353F",
			name: "antracita",
			check: true,
			desc: {
				es: "Gris Antracita",
				ca: "Gris Antracita",
				en: "Anthracite Gray",
				fr: "Gris Anthracite",
			},
		},
	];

	public readonly cercadoTitulo = {
		es: "Cercado Residencial y Rural",
		ca: "Tancats residencials i rurals",
		en: "Residential and Rural Fence",
		fr: "Clôture Résidentielle et Rural",
	};

	public readonly verjaTitulo = {
		es: "Verjas residenciales e industriales",
		ca: "Reixes residencials i industrials",
		en: "Residential and industrial fences",
		fr: "Clôtures résidentielles et industrielles",
	};

	// FAMILIAS (2)
	public readonly familiaCERCADO = {
		_id: "593a6250b040e6170cb9aa66",
		orden: 0,
		background: "#a0b101",
		tipo: "CERCADO",
		idUnity: "CERCADO",
		desc: {
			es: "Cercado Residencial y Rural",
			ca: "Tancats residencials i rurals",
			en: "Residential and Rural Fence",
			fr: "Clôture Résidentielle et Rural",
		},
	};

	public readonly familiaVERJA = {
		_id: "5b152a19ca1df794edf71a16",
		orden: 1,
		background: "#e8a500",
		tipo: "VERJA",
		idUnity: "VERJA",
		desc: {
			es: "Verjas residenciales e industriales",
			ca: "Reixes residencials i industrials",
			en: "Residential and industrial fences",
			fr: "Clôtures résidentielles et industrielles",
		},
	};
	// MODELOS CERCADOS (3)
	public readonly cercados = [
		{
			_id: "593a6ae4b040e6170cb9ab50",
			idUnity: "LUX_EST",
			IDFamilia: "CERCADO",
			longitud: 3,
			familia: "593a6250b040e6170cb9aa66",
			muro: true,
			orden: 1,
			background: "#a0b101",
			desc: {
				es: "Cercado Lux EST",
				ca: "Tancat Lux EST",
				en: "Lux EST Fence",
				fr: "Clôture Lux EST",
			},
		},
		{
			_id: "593a6ae4b040e6170cb9ab52",
			idUnity: "LUX_ELECTRO",
			IDFamilia: "CERCADO",
			longitud: 3,
			familia: "593a6250b040e6170cb9aa66",
			muro: false,
			orden: 2,
			background: "#a0b101",
			desc: {
				es: "Cercado Lux Malla Electrosoldada",
				ca: "Tancat Lux Malla Electrosoldada",
				en: "Electro-welded Mesh Lux Fence",
				fr: "Clôture Lux Grillage Électro-soudé",
			},
		},
		{
			_id: "593a6ae4b040e6170cb9ab54",
			idUnity: "LUX_ANUDADA",
			IDFamilia: "CERCADO",
			longitud: 6,
			familia: "593a6250b040e6170cb9aa66",
			muro: false,
			orden: 3,
			background: "#a0b101",
			desc: {
				es: "Cercado Lux Malla Anudada",
				ca: "Tancat Lux Malla Nuada",
				en: "Clôture Lux Grillage Noué",
				fr: "Knotted Mesh Lux Fence",
			},
		},
	];

	// MODELOS VERJA (13)
	public readonly verjas = [
		{
			_id: "5b1539e7ca1df794edf72791",
			idUnity: "BRICO-FAX",
			IDFamilia: "VERJA",
			familia: "5b152a19ca1df794edf71a16",
			muro: true,
			orden: 1,
			background: "#e8a500",
			longitud: 2.495,
			desc: {
				es: "Verja BRICO-FAX",
				ca: "Tanca BRICO-FAX",
				en: "Fence BRICO-FAX",
				fr: "Clôture BRICO-FAX",
			},
			tipos: [],
		},
		{
			_id: "5b153ad3ca1df794edf7285b",
			idUnity: "FAX",
			IDFamilia: "VERJA",
			familia: "5b152a19ca1df794edf71a16",
			muro: true,
			orden: 2,
			background: "#e8a500",
			longitud: 2.495,
			desc: {
				es: "Verja FAX",
				ca: "Tanca FAX",
				en: "Fence FAX",
				fr: "Clôture FAX",
			},
		},
		{
			_id: "5b153ae3ca1df794edf72868",
			idUnity: "FAX DH",
			IDFamilia: "VERJA",
			familia: "5b152a19ca1df794edf71a16",
			muro: true,
			orden: 3,
			background: "#e8a500",
			longitud: 2.495,
			desc: {
				es: "Verja FAX DH",
				ca: "Tanca FAX DH",
				en: "Fence FAX DH",
				fr: "Clôture FAX DH",
			},
		},
		{
			_id: "5b153b2bca1df794edf7289e",
			idUnity: "MAXI-FAX",
			IDFamilia: "VERJA",
			familia: "5b152a19ca1df794edf71a16",
			muro: true,
			orden: 4,
			background: "#e8a500",
			longitud: 2.605,
			desc: {
				es: "Verja MAXI-FAX",
				ca: "Tanca MAXI-FAX",
				en: "Fence MAXI-FAX",
				fr: "Clôture MAXI-FAX",
			},
		},
		{
			_id: "5b153b74ca1df794edf728d3",
			idUnity: "RITMO",
			IDFamilia: "VERJA",
			familia: "5b152a19ca1df794edf71a16",
			muro: true,
			orden: 5,
			background: "#e8a500",
			longitud: 2.495,
			desc: {
				es: "Verja RITMO",
				ca: "Tanca RITMO",
				en: "Fence RITMO",
				fr: "Clôture RITMO",
			},
		},
		{
			_id: "5b153ba0ca1df794edf728f6",
			idUnity: "RITMO DH",
			IDFamilia: "VERJA",
			familia: "5b152a19ca1df794edf71a16",
			muro: true,
			orden: 6,
			background: "#e8a500",
			longitud: 2.495,
			desc: {
				es: "Verja RITMO DH",
				ca: "Tanca RITMO DH",
				en: "Fence RITMO DH",
				fr: "Clôture RITMO DH",
			},
		},
		{
			_id: "5b153bcbca1df794edf72915",
			idUnity: "RITMOCLIP",
			IDFamilia: "VERJA",
			familia: "5b152a19ca1df794edf71a16",
			muro: true,
			orden: 7,
			background: "#e8a500",
			longitud: 2.495,
			desc: {
				es: "Verja RITMOCLIP",
				ca: "Tanca RITMOCLIP",
				en: "Fence RITMOCLIP",
				fr: "Clôture RITMOCLIP",
			},
		},
		{
			_id: "5b476530ca1df794ed1965e6",
			idUnity: "CLASSIC",
			IDFamilia: "VERJA",
			familia: "5b152a19ca1df794edf71a16",
			muro: true,
			orden: 8,
			background: "#e8a500",
			longitud: 2.75,
			desc: {
				es: "Verja CLASSIC",
				ca: "Tanca CLASSIC",
				en: "Fence CLASSIC",
				fr: "Clôture CLASSIC",
			},
		},
		{
			_id: "5b47663eca1df794ed19671a",
			idUnity: "NATURE",
			IDFamilia: "VERJA",
			familia: "5b152a19ca1df794edf71a16",
			muro: true,
			orden: 13,
			background: "#e8a500",
			longitud: 2.75,
			desc: {
				es: "Verja NATURE",
				ca: "Tanca NATURE",
				en: "Fence NATURE",
				fr: "Clôture NATURE",
			},
		},
		{
			_id: "5b4767beca1df794ed1968c7",
			idUnity: "CALITAX",
			IDFamilia: "VERJA",
			familia: "5b152a19ca1df794edf71a16",
			muro: true,
			orden: 9,
			background: "#e8a500",
			longitud: 2.48,
			desc: {
				es: "Verja CALITAX",
				ca: "Tanca CALITAX",
				en: "Fence CALITAX",
				fr: "Clôture CALITAX",
			},
		},
		{
			_id: "5b4768b1ca1df794ed1969c1",
			idUnity: "NOVE",
			IDFamilia: "VERJA",
			familia: "5b152a19ca1df794edf71a16",
			muro: true,
			orden: 10,
			background: "#e8a500",
			longitud: 2.75,
			desc: {
				es: "Verja NOVE",
				ca: "Tanca NOVE",
				en: "Fence NOVE",
				fr: "Clôture NOVE",
			},
		},
		{
			_id: "5b476914ca1df794ed196a28",
			idUnity: "ULTRA",
			IDFamilia: "VERJA",
			familia: "5b152a19ca1df794edf71a16",
			muro: true,
			orden: 11,
			background: "#e8a500",
			longitud: 2.75,
			desc: {
				es: "Verja ULTRA",
				ca: "Tanca ULTRA",
				en: "Fence ULTRA",
				fr: "Clôture ULTRA",
			},
		},
		{
			_id: "5b476991ca1df794ed196ab3",
			idUnity: "DECOR",
			IDFamilia: "VERJA",
			familia: "5b152a19ca1df794edf71a16",
			muro: true,
			orden: 12,
			background: "#e8a500",
			longitud: 2.75,
			desc: {
				es: "Verja DECOR",
				ca: "Tanca DECOR",
				en: "Fence DECOR",
				fr: "Clôture DECOR",
			},
		},
	];

	public readonly tiposVerjas = [
		{
			_id: "5b2110baca1df794edfe93d7",
			order: 0,
			modelo: "5b1539e7ca1df794edf72791",
			desc: { es: "1m00", ca: "1m00", en: "1m00", fr: "1m00" },
			dimensiones: "",
			poste: ["LUX 50mm"],
			modeloStr: "BRICO-FAX",
		},
		{
			_id: "5b2110c3ca1df794edfe93e0",
			order: 1,
			modelo: "5b1539e7ca1df794edf72791",
			desc: { es: "1m50", ca: "1m50", en: "1m50", fr: "1m50" },
			dimensiones: "",
			poste: ["LUX 50mm"],
			modeloStr: "BRICO-FAX",
		},
		{
			_id: "5b2110cbca1df794edfe93e7",
			order: 2,
			modelo: "5b1539e7ca1df794edf72791",
			desc: { es: "2m00", ca: "2m00", en: "2m00", fr: "2m00" },
			dimensiones: "",
			poste: ["LUX 50mm"],
			modeloStr: "BRICO-FAX",
		},
		{
			_id: "5b212e4eca1df794edfeaa08",
			order: 0,
			modelo: "5b153ad3ca1df794edf7285b",
			desc: { es: "0m60", ca: "0m60", en: "0m60", fr: "0m60" },
			dimensiones: "2m50x630",
			poste: ["LUX 50mm"],
			modeloStr: "FAX",
		},
		{
			_id: "5b212e57ca1df794edfeaa11",
			order: 1,
			modelo: "5b153ad3ca1df794edf7285b",
			desc: { es: "1m00", ca: "1m00", en: "1m00", fr: "1m00" },
			dimensiones: "2m50x1030",
			poste: ["LUX 50mm"],
			modeloStr: "FAX",
		},
		{
			_id: "5b212e60ca1df794edfeaa1a",
			order: 2,
			modelo: "5b153ad3ca1df794edf7285b",
			desc: { es: "1m20", ca: "1m20", en: "1m20", fr: "1m20" },
			dimensiones: "2m50x1230",
			poste: ["LUX 50mm"],
			modeloStr: "FAX",
		},
		{
			_id: "5b212e6aca1df794edfeaa25",
			order: 3,
			modelo: "5b153ad3ca1df794edf7285b",
			desc: {
				es: "1m50 (1m43)",
				ca: "1m50 (1m43)",
				en: "1m50 (1m43)",
				fr: "1m50 (1m43)",
			},
			dimensiones: "2m50x1430",
			poste: ["LUX 50mm"],
			modeloStr: "FAX",
		},

		{
			_id: "5b212e6aca1df794edfeaa24",
			order: 4,
			modelo: "5b153ad3ca1df794edf7285b",
			desc: {
				es: "1m50 (1m53) L50",
				ca: "1m50 (1m53) L50",
				en: "1m50 (1m53) L50",
				fr: "1m50 (1m53) L50",
			},
			dimensiones: "2m50x1530",
			poste: ["LUX 50mm"],
			modeloStr: "FAX",
		},
		{
			_id: "5b212e6aca1df794edfeaa48",
			order: 4,
			modelo: "5b153ad3ca1df794edf7285b",
			desc: {
				es: "1m50 (1m53) L80",
				ca: "1m50 (1m53) L80",
				en: "1m50 (1m53) L80",
				fr: "1m50 (1m53) L80",
			},
			dimensiones: "2m50x1530",
			poste: ["LUX 80mm"],
			modeloStr: "FAX",
		},

		{
			_id: "5b212e74ca1df794edfeaa2c",
			order: 5,
			modelo: "5b153ad3ca1df794edf7285b",
			desc: { es: "1m80", ca: "1m80", en: "1m80", fr: "1m80" },
			dimensiones: "2m50x1730",
			poste: ["LUX 80mm"],
			modeloStr: "FAX",
		},
		{
			_id: "5b212e7eca1df794edfeaa36",
			order: 6,
			modelo: "5b153ad3ca1df794edf7285b",
			desc: {
				es: "2m00 (1m93)",
				ca: "2m00 (1m93)",
				en: "2m00 (1m93)",
				fr: "2m00 (1m93)",
			},
			dimensiones: "2m50x1930",
			poste: ["LUX 80mm"],
			modeloStr: "FAX",
		},
		{
			_id: "5b212e7eca1df794edfeaa33",
			order: 7,
			modelo: "5b153ad3ca1df794edf7285b",
			desc: {
				es: "2m00 (2m03)",
				ca: "2m00 (2m03)",
				en: "2m00 (2m03)",
				fr: "2m00 (2m03)",
			},
			dimensiones: "2m50x2030",
			poste: ["LUX 80mm"],
			modeloStr: "FAX",
		},
		{
			_id: "5b212e7eca1df794edfeaa77",
			order: 8,
			modelo: "5b153ad3ca1df794edf7285b",
			desc: { es: "2m40", ca: "2m40", en: "2m40", fr: "2m40" },
			dimensiones: "2m50x2430",
			poste: ["LUX 80mm"],
			modeloStr: "FAX",
		},
		{
			_id: "5b2217a2ca1df794edff39e9",
			order: 0,
			modelo: "5b153ae3ca1df794edf72868",
			desc: {
				es: "1m00 Ø alambres 6/5/6",
				ca: "1m00 Ø filferros 6/5/6",
				en: "1m00 Ø wires 6/5/6",
				fr: "1m00 Ø des fils 6/5/6",
			},
			dimensiones: "",
			poste: ["LUX 50mm"],
			modeloStr: "FAX DH",
		},
		{
			_id: "5b2217b6ca1df794edff39fa",
			order: 2,
			modelo: "5b153ae3ca1df794edf72868",
			desc: {
				es: "1m40 Ø alambres 6/5/6",
				ca: "1m40 Ø filferros 6/5/6",
				en: "1m40 Ø wires 6/5/6",
				fr: "1m40 Ø des fils 6/5/6",
			},
			dimensiones: "",
			poste: ["LUX 80mm"],
			modeloStr: "FAX DH",
		},
		{
			_id: "5b2217beca1df794edff3a03",
			order: 3,
			modelo: "5b153ae3ca1df794edf72868",
			desc: {
				es: "1m60 Ø alambres 6/5/6",
				ca: "1m60 Ø filferros 6/5/6",
				en: "1m60 Ø wires 6/5/6",
				fr: "1m60 Ø des fils 6/5/6",
			},
			dimensiones: "",
			poste: ["LUX 80mm"],
			modeloStr: "FAX DH",
		},
		{
			_id: "5b2217c7ca1df794edff3a0d",
			order: 4,
			modelo: "5b153ae3ca1df794edf72868",
			desc: {
				es: "1m80 Ø alambres 6/5/6",
				ca: "1m80 Ø filferros 6/5/6",
				en: "1m80 Ø wires 6/5/6",
				fr: "1m80 Ø des fils 6/5/6",
			},
			dimensiones: "",
			poste: ["LUX 80mm"],
			modeloStr: "FAX DH",
		},
		{
			_id: "5b2217cfca1df794edff3a13",
			order: 5,
			modelo: "5b153ae3ca1df794edf72868",
			desc: {
				es: "2m00 Ø alambres 6/5/6",
				ca: "2m00 Ø filferros 6/5/6",
				en: "2m00 Ø wires 6/5/6",
				fr: "2m00 Ø des fils 6/5/6",
			},
			dimensiones: "",
			poste: ["LUX 80mm"],
			modeloStr: "FAX DH",
		},
		{
			_id: "5b221875ca1df794edff3aa3",
			order: 1,
			modelo: "5b153ae3ca1df794edf72868",
			desc: {
				es: "1m20 Ø alambres 6/5/6",
				ca: "1m20 Ø filferros 6/5/6",
				en: "1m20 Ø wires 6/5/6",
				fr: "1m20 Ø des fils 6/5/6",
			},
			dimensiones: "",
			poste: ["LUX 50mm"],
			modeloStr: "FAX DH",
		},
		{
			_id: "5b221f5fca1df794edff403a",
			order: 0,
			modelo: "5b153b2bca1df794edf7289e",
			desc: { es: "1m50", ca: "1m50", en: "1m50", fr: "1m50" },
			dimensiones: "",
			poste: ["LUX 80mm"],
			modeloStr: "MAXI-FAX",
		},
		{
			_id: "5b221f67ca1df794edff4040",
			order: 1,
			modelo: "5b153b2bca1df794edf7289e",
			desc: { es: "2m00", ca: "2m00", en: "2m00", fr: "2m00" },
			dimensiones: "",
			poste: ["LUX 80mm"],
			modeloStr: "MAXI-FAX",
		},
		{
			_id: "5b221f6eca1df794edff4049",
			order: 2,
			modelo: "5b153b2bca1df794edf7289e",
			desc: { es: "2m40", ca: "2m40", en: "2m40", fr: "2m40" },
			dimensiones: "",
			poste: ["LUX 80mm"],
			modeloStr: "MAXI-FAX",
		},
		{
			_id: "5b222418ca1df794edff441e",
			order: 0,
			modelo: "5b153b74ca1df794edf728d3",
			desc: { es: "0m60", ca: "0m60", en: "0m60", fr: "0m60" },
			dimensiones: "2m50x630",
			poste: ["Ritmo 1,2mm"],
			modeloStr: "RITMO",
		},
		{
			_id: "5b222420ca1df794edff4426",
			order: 1,
			modelo: "5b153b74ca1df794edf728d3",
			desc: { es: "0m80", ca: "0m80", en: "0m80", fr: "0m80" },
			dimensiones: "2m50x830",
			poste: ["Ritmo 1,2mm"],
			modeloStr: "RITMO",
		},
		{
			_id: "5b222428ca1df794edff442f",
			order: 2,
			modelo: "5b153b74ca1df794edf728d3",
			desc: { es: "1m00", ca: "1m00", en: "1m00", fr: "1m00" },
			dimensiones: "2m50x1030",
			poste: ["Ritmo 1,2mm"],
			modeloStr: "RITMO",
		},
		{
			_id: "5b222428ca1df794edff4fff",
			order: 2,
			modelo: "5b153b74ca1df794edf728d3",
			desc: { es: "1m00 MEDIUM", ca: "1m00", en: "1m00", fr: "1m00" },
			dimensiones: "2m50x1030",
			poste: ["Ritmo 1,2mm"],
			modeloStr: "RITMO",
		},

		{
			_id: "5b222430ca1df794edff4435",
			order: 3,
			modelo: "5b153b74ca1df794edf728d3",
			desc: { es: "1m20", ca: "1m20", en: "1m20", fr: "1m20" },
			dimensiones: "2m50x1230",
			poste: ["Ritmo 1,2mm"],
			modeloStr: "RITMO",
		},

		{
			_id: "5b222430ca1df794edff4555",
			order: 3,
			modelo: "5b153b74ca1df794edf728d3",
			desc: {
				es: "1m20 MEDIUM",
				ca: "1m20 MEDIUM",
				en: "1m20 MEDIUM",
				fr: "1m20 MEDIUM",
			},
			dimensiones: "2m50x1230",
			poste: ["Ritmo 1,2mm"],
			modeloStr: "RITMO",
		},

		{
			_id: "5b222438ca1df794edff4433",
			order: 4,
			modelo: "5b153b74ca1df794edf728d3",
			desc: {
				es: "1m50 (1m43)",
				ca: "1m50 (1m43)",
				en: "1m50 (1m43)",
				fr: "1m50 (1m43)",
			},
			dimensiones: "2m50x1430",
			poste: ["Ritmo 1,2mm"],
			modeloStr: "RITMO",
		},

		{
			_id: "5b222438ca1df794edff443f",
			order: 5,
			modelo: "5b153b74ca1df794edf728d3",
			desc: {
				es: "1m50 (1m53)",
				ca: "1m50 (1m53)",
				en: "1m50 (1m53)",
				fr: "1m50 (1m53)",
			},
			dimensiones: "2m50x1530",
			poste: ["Ritmo 1,2mm"],
			modeloStr: "RITMO",
		},

		{
			_id: "5b222438ca1df794edff4555",
			order: 5,
			modelo: "5b153b74ca1df794edf728d3",
			desc: {
				es: "1m50 (1m53) MEDIUM",
				ca: "1m50 (1m53) MEDIUM",
				en: "1m50 (1m53) MEDIUM",
				fr: "1m50 (1m53) MEDIUM",
			},
			dimensiones: "2m50x1530",
			poste: ["Ritmo 1,2mm"],
			modeloStr: "RITMO",
		},

		{
			_id: "5b222444ca1df794edff4449",
			order: 6,
			modelo: "5b153b74ca1df794edf728d3",
			desc: { es: "1m80", ca: "1m80", en: "1m80", fr: "1m80" },
			dimensiones: "2m50x1730",
			poste: ["Ritmo 1,2mm"],
			modeloStr: "RITMO",
		},

		{
			_id: "5b222444ca1df794edff4666",
			order: 6,
			modelo: "5b153b74ca1df794edf728d3",
			desc: {
				es: "1m80 MEDIUM",
				ca: "1m80 MEDIUM",
				en: "1m80 MEDIUM",
				fr: "1m80 MEDIUM",
			},
			dimensiones: "2m50x1730",
			poste: ["Ritmo 1,2mm"],
			modeloStr: "RITMO",
		},

		{
			_id: "5b22244cca1df794edff4453",
			order: 7,
			modelo: "5b153b74ca1df794edf728d3",
			desc: {
				es: "2m00 (1m93)",
				ca: "2m00 (1m93)",
				en: "2m00 (1m93)",
				fr: "2m00 (1m93)",
			},
			dimensiones: "2m50x1930",
			poste: ["Ritmo 1,2mm"],
			modeloStr: "RITMO",
		},

		{
			_id: "5b22244cca1df794edff4477",
			order: 7,
			modelo: "5b153b74ca1df794edf728d3",
			desc: {
				es: "2m00 (1m93) MEDIUM",
				ca: "2m00 (1m93) MEDIUM",
				en: "2m00 (1m93) MEDIUM",
				fr: "2m00 (1m93) MEDIUM",
			},
			dimensiones: "2m50x2030",
			poste: ["Ritmo 1,2mm"],
			modeloStr: "RITMO",
		},

		{
			_id: "5b22244cca1df794edff4455",
			order: 8,
			modelo: "5b153b74ca1df794edf728d3",
			desc: {
				es: "2m00 (2m03)",
				ca: "2m00 (2m03)",
				en: "2m00 (2m03)",
				fr: "2m00 (2m03)",
			},
			dimensiones: "2m50x2030",
			poste: ["Ritmo 1,2mm"],
			modeloStr: "RITMO",
		},

		{
			_id: "5b222453ca1df794edff4459",
			order: 9,
			modelo: "5b153b74ca1df794edf728d3",
			desc: { es: "2m40", ca: "2m40", en: "2m40", fr: "2m40" },
			dimensiones: "2m50x2430",
			poste: ["Ritmo 1,2mm"],
			modeloStr: "RITMO",
		},
		{
			_id: "5b222718ca1df794edff46b0",
			order: 0,
			modelo: "5b153ba0ca1df794edf728f6",
			desc: { es: "1m00", ca: "1m00", en: "1m00", fr: "1m00" },
			dimensiones: "6/5/6",
			poste: ["Ritmo 1,2mm"],
			modeloStr: "RITMO DH",
		},
		{
			_id: "5b222721ca1df794edff46b8",
			order: 1,
			modelo: "5b153ba0ca1df794edf728f6",
			desc: { es: "1m20", ca: "1m20", en: "1m20", fr: "1m20" },
			dimensiones: "6/5/6",
			poste: ["Ritmo 1,2mm"],
			modeloStr: "RITMO DH",
		},
		{
			_id: "5b222729ca1df794edff46c0",
			order: 2,
			modelo: "5b153ba0ca1df794edf728f6",
			desc: { es: "1m40", ca: "1m40", en: "1m40", fr: "1m40" },
			dimensiones: "6/5/6",
			poste: "Ritmo 1,2mm",
			modeloStr: "RITMO DH",
		},
		{
			_id: "5b222732ca1df794edff46c7",
			order: 3,
			modelo: "5b153ba0ca1df794edf728f6",
			desc: { es: "1m60", ca: "1m60", en: "1m60", fr: "1m60" },
			dimensiones: "6/5/6",
			poste: ["Ritmo 1,2mm"],
			modeloStr: "RITMO DH",
		},
		{
			_id: "5b22273bca1df794edff46d1",
			order: 4,
			modelo: "5b153ba0ca1df794edf728f6",
			desc: { es: "1m80", ca: "1m80", en: "1m80", fr: "1m80" },
			dimensiones: "6/5/6",
			poste: ["Ritmo 1,2mm"],
			modeloStr: "RITMO DH",
		},
		{
			_id: "5b222744ca1df794edff46db",
			order: 5,
			modelo: "5b153ba0ca1df794edf728f6",
			desc: { es: "2m00", ca: "2m00", en: "2m00", fr: "2m00" },
			dimensiones: "6/5/6",
			poste: ["Ritmo 1,2mm"],
			modeloStr: "RITMO DH",
		},
		{
			_id: "5b222a38ca1df794edff4948",
			order: 0,
			modelo: "5b153bcbca1df794edf72915",
			desc: { es: "0m60", ca: "0m60", en: "0m60", fr: "0m60" },
			dimensiones: "2m50x630",
			poste: ["Ritmo Clip 1,2mm"],
			modeloStr: "RITMOCLIP",
		},
		{
			_id: "5b222a41ca1df794edff4951",
			order: 1,
			modelo: "5b153bcbca1df794edf72915",
			desc: { es: "1m00", ca: "1m00", en: "1m00", fr: "1m00" },
			dimensiones: "2m50x1030",
			poste: ["Ritmo Clip 1,2mm"],
			modeloStr: "RITMOCLIP",
		},
		{
			_id: "5b222a49ca1df794edff4958",
			order: 2,
			modelo: "5b153bcbca1df794edf72915",
			desc: { es: "1m20", ca: "1m20", en: "1m20", fr: "1m20" },
			dimensiones: "2m50x1230",
			poste: ["Ritmo Clip 1,2mm"],
			modeloStr: "RITMOCLIP",
		},
		{
			_id: "5b222a51ca1df794edff4961",
			order: 3,
			modelo: "5b153bcbca1df794edf72915",
			desc: { es: "1m50", ca: "1m50", en: "1m50", fr: "1m50" },
			dimensiones: "2m50x1430",
			poste: ["Ritmo Clip 1,2mm"],
			modeloStr: "RITMOCLIP",
		},
		{
			_id: "5b222a5aca1df794edff4968",
			order: 4,
			modelo: "5b153bcbca1df794edf72915",
			desc: { es: "1m80", ca: "1m80", en: "1m80", fr: "1m80" },
			dimensiones: "2m50x1730",
			poste: ["Ritmo Clip 1,2mm"],
			modeloStr: "RITMOCLIP",
		},
		{
			_id: "5b222a64ca1df794edff4975",
			order: 5,
			modelo: "5b153bcbca1df794edf72915",
			desc: { es: "2m00", ca: "2m00", en: "2m00", fr: "2m00" },
			dimensiones: "2m50x1930",
			poste: ["Ritmo Clip 1,2mm"],
			modeloStr: "RITMOCLIP",
		},
		{
			_id: "5b34ad17ca1df794ed0b44a1",
			order: 6,
			modelo: "5b153ae3ca1df794edf72868",
			desc: {
				es: "1m00 Ø alambres 8/6/8",
				ca: "1m00 Ø filferros 8/6/8",
				en: "1m00 Ø wires 8/6/8",
				fr: "1m00 Ø des fils 8/6/8",
			},
			dimensiones: "",
			poste: ["LUX 50mm"],
			modeloStr: "FAX DH",
		},
		{
			_id: "5b34af75ca1df794ed0b4735",
			order: 7,
			modelo: "5b153ae3ca1df794edf72868",
			desc: {
				es: "1m20 Ø alambres 8/6/8",
				ca: "1m20 Ø filferros 8/6/8",
				en: "1m20 Ø wires 8/6/8",
				fr: "1m20 Ø des fils 8/6/8",
			},
			dimensiones: "",
			poste: ["LUX 50mm"],
			modeloStr: "FAX DH",
		},
		{
			_id: "5b34afa5ca1df794ed0b4760",
			order: 8,
			modelo: "5b153ae3ca1df794edf72868",
			desc: {
				es: "1m40 Ø alambres 8/6/8",
				ca: "1m40 Ø filferros 8/6/8",
				en: "1m40 Ø wires 8/6/8",
				fr: "1m40 Ø des fils 8/6/8",
			},
			dimensiones: "",
			poste: ["LUX 80mm"],
			modeloStr: "FAX DH",
		},
		{
			_id: "5b34afcaca1df794ed0b479f",
			order: 9,
			modelo: "5b153ae3ca1df794edf72868",
			desc: {
				es: "1m60 Ø alambres 8/6/8",
				ca: "1m60 Ø filferros 8/6/8",
				en: "1m60 Ø wires 8/6/8",
				fr: "1m60 Ø des fils 8/6/8",
			},
			dimensiones: "",
			poste: ["LUX 80mm"],
			modeloStr: "FAX DH",
		},
		{
			_id: "5b34afefca1df794ed0b47da",
			order: 10,
			modelo: "5b153ae3ca1df794edf72868",
			desc: {
				es: "1m80 Ø alambres 8/6/8",
				ca: "1m80 Ø filferros 8/6/8",
				en: "1m80 Ø wires 8/6/8",
				fr: "1m80 Ø des fils 8/6/8",
			},
			dimensiones: "",
			poste: ["LUX 80mm"],
			modeloStr: "FAX DH",
		},
		{
			_id: "5b34b00cca1df794ed0b47fa",
			order: 11,
			modelo: "5b153ae3ca1df794edf72868",
			desc: {
				es: "2m00 Ø alambres 8/6/8",
				ca: "2m00 Ø filferros 8/6/8",
				en: "2m00 Ø wires 8/6/8",
				fr: "2m00 Ø des fils 8/6/8",
			},
			dimensiones: "",
			poste: ["LUX 80mm"],
			modeloStr: "FAX DH",
		},
		{
			_id: "5b47640fca1df794ed196492",
			order: 0,
			modelo: "5b476530ca1df794ed1965e6",
			desc: { es: "0m60", ca: "0m60", en: "0m60", fr: "0m60" },
			dimensiones: "2m75x0m689",
			poste: ["Classic Ø60x2"],
			modeloStr: "CLASSIC",
		},
		{
			_id: "5b47645aca1df794ed1964e8",
			order: 1,
			modelo: "5b476530ca1df794ed1965e6",
			desc: { es: "1m00", ca: "1m00", en: "1m00", fr: "1m00" },
			dimensiones: "2m75x0m989",
			poste: ["Classic Ø60x2"],
			modeloStr: "CLASSIC",
		},
		{
			_id: "5b47646bca1df794ed1964f8",
			order: 2,
			modelo: "5b476530ca1df794ed1965e6",
			desc: { es: "1m50", ca: "1m50", en: "1m50", fr: "1m50" },
			dimensiones: "2m75x1m489",
			poste: ["Classic Ø60x2"],
			modeloStr: "CLASSIC",
		},
		{
			_id: "5b476482ca1df794ed196518",
			order: 3,
			modelo: "5b476530ca1df794ed1965e6",
			desc: { es: "2m00", ca: "2m00", en: "2m00", fr: "2m00" },
			dimensiones: "2m75x1m889",
			poste: ["Classic Ø60x2"],
			modeloStr: "CLASSIC",
		},
		{
			_id: "5b4767e5ca1df794ed1968ee",
			order: 0,
			modelo: "5b4767beca1df794ed1968c7",
			desc: { es: "1m00", ca: "1m00", en: "1m00", fr: "1m00" },
			dimensiones: "2m75x0m989",
			poste: ["Calitax Ø60x2 Redondo", "Calitax 60x2 Cuadrado"],
			modeloStr: "CALITAX",
		},
		{
			_id: "62b55c60af08dcedc94ac105",
			order: 1,
			modelo: "5b4767beca1df794ed1968c7",
			desc: { es: "1m20", ca: "1m20", en: "1m20", fr: "1m20" },
			dimensiones: "2m75x1m189",
			poste: ["Calitax Ø60x2 Redondo", "Calitax 60x2 Cuadrado"],
			modeloStr: "CALITAX",
		},
		{
			_id: "5b476892ca1df794ed19699f",
			order: 2,
			modelo: "5b4767beca1df794ed1968c7",
			desc: { es: "1m50", ca: "1m50", en: "1m50", fr: "1m50" },
			dimensiones: "2m75x1m489",
			poste: ["Calitax Ø60x2 Redondo", "Calitax 60x2 Cuadrado"],
			modeloStr: "CALITAX",
		},
		{
			_id: "62b55cb7af08dcedc94ac106",
			order: 3,
			modelo: "5b4767beca1df794ed1968c7",
			desc: { es: "1m80", ca: "1m80", en: "1m80", fr: "1m80" },
			dimensiones: "2m75x1m789",
			poste: ["Calitax Ø60x2 Redondo", "Calitax 60x2 Cuadrado"],
			modeloStr: "CALITAX",
		},
		{
			_id: "5b476899ca1df794ed1969a6",
			order: 4,
			modelo: "5b4767beca1df794ed1968c7",
			desc: { es: "2m00", ca: "2m00", en: "2m00", fr: "2m00" },
			dimensiones: "2m75x1m989",
			poste: ["Calitax Ø60x3 Redondo", "Calitax 60x2 Cuadrado"],
			modeloStr: "CALITAX",
		},
		{
			_id: "5b4768dfca1df794ed1969f0",
			order: 0,
			modelo: "5b4768b1ca1df794ed1969c1",
			desc: { es: "0m60", ca: "0m60", en: "0m60", fr: "0m60" },
			dimensiones: "2m48x0m689",
			poste: ["Nové Ø60x2 Redondo", "Nové 60x2 Cuadrado"],
			modeloStr: "NOVE",
		},
		{
			_id: "5b4768e9ca1df794ed196a00",
			order: 1,
			modelo: "5b4768b1ca1df794ed1969c1",
			desc: { es: "1m00", ca: "1m00", en: "1m00", fr: "1m00" },
			dimensiones: "2m48x0m989",
			poste: ["Nové Ø60x2 Redondo", "Nové 60x2 Cuadrado"],
			modeloStr: "NOVE",
		},

		{
			_id: "62b574e4af08dcedc94ac11c",
			order: 2,
			modelo: "5b4768b1ca1df794ed1969c1",
			desc: { es: "1m20", ca: "1m20", en: "1m20", fr: "1m20" },
			dimensiones: "2m48x1m200",
			poste: ["Nové Ø60x2 Redondo", "Nové 60x2 Cuadrado"],
			modeloStr: "NOVE",
		},

		{
			_id: "5b4768f1ca1df794ed196a0b",
			order: 3,
			modelo: "5b4768b1ca1df794ed1969c1",
			desc: { es: "1m50", ca: "1m50", en: "1m50", fr: "1m50" },
			dimensiones: "2m48x1m500",
			poste: ["Nové Ø60x2 Redondo", "Nové 60x2 Cuadrado"],
			modeloStr: "NOVE",
		},

		{
			_id: "5b476946ca1df794ed196a64",
			order: 0,
			modelo: "5b476914ca1df794ed196a28",
			desc: { es: "1m00", ca: "1m00", en: "1m00", fr: "1m00" },
			dimensiones: "2m75x1m00",
			poste: ["Ultra Ø60x2 Redondo", "Ultra 60x2 Cuadrado"],
			modeloStr: "ULTRA",
			topEdgeCut: 0,
		},

		{
			_id: "62b56804af08dcedc94ac112",
			order: 1,
			modelo: "5b476914ca1df794ed196a28",
			desc: { es: "1m20", ca: "1m20", en: "1m20", fr: "1m20" },
			dimensiones: "2m75x1m20",
			poste: ["Ultra Ø60x2 Redondo", "Ultra 60x2 Cuadrado"],
			modeloStr: "ULTRA",
			topEdgeCut: 0,
		},

		{
			_id: "5b47694eca1df794ed196a6c",
			order: 2,
			modelo: "5b476914ca1df794ed196a28",
			desc: { es: "1m50", ca: "1m50", en: "1m50", fr: "1m50" },
			dimensiones: "2m75x1m50",
			poste: ["Ultra Ø60x2 Redondo", "Ultra 60x2 Cuadrado"],
			modeloStr: "ULTRA",
			topEdgeCut: 0,
		},

		{
			_id: "62b5688baf08dcedc94ac113",
			order: 3,
			modelo: "5b476914ca1df794ed196a28",
			desc: { es: "1m80", ca: "1m80", en: "1m80", fr: "1m80" },
			dimensiones: "2m75x1m80",
			poste: ["Ultra Ø60x2 Redondo", "Ultra 60x2 Cuadrado"],
			modeloStr: "ULTRA",
			topEdgeCut: 0,
		},
		{
			_id: "5b476956ca1df794ed196a76",
			order: 4,
			modelo: "5b476914ca1df794ed196a28",
			desc: { es: "2m00", ca: "2m00", en: "2m00", fr: "2m00" },
			dimensiones: "2m75x2m00",
			poste: ["Ultra Ø60x3 Redondo", "Ultra 60x2 Cuadrado"],
			modeloStr: "ULTRA",
			topEdgeCut: 0,
		},
		{
			_id: "5b4769bcca1df794ed196ae2",
			order: 0,
			modelo: "5b476991ca1df794ed196ab3",
			desc: { es: "0m60", ca: "0m60", en: "0m60", fr: "0m60" },
			dimensiones: "2m75x0m60",
			poste: ["Decor Ø60x2 Redondo", "Decor 60x2 Cuadrado"],
			modeloStr: "DECOR",
		},
		{
			_id: "5b4769c7ca1df794ed196aed",
			order: 1,
			modelo: "5b476991ca1df794ed196ab3",
			desc: { es: "1m00", ca: "1m00", en: "1m00", fr: "1m00" },
			dimensiones: "2m75x1m00",
			poste: ["Decor Ø60x2 Redondo", "Decor 60x2 Cuadrado"],
			modeloStr: "DECOR",
		},
		{
			_id: "5b4769ceca1df794ed196af6",
			order: 2,
			modelo: "5b476991ca1df794ed196ab3",
			desc: { es: "1m50", ca: "1m50", en: "1m50", fr: "1m50" },
			dimensiones: "2m75x1m50",
			poste: ["Decor Ø60x2 Redondo", "Decor 60x2 Cuadrado"],
			modeloStr: "DECOR",
		},
		{
			_id: "5b4769d5ca1df794ed196b02",
			order: 3,
			modelo: "5b476991ca1df794ed196ab3",
			desc: { es: "2m00", ca: "2m00", en: "2m00", fr: "2m00" },
			dimensiones: "2m75x2m00",
			poste: ["Decor Ø60x3 Redondo", "Decor 60x2 Cuadrado"],
			modeloStr: "DECOR",
		},
		{
			_id: "5b4766d3ca1df794ed1967b5",
			order: 0,
			modelo: "5b47663eca1df794ed19671a",
			desc: { es: "1m00", ca: "1m00", en: "1m00", fr: "1m00" },
			dimensiones: "2m48x1m00",
			poste: ["Nature Ø60x2 Redondo", "Nature 60x2 Cuadrado"],
			modeloStr: "NATURE",
		},
		{
			_id: "5bf7c292ca1df794ed8930eb",
			order: 1,
			modelo: "5b47663eca1df794ed19671a",
			desc: { es: "1m20", ca: "1m20", en: "1m20", fr: "1m20" },
			dimensiones: "2m48x1m20",
			poste: ["Nature Ø60x2 Redondo", "Nature 60x2 Cuadrado"],
			modeloStr: "NATURE",
		},
		{
			_id: "5b4766dfca1df794ed1967c2",
			order: 2,
			modelo: "5b47663eca1df794ed19671a",
			desc: { es: "1m50", ca: "1m50", en: "1m50", fr: "1m50" },
			dimensiones: "2m48x1m50",
			poste: ["Nature Ø60x2 Redondo", "Nature 60x2 Cuadrado"],
			modeloStr: "NATURE",
		},
		{
			_id: "5bf7c2cbca1df794ed89311a",
			order: 3,
			modelo: "5b47663eca1df794ed19671a",
			desc: { es: "1m80", ca: "1m80", en: "1m80", fr: "1m80" },
			dimensiones: "2m48x1m80",
			poste: ["Nature Ø60x3 Redondo", "Nature 60x2 Cuadrado"],
			modeloStr: "NATURE",
		},
		{
			_id: "5b4766eeca1df794ed1967d3",
			order: 4,
			modelo: "5b47663eca1df794ed19671a",
			desc: { es: "2m00", ca: "2m00", en: "2m00", fr: "2m00" },
			dimensiones: "2m48x2m00",
			poste: ["Nature Ø60x3 Redondo", "Nature 60x2 Cuadrado"],
			modeloStr: "NATURE",
		},
		{
			_id: "5bf7c3abca1df794ed8931d3",
			order: 5,
			modelo: "5b47663eca1df794ed19671a",
			desc: { es: "2m40", ca: "2m40", en: "2m40", fr: "2m40" },
			dimensiones: "2m48x2m40",
			poste: ["Nature Ø60x3 Redondo", "Nature 60x2 Cuadrado"],
			modeloStr: "NATURE",
		},
	];

	public readonly tiposCercados = [
		{
			_id: "593a8596b040e6170cb9ae2c",
			order: 0,
			modelo: "593a6ae4b040e6170cb9ab50",
			desc: {
				es: "40/14 Galvanizado",
				ca: "40/14 Galvanitzat",
				en: "40/14 Galvanized",
				fr: "40/14 Galvanisé",
			},
			factConvAlambre: "0.045",
			rolloAlambre: 25,
			idAlambreRivisa: "ALA0005",
			factConvAlambreUnion: "0.0007",
			rolloAlambreUnion: 5,
			idAlambreUnion: "ALA0004",
			modeloStr: "LUX_EST",
		},
		{
			_id: "5989d8625394623757429436",
			order: 1,
			modelo: "593a6ae4b040e6170cb9ab50",
			desc: {
				es: "50/14 Galvanizado",
				ca: "50/14 Galvanitzat",
				en: "50/14 Galvanized",
				fr: "50/14 Galvanisé",
			},
			factConvAlambre: "0.045",
			rolloAlambre: 25,
			idAlambreRivisa: "ALA0005",
			factConvAlambreUnion: "0.0007",
			rolloAlambreUnion: 5,
			idAlambreUnion: "ALA0004",
			modeloStr: "LUX_EST",
		},
		{
			_id: "593a8596b040e6170cb9ae2e",
			order: 2,
			modelo: "593a6ae4b040e6170cb9ab50",
			desc: {
				es: "50/16 Galvanizado",
				ca: "50/16 Galvanitzat",
				en: "50/16 Galvanized",
				fr: "50/16 Galvanisé",
			},
			factConvAlambre: "0.045",
			rolloAlambre: 25,
			idAlambreRivisa: "ALA0005",
			factConvAlambreUnion: "0.0007",
			rolloAlambreUnion: 5,
			idAlambreUnion: "ALA0004",
			modeloStr: "LUX_EST",
		},
		{
			_id: "593a8596b040e6170cb9ae30",
			order: 3,
			modelo: "593a6ae4b040e6170cb9ab50",
			desc: {
				es: "40/17 Plastificado verde",
				ca: "40/17 Plastificat verd",
				en: "40/17 Green plasticized",
				fr: "40/17 Vert plastifiée",
			},
			factConvAlambre: "0.05",
			rolloAlambre: 25,
			idAlambreRivisa: "ALA0002",
			factConvAlambreUnion: "0.0007",
			rolloAlambreUnion: 5,
			idAlambreUnion: "ALA0007",
			modeloStr: "LUX_EST",
		},
		{
			_id: "593a8596b040e6170cb9ae32",
			order: 4,
			modelo: "593a6ae4b040e6170cb9ab50",
			desc: {
				es: "50/17 Plastificado verde",
				ca: "50/17 Plastificat verd",
				en: "50/17 Green plasticized",
				fr: "50/17 Vert plastifiée",
			},
			factConvAlambre: "0.05",
			rolloAlambre: 25,
			idAlambreRivisa: "ALA0002",
			factConvAlambreUnion: "0.0007",
			rolloAlambreUnion: 5,
			idAlambreUnion: "ALA0007",
			modeloStr: "LUX_EST",
		},
		{
			_id: "5989e0f25394623757429599",
			order: 5,
			modelo: "593a6ae4b040e6170cb9ab50",
			desc: {
				es: "50/19 Plastificado verde",
				ca: "50/19 Plastificat verd",
				en: "50/19 Green plasticized",
				fr: "50/19 Vert plastifiée",
			},
			factConvAlambre: "0.05",
			rolloAlambre: 25,
			idAlambreRivisa: "ALA0002",
			factConvAlambreUnion: "0.0007",
			rolloAlambreUnion: 5,
			idAlambreUnion: "ALA0007",
			modeloStr: "LUX_EST",
		},
		{
			_id: "5989e0f2539462375742959b",
			order: 6,
			modelo: "593a6ae4b040e6170cb9ab50",
			desc: {
				es: "50/20 Plastificado verde",
				ca: "50/20 Plastificat verd",
				en: "50/20 Green plasticized",
				fr: "50/20 Vert plastifiée",
			},
			factConvAlambre: "0.05",
			rolloAlambre: 25,
			idAlambreRivisa: "ALA0002",
			factConvAlambreUnion: "0.0007",
			rolloAlambreUnion: 5,
			idAlambreUnion: "ALA0007",
			modeloStr: "LUX_EST",
		},
		{
			_id: "593a8596b040e6170cb9ae34",
			order: 1,
			modelo: "593a6ae4b040e6170cb9ab52",
			desc: {
				es: "M.E.P. 100x50",
				ca: "M.E.P. 100x50",
				en: "M.E.P. 100x50",
				fr: "M.E.P. 100x50",
			},
			modeloStr: "LUX_ELECTRO",
		},
		{
			_id: "5b3107ceca1df794ed08f30b",
			order: 0,
			modelo: "593a6ae4b040e6170cb9ab52",
			desc: {
				es: "M.E.P. 50x50",
				ca: "M.E.P. 50x50",
				en: "M.E.P. 50x50",
				fr: "M.E.P. 50x50",
			},
			modeloStr: "LUX_ELECTRO",
		},
		{
			_id: "593a8596b040e6170cb9ae38",
			order: 0,
			modelo: "593a6ae4b040e6170cb9ab54",
			desc: {
				es: "100-08-15",
				ca: "100-08-15",
				en: "100-08-15",
				fr: "100-08-15",
			},
			modeloStr: "LUX_ANUDADA",
		},
		{
			_id: "593a8596b040e6170cb9ae3a",
			order: 1,
			modelo: "593a6ae4b040e6170cb9ab54",
			desc: {
				es: "100-08-30",
				ca: "100-08-30",
				en: "100-08-30",
				fr: "100-08-30",
			},
			modeloStr: "LUX_ANUDADA",
		},
		{
			_id: "593a8596b040e6170cb9ae3c",
			order: 2,
			modelo: "593a6ae4b040e6170cb9ab54",
			desc: {
				es: "148-18-15",
				ca: "148-18-15",
				en: "148-18-15",
				fr: "148-18-15",
			},
			modeloStr: "LUX_ANUDADA",
		},
		{
			_id: "593a8596b040e6170cb9ae3e",
			order: 3,
			modelo: "593a6ae4b040e6170cb9ab54",
			desc: {
				es: "148-18-30",
				ca: "148-18-30",
				en: "148-18-30",
				fr: "148-18-30",
			},
			modeloStr: "LUX_ANUDADA",
		},
		{
			_id: "593a8596b040e6170cb9ae40",
			order: 4,
			modelo: "593a6ae4b040e6170cb9ab54",
			desc: {
				es: "200-20-15",
				ca: "200-20-15",
				en: "200-20-15",
				fr: "200-20-15",
			},
			modeloStr: "LUX_ANUDADA",
		},
		{
			_id: "593a8596b040e6170cb9ae42",
			order: 5,
			modelo: "593a6ae4b040e6170cb9ab54",
			desc: {
				es: "200-20-30",
				ca: "200-20-30",
				en: "200-20-30",
				fr: "200-20-30",
			},
			modeloStr: "LUX_ANUDADA",
		},
	];

	public readonly bayonetas = [
		{
			_id: "594cff4d85e50bd508b4b363",
			idRivisa: "BAY0022",
			color: ["595bb930060cda18c1334ed0"],
			colorStr: "Galvanizado",
			anchuraPoste: "LUX50",
			desc: { es: "", ca: "", en: "", fr: "" },
			altura: "0m300",
			paneles: [
				"59366ad4b040e6170cb97934",
				"5989d96d539462375742947a",
				"59366ad4b040e6170cb9793c",
			],
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			espino: { idRivisa: "ESP000101", metros: 250 },
		},
		{
			_id: "6231ddcfc631a51514e61527",
			idRivisa: "BAY0024",
			color: ["5b16acd5ca1df794edf82198"],
			colorStr: "Antracita",
			anchuraPoste: "LUX50",
			desc: { es: "", ca: "", en: "", fr: "" },
			altura: "0m300",
			paneles: [],
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			espino: { idRivisa: "ESP000101", metros: 250 },
		},
		{
			_id: "598b28335394623757429d0f",
			idRivisa: "BAY0005",
			color: ["595bb930060cda18c1334ed0"],
			colorStr: "Galvanizado",
			anchuraPoste: "LUX80",
			desc: { es: "", ca: "", en: "", fr: "" },
			altura: "0m300",
			paneles: [
				"59366ad4b040e6170cb97934",
				"5989d96d539462375742947a",
				"59366ad4b040e6170cb9793c",
			],
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			espino: { idRivisa: "ESP000101", metros: 250 },
		},
		{
			_id: "598b28335394623757429d14",
			idRivisa: "BAY0020",
			color: ["595bb930060cda18c1334ed2"],
			colorStr: "Verde",
			anchuraPoste: "LUX50",
			desc: { es: "", ca: "", en: "", fr: "" },
			altura: "0m300",
			paneles: [
				"59366ad4b040e6170cb97944",
				"59366ad4b040e6170cb9794c",
				"5989e27453946237574295ef",
				"5989e27453946237574295f7",
			],
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			espino: { idRivisa: "ESP0003", metros: 200 },
		},
		//# ESPRIVISA-42: Código suplemento de Bayoneta en Batientes Ligeras
		{
			_id: "5a314fa5514ced9b5d583489",
			idRivisa: "SUP0013",
			color: ["595bb930060cda18c1334ed2"],
			colorStr: "Verde",
			modeloPuerta: ["5942708e85e50bd508b492fa"],
			hojas: "1",
			desc: {
				es: " SUPLEMENTO BAYONETA Pta. Ligera 1H. Plast. Verde",
				ca: "CA: SUPLEMENTO BAYONETA Pta. Ligera 1H. Plast. Verde",
				en: "EN: SUPLEMENTO BAYONETA Pta. Ligera 1H. Plast. Verde",
				fr: "FR: SUPLEMENTO BAYONETA Pta. Ligera 1H. Plast. Verde",
			},
			altura: "0m300",
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			paneles: [],
		},
		{
			_id: "5a314fa5514ced9b5d58348b",
			idRivisa: "SUP0014",
			color: ["595bb930060cda18c1334ed2"],
			colorStr: "Verde",
			modeloPuerta: ["5942708e85e50bd508b492fa"],
			hojas: "2",
			desc: {
				es: " SUPLEMENTO BAYONETA Pta. Ligera 2H. Plast. Verde",
				ca: "CA: SPLEMENTO BAYONETA Pta. Ligera 2H. Plast. Verde",
				en: "EN: SUPLEMENTO BAYONETA Pta. Ligera 2H. Plast. Verde",
				fr: "FR: SUPLEMENTO BAYONETA Pta. Ligera 2H. Plast. Verde",
			},
			altura: "0m300",
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			paneles: [],
		},
		{
			_id: "5a314fa5514ced9b5d58348d",
			idRivisa: "SUP0017",
			color: ["595bb930060cda18c1334ed0"],
			colorStr: "Galvanizado",
			modeloPuerta: ["5942708e85e50bd508b492fa"],
			hojas: "1",
			desc: {
				es: " SUPLEMENTO BAYONETA Pta. Ligera 1H. Galvanizado",
				ca: "CA: SUPLEMENTO BAYONETA Pta. Ligera 1H. Galvanizado",
				en: "EN: SUPLEMENTO BAYONETA Pta. Ligera 1H. Galvanizado",
				fr: "FR: SUPLEMENTO BAYONETA Pta. Ligera 1H. Galvanizado",
			},
			altura: "0m300",
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			paneles: [],
		},
		{
			_id: "5a314fa5514ced9b5d58348f",
			idRivisa: "SUP0018",
			color: ["595bb930060cda18c1334ed0"],
			colorStr: "Galvanizado",
			modeloPuerta: ["5942708e85e50bd508b492fa"],
			hojas: "2",
			desc: {
				es: " SUPLEMENTO BAYONETA Pta. Ligera 1H. Galvanizado",
				ca: "CA: SUPLEMENTO BAYONETA Pta. Ligera 1H. Galvanizado",
				en: "EN: SUPLEMENTO BAYONETA Pta. Ligera 1H. Galvanizado",
				fr: "FR: SUPLEMENTO BAYONETA Pta. Ligera 1H. Galvanizado",
			},
			altura: "0m300",
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			paneles: [],
		},
		{
			_id: "62262ee35343a30ff0174c34",
			idRivisa: "SUP0015",
			color: ["5b16ab91ca1df794edf82088"],
			colorStr: "Blanco",
			modeloPuerta: ["5942708e85e50bd508b492fa"],
			hojas: "1",
			desc: {
				es: " SUPLEMENTO BAYONETA Pta. Ligera 1H. Blanco",
				ca: "CA: SUPLEMENTO BAYONETA Pta. Ligera 1H. Plast. Blanco",
				en: "EN: SUPLEMENTO BAYONETA Pta. Ligera 1H. Plast. Blanco",
				fr: "FR: SUPLEMENTO BAYONETA Pta. Ligera 1H. Plast. Blanco",
			},
			altura: "0m300",
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			paneles: [],
		},
		{
			_id: "62262ef45343a30ff0174c35",
			idRivisa: "SUP0016",
			color: ["5b16ab91ca1df794edf82088"],
			colorStr: "Blanco",
			modeloPuerta: ["5942708e85e50bd508b492fa"],
			hojas: "2",
			desc: {
				es: " SUPLEMENTO BAYONETA Pta. Ligera 2H. Blanco",
				ca: "CA: SUPLEMENTO BAYONETA Pta. Ligera 2H. Plast. Blanco",
				en: "EN: SUPLEMENTO BAYONETA Pta. Ligera 2H. Plast. Blanco",
				fr: "FR: SUPLEMENTO BAYONETA Pta. Ligera 2H. Plast. Blanco",
			},
			altura: "0m300",
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			paneles: [],
		},
		{
			_id: "62262ebb5343a30ff0174c32",
			idRivisa: "SUP0023",
			color: ["5b16acd5ca1df794edf82198"],
			colorStr: "Antracita",
			modeloPuerta: ["5942708e85e50bd508b492fa"],
			hojas: "1",
			desc: {
				es: " SUPLEMENTO BAYONETA Pta. Ligera 1H. Antracita",
				ca: "CA: SUPLEMENTO BAYONETA Pta. Ligera 1H. Antracita",
				en: "EN: SUPLEMENTO BAYONETA Pta. Ligera 1H. Antracita",
				fr: "FR: SUPLEMENTO BAYONETA Pta. Ligera 1H. Antracita",
			},
			altura: "0m300",
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			paneles: [],
		},
		{
			_id: "62262ecc5343a30ff0174c33",
			idRivisa: "SUP0024",
			color: ["5b16acd5ca1df794edf82198"],
			colorStr: "Antracita",
			modeloPuerta: ["5942708e85e50bd508b492fa"],
			hojas: "2",
			desc: {
				es: " SUPLEMENTO BAYONETA Pta. Ligera 2H. Antracita",
				ca: "CA: SUPLEMENTO BAYONETA Pta. Ligera 2H. Antracita",
				en: "EN: SUPLEMENTO BAYONETA Pta. Ligera 2H. Antracita",
				fr: "FR: SUPLEMENTO BAYONETA Pta. Ligera 2H. Antracita",
			},
			altura: "0m300",
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			paneles: [],
		},
		{
			_id: "62262e9f5343a30ff0174c30",
			idRivisa: "SUP0019",
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			colorStr: "RAL",
			modeloPuerta: ["5942708e85e50bd508b492fa"],
			hojas: "1",
			desc: {
				es: " SUPLEMENTO BAYONETA Pta. Ligera 1H. RAL",
				ca: "CA: SUPLEMENTO BAYONETA Pta. Ligera 1H. RAL",
				en: "EN: SUPLEMENTO BAYONETA Pta. Ligera 1H. RAL",
				fr: "FR: SUPLEMENTO BAYONETA Pta. Ligera 1H. RAL",
			},
			altura: "0m300",
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			paneles: [],
		},
		{
			_id: "62262ead5343a30ff0174c31",
			idRivisa: "SUP0020",
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			colorStr: "RAL",
			modeloPuerta: ["5942708e85e50bd508b492fa"],
			hojas: "1",
			desc: {
				es: " SUPLEMENTO BAYONETA Pta. Ligera 2H. RAL",
				ca: "CA: SUPLEMENTO BAYONETA Pta. Ligera 2H. RAL",
				en: "EN: SUPLEMENTO BAYONETA Pta. Ligera 2H. RAL",
				fr: "FR: SUPLEMENTO BAYONETA P ta. Ligera 2H. RAL",
			},
			altura: "0m300",
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			paneles: [],
		},
		//# ESPRIVISA Batientes Fuertes código de Bayonetas
		{
			_id: "622a1c18eaae96025cae4f8e",
			idRivisa: "SUP0005",
			color: ["595bb930060cda18c1334ed2"],
			colorStr: "Verde",
			modeloPuerta: ["5b4da6f5ca1df794ed1d9a89"],
			hojas: "1",
			desc: {
				es: " SUPLEMENTO BAYONETA Pta. Fuerte 1H. Plast. Verde",
				ca: "CA: SUPLEMENTO BAYONETA Pta. Fuerte 1H. Plast. Verde",
				en: "EN: SUPLEMENTO BAYONETA Pta. Fuerte 1H. Plast. Verde",
				fr: "FR: SUPLEMENTO BAYONETA Pta. Fuerte 1H. Plast. Verde",
			},
			altura: "0m300",
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			paneles: [],
		},
		{
			_id: "622a1d34eaae96025cae4f8f",
			idRivisa: "SUP0006",
			color: ["595bb930060cda18c1334ed2"],
			colorStr: "Verde",
			modeloPuerta: ["5b4da6f5ca1df794ed1d9a89"],
			hojas: "2",
			desc: {
				es: " SUPLEMENTO BAYONETA Pta. Fuerte 2H. Plast. Verde",
				ca: "CA: SPLEMENTO BAYONETA Pta. Fuerte 2H. Plast. Verde",
				en: "EN: SUPLEMENTO BAYONETA Pta. Fuerte 2H. Plast. Verde",
				fr: "FR: SUPLEMENTO BAYONETA Pta. Fuerte 2H. Plast. Verde",
			},
			altura: "0m300",
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			paneles: [],
		},
		{
			_id: "622a1e2deaae96025cae4f90",
			idRivisa: "SUP0007",
			color: ["5b16ab91ca1df794edf82088"],
			colorStr: "Blanco",
			modeloPuerta: ["5b4da6f5ca1df794ed1d9a89"],
			hojas: "1",
			desc: {
				es: " SUPLEMENTO BAYONETA Pta. Fuerte 1H. Blanco",
				ca: "CA: SUPLEMENTO BAYONETA Pta. Fuerte 1H. Plast. Blanco",
				en: "EN: SUPLEMENTO BAYONETA Pta. Fuerte 1H. Plast. Blanco",
				fr: "FR: SUPLEMENTO BAYONETA Pta. Fuerte 1H. Plast. Blanco",
			},
			altura: "0m300",
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			paneles: [],
		},
		{
			_id: "622a2245eaae96025cae4f92",
			idRivisa: "SUP0008",
			color: ["5b16ab91ca1df794edf82088"],
			colorStr: "Blanco",
			modeloPuerta: ["5b4da6f5ca1df794ed1d9a89"],
			hojas: "2",
			desc: {
				es: " SUPLEMENTO BAYONETA Pta. Fuerte 2H. Blanco",
				ca: "CA: SUPLEMENTO BAYONETA Pta. Fuerte 2H. Plast. Blanco",
				en: "EN: SUPLEMENTO BAYONETA Pta. Fuerte 2H. Plast. Blanco",
				fr: "FR: SUPLEMENTO BAYONETA Pta. Fuerte 2H. Plast. Blanco",
			},
			altura: "0m300",
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			paneles: [],
		},
		{
			_id: "622a23a3eaae96025cae4f93",
			idRivisa: "SUP0009",
			color: ["595bb930060cda18c1334ed0"],
			colorStr: "Galvanizado",
			modeloPuerta: ["5b4da6f5ca1df794ed1d9a89"],
			hojas: "1",
			desc: {
				es: " SUPLEMENTO BAYONETA Pta. Fuerte 1H. Galvanizado",
				ca: "CA: SUPLEMENTO BAYONETA Pta. Fuerte 1H. Galvanizado",
				en: "EN: SUPLEMENTO BAYONETA Pta. Fuerte 1H. Galvanizado",
				fr: "FR: SUPLEMENTO BAYONETA Pta. Fuerte 1H. Galvanizado",
			},
			altura: "0m300",
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			paneles: [],
		},
		{
			_id: "622a254ceaae96025cae4f94",
			idRivisa: "SUP0010",
			color: ["595bb930060cda18c1334ed0"],
			colorStr: "Galvanizado",
			modeloPuerta: ["5b4da6f5ca1df794ed1d9a89"],
			hojas: "2",
			desc: {
				es: " SUPLEMENTO BAYONETA Pta. Fuerte 2H. Galvanizado",
				ca: "CA: SUPLEMENTO BAYONETA Pta. Fuerte 2H. Galvanizado",
				en: "EN: SUPLEMENTO BAYONETA Pta. Fuerte 2H. Galvanizado",
				fr: "FR: SUPLEMENTO BAYONETA Pta. Fuerte 2H. Galvanizado",
			},
			altura: "0m300",
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			paneles: [],
		},
		{
			_id: "6229cc2deaae96025cae4f8a",
			idRivisa: "SUP0011",
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			colorStr: "RAL",
			modeloPuerta: ["5b4da6f5ca1df794ed1d9a89"],
			hojas: "1",
			desc: {
				es: " SUPLEMENTO BAYONETA Pta. Fuerte 1H. RAL",
				ca: "CA: SUPLEMENTO BAYONETA Pta. Fuerte 1H. RAL",
				en: "EN: SUPLEMENTO BAYONETA Pta. Fuerte 1H. RAL",
				fr: "FR: SUPLEMENTO BAYONETA Pta. Fuerte 1H. RAL",
			},
			altura: "0m300",
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			paneles: [],
		},
		{
			_id: "6229cc41eaae96025cae4f8b",
			idRivisa: "SUP0012",
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			colorStr: "RAL",
			modeloPuerta: ["5b4da6f5ca1df794ed1d9a89"],
			hojas: "1",
			desc: {
				es: " SUPLEMENTO BAYONETA Pta. Fuerte 2H. RAL",
				ca: "CA: SUPLEMENTO BAYONETA Pta. Fuerte 2H. RAL",
				en: "EN: SUPLEMENTO BAYONETA Pta. Fuerte 2H. RAL",
				fr: "FR: SUPLEMENTO BAYONETA Pta. Fuerte 2H. RAL",
			},
			altura: "0m300",
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			paneles: [],
		},
		{
			_id: "6229cc67eaae96025cae4f8c",
			idRivisa: "SUP0021",
			color: ["5b16acd5ca1df794edf82198"],
			colorStr: "Antracita",
			modeloPuerta: ["5b4da6f5ca1df794ed1d9a89"],
			hojas: "1",
			desc: {
				es: " SUPLEMENTO BAYONETA Pta. Fuerte 1H. Antracita",
				ca: "CA: SUPLEMENTO BAYONETA Pta. Fuerte 1H. Antracita",
				en: "EN: SUPLEMENTO BAYONETA Pta. Fuerte 1H. Antracita",
				fr: "FR: SUPLEMENTO BAYONETA Pta. Fuerte 1H. Antracita",
			},
			altura: "0m300",
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			paneles: [],
		},
		{
			_id: "6229cc72eaae96025cae4f8d",
			idRivisa: "SUP0022",
			color: ["5b16acd5ca1df794edf82198"],
			colorStr: "Antracita",
			modeloPuerta: ["5942708e85e50bd508b492fa"],
			hojas: "2",
			desc: {
				es: " SUPLEMENTO BAYONETA Pta. Fuerte 2H. Antracita",
				ca: "CA: SUPLEMENTO BAYONETA Pta. Fuerte 2H. Antracita",
				en: "EN: SUPLEMENTO BAYONETA Pta. Fuerte 2H. Antracita",
				fr: "FR: SUPLEMENTO BAYONETA Pta. Fuerte 2H. Antracita",
			},
			altura: "0m300",
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			paneles: [],
		},

		{
			_id: "5b447b01ca1df794ed16d96a",
			idRivisa: "BAY0023",
			colorStr: "RAL",
			anchuraPoste: "LUX50",
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			desc: { es: "", ca: "", en: "", fr: "" },
			altura: "0m300",
			paneles: [],
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			espino: { idRivisa: "ESP000101", metros: 250 },
		},
		{
			_id: "5b447c00ca1df794ed16da7c",
			idRivisa: "BAY0003",
			color: ["5b16ab91ca1df794edf82088"],
			colorStr: "Blanco",
			anchuraPoste: "LUX80",
			desc: { es: "", ca: "", en: "", fr: "" },
			altura: "0m300",
			paneles: [
				"5b1e674dca1df794edfce348",
				"5b1e6a62ca1df794edfce5a0",
				"5b1e6d65ca1df794edfce807",
				"5b1e6d42ca1df794edfce7ea",
				"5b1e6c79ca1df794edfce73c",
				"5b1e6c4cca1df794edfce719",
				"5b1e6fd4ca1df794edfcea04",
				"5b1e6fadca1df794edfce9e4",
			],
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			espino: { idRivisa: "ESP000101", metros: 250 },
		},
		{
			_id: "5b447c6cca1df794ed16dae9",
			idRivisa: "BAY0001",
			color: ["595bb930060cda18c1334ed2"],
			colorStr: "Verde",
			anchuraPoste: "LUX80",
			desc: { es: "", ca: "", en: "", fr: "" },
			altura: "0m300",
			paneles: [
				"59366ad4b040e6170cb97944",
				"59366ad4b040e6170cb9794c",
				"5989e27453946237574295ef",
				"5989e27453946237574295f7",
				"5b1e677bca1df794edfce36b",
				"5b1e6d4cca1df794edfce7f2",
				"5b1e6d6eca1df794edfce810",
				"5b1e6c57ca1df794edfce723",
				"5b1e6c83ca1df794edfce749",
				"5b1e6fb7ca1df794edfce9ee",
				"5b1e6fe5ca1df794edfcea10",
			],
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			espino: { idRivisa: "ESP0003", metros: 200 },
		},
		{
			_id: "5b447ce0ca1df794ed16db5a",
			idRivisa: "BAY0007",
			colorStr: "RAL",
			anchuraPoste: "LUX80",
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			desc: { es: "", ca: "", en: "", fr: "" },
			altura: "0m300",
			paneles: [
				"5b1e6a7bca1df794edfce5b4",
				"5b1e678eca1df794edfce37a",
				"5b1e6d78ca1df794edfce819",
				"5b1e6d58ca1df794edfce7fb",
				"5b1e6c8eca1df794edfce752",
				"5b1e6c62ca1df794edfce72b",
				"5b1e6fefca1df794edfcea1b",
				"5b1e6fc2ca1df794edfce9f8",
			],
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			espino: { idRivisa: "ESP000101", metros: 250 },
		},
		{
			_id: "5b447d5eca1df794ed16dbd6",
			idRivisa: "BAY0057",
			color: ["5b16ab91ca1df794edf82088"],
			colorStr: "Blanco",
			anchuraPoste: "",
			desc: { es: "", ca: "", en: "", fr: "" },
			altura: "0m300",
			paneles: [
				"5b20f7cbca1df794edfe81b4",
				"5b20f787ca1df794edfe8182",
				"5b20f7f5ca1df794edfe81d5",
				"5b20fb49ca1df794edfe8462",
				"5b20f9e1ca1df794edfe8349",
				"5b20fd29ca1df794edfe85de",
				"5b20fb87ca1df794edfe848f",
			],
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			espino: { idRivisa: "ESP000101", metros: 250 },
		},
		{
			_id: "5b447dc8ca1df794ed16dc3f",
			idRivisa: "BAY0056",
			color: ["595bb930060cda18c1334ed2"],
			colorStr: "Verde",
			anchuraPoste: "",
			desc: { es: "", ca: "", en: "", fr: "" },
			altura: "0m300",
			paneles: [
				"5b20f7d8ca1df794edfe81bd",
				"5b20f79aca1df794edfe818f",
				"5b20f7ffca1df794edfe81dc",
				"5b20fb5aca1df794edfe846e",
				"5b20f9eaca1df794edfe8351",
				"5b20fd38ca1df794edfe85ea",
				"5b20fb91ca1df794edfe8497",
			],
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			espino: { idRivisa: "ESP0003", metros: 250 },
		},
		{
			_id: "5b447e2bca1df794ed16dca1",
			idRivisa: "BAY0058",
			colorStr: "RAL",
			anchuraPoste: "",
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			desc: { es: "", ca: "", en: "", fr: "" },
			altura: "0m300",
			paneles: [
				"5b20f7e2ca1df794edfe81c7",
				"5b20f7a4ca1df794edfe8199",
				"5b20f80aca1df794edfe81e5",
				"5b20fb66ca1df794edfe8479",
				"5b20f9f4ca1df794edfe8359",
				"5b20fd46ca1df794edfe85f6",
				"5b20fb9cca1df794edfe849f",
			],
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			espino: { idRivisa: "ESP000101", metros: 250 },
		},
		{
			_id: "5b472d72ca1df794ed192607",
			idRivisa: "BAY0021",
			color: ["5b16ab91ca1df794edf82088"],
			colorStr: "Blanco",
			anchuraPoste: "LUX50",
			desc: {
				es: "BAYONETA SIMPLE LUX 50 Galv",
				ca: "CA: BAYONETA SIMPLE LUX 50",
				en: "EN: BAYONETA SIMPLE LUX 50",
				fr: "FR: BAYONETA SIMPLE LUX 50",
			},
			altura: "0m300",
			paneles: [],
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			espino: { idRivisa: "ESP000101", metros: 250 },
		},
		{
			_id: "5b472dc3ca1df794ed192658",
			idRivisa: "BAY0062",
			color: ["5b16ab91ca1df794edf82088"],
			colorStr: "Blanco",
			anchuraPoste: "",
			desc: { es: "", ca: "", en: "", fr: "" },
			altura: "0m300",
			paneles: ["5b20fd29ca1df794edfe85de"],
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			espino: { idRivisa: "ESP000101", metros: 250 },
		},
		{
			_id: "5b472ddeca1df794ed192676",
			idRivisa: "BAY0061",
			color: ["595bb930060cda18c1334ed2"],
			colorStr: "Verde",
			anchuraPoste: "",
			desc: { es: "", ca: "", en: "", fr: "" },
			altura: "0m300",
			paneles: ["5b20fd38ca1df794edfe85ea"],
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			espino: { idRivisa: "ESP0003", metros: 200 },
		},
		{
			_id: "5b472dfcca1df794ed192698",
			idRivisa: "BAY0063",
			colorStr: "RAL",
			anchuraPoste: "",
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			desc: { es: "", ca: "", en: "", fr: "" },
			altura: "0m300",
			paneles: ["5b20fd46ca1df794edfe85f6"],
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			espino: { idRivisa: "ESP000101", metros: 250 },
		},
		{
			_id: "5be3f9c1ca1df794ed7c56c3",
			idRivisa: "BAY0001",
			color: ["595bb930060cda18c1334ed2"],
			colorStr: "Verde",
			anchuraPoste: "LUX80",
			desc: { es: "BAYONETA DOBLE VERDE", ca: "", en: "", fr: "" },
			altura: "0m300",
			paneles: [
				"5b1e677bca1df794edfce36b",
				"5b1e6a71ca1df794edfce5ac",
				"5b1e6c57ca1df794edfce723",
				"5b1e6c83ca1df794edfce749",
				"5b1e6d4cca1df794edfce7f2",
				"5b1e6d6eca1df794edfce810",
				"5b1e6fb7ca1df794edfce9ee",
				"5b1e6fe5ca1df794edfcea10",
			],
			tipo: "doble",
			elementos: ["5a311e82514ced9b5d5823f0"],
			espino: { idRivisa: "ESP0003", metros: 200 },
		},
		//ESPRIVISA-42: Bayonetas Antracita separadas del array de RAL -> - BAY0023 - BAY0007 - BAY0058 - BAY0063 - BAY0017
		{
			_id: "622b713628778806f0a4c7dd",
			color: "5b16acd5ca1df794edf82198",
			colorStr: "Antracita",
			idRivisa: "BAY0010",
			anchuraPoste: "LUX80",
			desc: {
				es: "BAYONETA SIMPLE LUX 80",
				ca: "BAYONETA SIMPLE LUX 80",
				en: "BAYONETA SIMPLE LUX 80",
				fr: "BAYONETA SIMPLE LUX 80",
			},
			altura: "0m300",
			paneles: [
				"62308f3746d79e1e8c060942",
				"6231984846d79e1e8c060943",
				"6231987e46d79e1e8c060946",
				"6231987146d79e1e8c060945",
				"6231a58646d79e1e8c060949",
				"6231986446d79e1e8c060944",
				"6231989646d79e1e8c060948",
				"6231988846d79e1e8c060947",
			],
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			espino: {
				idRivisa: "ESP000101",
				metros: 250,
			},
		},
		{
			_id: "622b714328778806f0a4c7de",
			idRivisa: "BAY0018",
			colorStr: "Antracita",
			anchuraPoste: "LUX80",
			desc: {
				es: "Bayoneta Doble Antracita LUX-80",
				ca: "Bayoneta Doble Antracita LUX-80",
				en: "Bayoneta Doble Antracita LUX-80",
				fr: "Bayoneta Doble Antracita LUX-80",
			},
			altura: "0m300",
			color: ["5b16acd5ca1df794edf82198"],
			paneles: [
				"62308f3746d79e1e8c060942",
				"6231984846d79e1e8c060943",
				"5b1e6c62ca1df794edfce799",
				"6231a58646d79e1e8c060949",
				"6231987146d79e1e8c060945",
				"6231987e46d79e1e8c060946",
				"6231988846d79e1e8c060947",
				"6231989646d79e1e8c060948",
			],
			tipo: "doble",
			elementos: ["5a311e82514ced9b5d5823f0"],
			espino: {
				idRivisa: "ESP000101",
				metros: 250,
			},
		},
		{
			_id: "622b715c28778806f0a4c7e0",
			idRivisa: "BAY0059",
			colorStr: "Antracita",
			anchuraPoste: "",
			color: ["5b16acd5ca1df794edf82198"],
			desc: {
				es: "Bayoneta Doble Antracita RITMO",
				ca: "Bayoneta Doble Antracita RITMO",
				en: "Bayoneta Doble Antracita RITMO",
				fr: "Bayoneta Doble Antracita RITMO",
			},
			altura: "0m300",
			paneles: [
				"62385debc631a51514e61531",
				"62385bdac631a51514e6152f",
				"62385ec6c631a51514e61532",
				"62386232c631a51514e61534",
				"6238605ac631a51514e61533",
				"623871c2c631a51514e61538",
				"623866fcc631a51514e61535",
			],
			tipo: "doble",
			elementos: ["5a311e82514ced9b5d5823f0"],
			espino: {
				idRivisa: "ESP000101",
				metros: 250,
			},
		},
		{
			_id: "622b716528778806f0a4c7e1",
			idRivisa: "BAY0063",
			colorStr: "Antracita",
			anchuraPoste: "",
			color: ["5b16acd5ca1df794edf82198"],
			desc: {
				es: "",
				ca: "",
				en: "",
				fr: "",
			},
			altura: "0m300",
			paneles: ["5b20fd46ca1df794edfe85f6"],
			tipo: "simple",
			elementos: ["5a311e82514ced9b5d5823f0"],
			espino: {
				idRivisa: "ESP000101",
				metros: 250,
			},
		},
		{
			_id: "5be405afca1df794ed7c61e6",
			idRivisa: "BAY0019",
			colorStr: "RAL",
			anchuraPoste: "LUX80",
			desc: {
				es: "Bayoneta Doble RAL LUX-80",
				ca: "Bayoneta Doble RAL LUX-80",
				en: "Bayoneta Doble RAL LUX-80",
				fr: "Bayoneta Doble RAL LUX-80",
			},
			altura: "0m300",
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			paneles: [
				"5b1e678eca1df794edfce37a",
				"5b1e6a7bca1df794edfce5b4",
				"5b1e6c62ca1df794edfce72b",
				"5b1e6c8eca1df794edfce752",
				"5b1e6d58ca1df794edfce7fb",
				"5b1e6d78ca1df794edfce819",
				"5b1e6fc2ca1df794edfce9f8",
				"5b1e6fefca1df794edfcea1b",
			],
			tipo: "doble",
			elementos: ["5a311e82514ced9b5d5823f0"],
			espino: { idRivisa: "ESP000101", metros: 250 },
		},
		{
			_id: "62382763c631a51514e6152d",
			idRivisa: "BAY0016",
			colorStr: "Verde",
			anchuraPoste: "LUX80",
			desc: {
				es: "Bayoneta Doble Verde LUX-80",
				ca: "Bayoneta Doble Verde LUX-80",
				en: "Bayoneta Doble Verde LUX-80",
				fr: "Bayoneta Doble Verde LUX-80",
			},
			altura: "0m300",
			color: ["595bb930060cda18c1334ed2 "],
			paneles: [
				"5b1e677bca1df794edfce36b",
				"5b1e6a71ca1df794edfce5ac",
				"5b1e6c57ca1df794edfce723",
				"5b1e6c83ca1df794edfce749",
				"5b1e6d4cca1df794edfce7f2",
				"5b1e6d6eca1df794edfce810",
				"5b1e6fb7ca1df794edfce9ee",
				"5b1e6fe5ca1df794edfcea10",
			],
			tipo: "doble",
			elementos: ["5a311e82514ced9b5d5823f0"],
			espino: { idRivisa: "ESP000101", metros: 250 },
		},

		{
			_id: "5be40773ca1df794ed7c6359",
			idRivisa: "BAY0017",
			color: ["5b16ab91ca1df794edf82088"],
			colorStr: "Blanco",
			anchuraPoste: "LUX80",
			desc: {
				es: "Bayoneta Doble Blanco LUX-80",
				ca: "Bayoneta Doble Blanco LUX-80",
				en: "Bayoneta Doble Blanco LUX-80",
				fr: "Bayoneta Doble Blanco LUX-80",
			},
			altura: "0m300",
			paneles: [
				"5b1e674dca1df794edfce348",
				"5b1e6a62ca1df794edfce5a0",
				"5b1e6c4cca1df794edfce719",
				"5b1e6c79ca1df794edfce73c",
				"5b1e6d42ca1df794edfce7ea",
				"5b1e6d65ca1df794edfce807",
				"5b1e6fadca1df794edfce9e4",
				"5b1e6fd4ca1df794edfcea04",
			],
			tipo: "doble",
			elementos: ["5a311e82514ced9b5d5823f0"],
			espino: { idRivisa: "ESP0003", metros: 200 },
		},
		{
			_id: "6238409bc631a51514e6152e",
			idRivisa: "BAY0015",
			color: ["595bb930060cda18c1334ed0"],
			colorStr: "Galvanizado",
			anchuraPoste: "LUX80",
			desc: {
				es: "Bayoneta Doble Galvanizado LUX-80",
				ca: "Bayoneta Doble Galvanizado LUX-80",
				en: "Bayoneta Doble Galvanizado LUX-80",
				fr: "Bayoneta Doble Galvanizado LUX-80",
			},
			altura: "0m300",
			paneles: ["5b1e674dca1df794edfce348"],
			tipo: "doble",
			elementos: ["5a311e82514ced9b5d5823f0"],
			espino: { idRivisa: "ESP0003", metros: 200 },
		},
	];

	public readonly panels = [
		{
			_id: "59366ad4b040e6170cb97930",
			tipoPanel: "593a8596b040e6170cb9ae2c",
			idRivisa: "EST0004",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed0"],
			luz: "50",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 3,
			grapasPosteExtremo: 12,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 3,
			grapasPosteIntermedio: 4,
			hiladasAlambre: 2,
			rolloMalla: 25,
			placaBase: true,
		},
		{
			_id: "59366ad4b040e6170cb97932",
			tipoPanel: "593a8596b040e6170cb9ae2c",
			idRivisa: "EST0005",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed0"],
			luz: "50",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 4,
			grapasPosteExtremo: 18,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 4,
			grapasPosteIntermedio: 5,
			hiladasAlambre: 3,
			rolloMalla: 25,
			placaBase: true,
		},
		{
			_id: "59366ad4b040e6170cb97934",
			idRivisa: "EST0007",
			tipoPanel: "593a8596b040e6170cb9ae2c",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed0"],
			luz: "50",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 4,
			grapasPosteExtremo: 24,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 4,
			grapasPosteIntermedio: 5,
			hiladasAlambre: 3,
			rolloMalla: 25,
			placaBase: true,
			bayoneta: { id: "594cff4d85e50bd508b4b363", idRivisa: "BAY0022" },
		},
		{
			_id: "59366ad4b040e6170cb97936",
			idRivisa: "EST0007-EST0004",
			tipoPanel: "593a8596b040e6170cb9ae2c",
			altura: "3m00",
			altura3d: "3m00",
			alturaValor: 3000,
			color: ["595bb930060cda18c1334ed0"],
			luz: "50",
			posteExtremo: "LUX80",
			soportesPosteExtremo: 5,
			grapasPosteExtremo: 36,
			posteIntermedio: "LUX80",
			soportePosteIntermedio: 5,
			grapasPosteIntermedio: 7,
			hiladasAlambre: 4,
			rolloMalla: 25,
		},
		{
			_id: "59f3269a7f936cd8bbf5d8cf",
			tipoPanel: "593a8596b040e6170cb9ae2c",
			idRivisa: "EST0007-EST0007",
			altura: "4m00",
			altura3d: "3m00",
			alturaValor: 4000,
			color: ["595bb930060cda18c1334ed0"],
			luz: "50",
			posteExtremo: "LUX80",
			soportesPosteExtremo: 6,
			grapasPosteExtremo: 48,
			posteIntermedio: "LUX80",
			soportePosteIntermedio: 6,
			grapasPosteIntermedio: 9,
			hiladasAlambre: 5,
			rolloMalla: 25,
		},
		{
			_id: "5989d96d5394623757429476",
			tipoPanel: "5989d8625394623757429436",
			idRivisa: "EST0018",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed0"],
			luz: "50",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 3,
			grapasPosteExtremo: 12,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 3,
			grapasPosteIntermedio: 4,
			hiladasAlambre: 2,
			rolloMalla: 25,
			placaBase: true,
		},
		{
			_id: "5989d96d5394623757429478",
			tipoPanel: "5989d8625394623757429436",
			idRivisa: "EST0020",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed0"],
			luz: "50",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 4,
			grapasPosteExtremo: 18,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 4,
			grapasPosteIntermedio: 5,
			hiladasAlambre: 3,
			rolloMalla: 25,
			placaBase: true,
		},
		{
			_id: "5989d96d539462375742947a",
			tipoPanel: "5989d8625394623757429436",
			idRivisa: "EST0022",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed0"],
			luz: "50",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 4,
			grapasPosteExtremo: 24,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 4,
			grapasPosteIntermedio: 5,
			hiladasAlambre: 3,
			rolloMalla: 25,
			placaBase: true,
			bayoneta: { id: "594cff4d85e50bd508b4b363", idRivisa: "BAY0022" },
		},
		{
			_id: "5989d96d539462375742947c",
			tipoPanel: "5989d8625394623757429436",
			idRivisa: "EST0022-EST0018",
			altura: "3m00",
			altura3d: "3m00",
			alturaValor: 3000,
			color: ["595bb930060cda18c1334ed0"],
			luz: "50",
			posteExtremo: "LUX80",
			soportesPosteExtremo: 5,
			grapasPosteExtremo: 36,
			posteIntermedio: "LUX80",
			soportePosteIntermedio: 5,
			grapasPosteIntermedio: 7,
			hiladasAlambre: 4,
			rolloMalla: 25,
		},
		{
			_id: "59f3269a7f936cd8bbf5d8d5",
			tipoPanel: "5989d8625394623757429436",
			idRivisa: "EST0022-EST0022",
			altura: "4m00",
			altura3d: "3m00",
			alturaValor: 4000,
			color: ["595bb930060cda18c1334ed0"],
			luz: "50",
			posteExtremo: "LUX80",
			soportesPosteExtremo: 6,
			grapasPosteExtremo: 48,
			posteIntermedio: "LUX80",
			soportePosteIntermedio: 6,
			grapasPosteIntermedio: 9,
			hiladasAlambre: 5,
			rolloMalla: 25,
		},
		{
			_id: "59366ad4b040e6170cb97938",
			tipoPanel: "593a8596b040e6170cb9ae2e",
			idRivisa: "EST0026",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed0"],
			luz: "50",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 3,
			grapasPosteExtremo: 12,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 3,
			grapasPosteIntermedio: 4,
			hiladasAlambre: 2,
			rolloMalla: 25,
			placaBase: true,
		},
		{
			_id: "59366ad4b040e6170cb9793a",
			tipoPanel: "593a8596b040e6170cb9ae2e",
			idRivisa: "EST0027",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed0"],
			luz: "50",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 4,
			grapasPosteExtremo: 18,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 4,
			grapasPosteIntermedio: 5,
			hiladasAlambre: 3,
			rolloMalla: 25,
			placaBase: true,
		},
		{
			_id: "59366ad4b040e6170cb9793c",
			tipoPanel: "593a8596b040e6170cb9ae2e",
			idRivisa: "EST0028",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed0"],
			luz: "50",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 4,
			grapasPosteExtremo: 24,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 4,
			grapasPosteIntermedio: 5,
			hiladasAlambre: 3,
			rolloMalla: 25,
			placaBase: true,
			bayoneta: { id: "594cff4d85e50bd508b4b363", idRivisa: "BAY0022" },
		},
		{
			_id: "59366ad4b040e6170cb9793e",
			tipoPanel: "593a8596b040e6170cb9ae2e",
			idRivisa: "EST0028-EST0026",
			altura: "3m00",
			altura3d: "3m00",
			alturaValor: 3000,
			color: ["595bb930060cda18c1334ed0"],
			luz: "50",
			posteExtremo: "LUX80",
			soportesPosteExtremo: 5,
			grapasPosteExtremo: 36,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 5,
			grapasPosteIntermedio: 7,
			hiladasAlambre: 4,
			rolloMalla: 25,
		},
		{
			_id: "59f3269a7f936cd8bbf5d8db",
			tipoPanel: "593a8596b040e6170cb9ae2e",
			idRivisa: "EST0028-EST0028",
			altura: "4m00",
			altura3d: "3m00",
			alturaValor: 4000,
			color: ["595bb930060cda18c1334ed0"],
			luz: "50",
			posteExtremo: "LUX80",
			soportesPosteExtremo: 6,
			grapasPosteExtremo: 48,
			posteIntermedio: "LUX80",
			soportePosteIntermedio: 6,
			grapasPosteIntermedio: 9,
			hiladasAlambre: 5,
			rolloMalla: 25,
		},
		{
			_id: "59366ad4b040e6170cb97940",
			tipoPanel: "593a8596b040e6170cb9ae30",
			idRivisa: "EST0035",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed2"],
			luz: "40",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 3,
			grapasPosteExtremo: 12,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 3,
			grapasPosteIntermedio: 4,
			hiladasAlambre: 2,
			rolloMalla: 25,
			placaBase: true,
		},
		{
			_id: "59366ad4b040e6170cb97942",
			tipoPanel: "593a8596b040e6170cb9ae30",
			idRivisa: "EST0036",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed2"],
			luz: "40",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 4,
			grapasPosteExtremo: 18,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 4,
			grapasPosteIntermedio: 5,
			hiladasAlambre: 3,
			rolloMalla: 25,
			placaBase: true,
		},
		{
			_id: "59366ad4b040e6170cb97944",
			tipoPanel: "593a8596b040e6170cb9ae30",
			idRivisa: "EST0037",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed2"],
			luz: "40",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 4,
			grapasPosteExtremo: 24,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 4,
			grapasPosteIntermedio: 5,
			hiladasAlambre: 3,
			rolloMalla: 25,
			placaBase: true,
		},
		{
			_id: "59366ad4b040e6170cb97946",
			tipoPanel: "593a8596b040e6170cb9ae30",
			idRivisa: "EST0037-EST0035",
			altura: "3m00",
			altura3d: "3m00",
			alturaValor: 3000,
			color: ["595bb930060cda18c1334ed2"],
			luz: "40",
			posteExtremo: "LUX80",
			soportesPosteExtremo: 5,
			grapasPosteExtremo: 36,
			posteIntermedio: "LUX80",
			soportePosteIntermedio: 5,
			grapasPosteIntermedio: 7,
			hiladasAlambre: 4,
			rolloMalla: 25,
		},
		{
			_id: "59f3269a7f936cd8bbf5d8e1",
			tipoPanel: "593a8596b040e6170cb9ae30",
			idRivisa: "EST0037-EST0037",
			altura: "4m00",
			altura3d: "3m00",
			alturaValor: 4000,
			color: ["595bb930060cda18c1334ed2"],
			luz: "50",
			posteExtremo: "LUX80",
			soportesPosteExtremo: 6,
			grapasPosteExtremo: 48,
			posteIntermedio: "LUX80",
			soportePosteIntermedio: 6,
			grapasPosteIntermedio: 9,
			hiladasAlambre: 5,
			rolloMalla: 25,
		},
		{
			_id: "59366ad4b040e6170cb97948",
			tipoPanel: "593a8596b040e6170cb9ae32",
			idRivisa: "EST0042",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed2"],
			luz: "50",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 3,
			grapasPosteExtremo: 12,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 3,
			grapasPosteIntermedio: 4,
			hiladasAlambre: 2,
			rolloMalla: 25,
			placaBase: true,
		},
		{
			_id: "59366ad4b040e6170cb9794a",
			tipoPanel: "593a8596b040e6170cb9ae32",
			idRivisa: "EST0044",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed2"],
			luz: "50",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 4,
			grapasPosteExtremo: 18,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 4,
			grapasPosteIntermedio: 5,
			hiladasAlambre: 3,
			rolloMalla: 25,
			placaBase: true,
		},
		{
			_id: "59366ad4b040e6170cb9794c",
			tipoPanel: "593a8596b040e6170cb9ae32",
			idRivisa: "EST0046",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed2"],
			luz: "40",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 4,
			grapasPosteExtremo: 24,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 4,
			grapasPosteIntermedio: 5,
			hiladasAlambre: 3,
			rolloMalla: 25,
			placaBase: true,
		},
		{
			_id: "59366ad4b040e6170cb9794e",
			tipoPanel: "593a8596b040e6170cb9ae32",
			idRivisa: "EST0046-EST0042",
			altura: "3m00",
			altura3d: "3m00",
			alturaValor: 3000,
			color: ["595bb930060cda18c1334ed2"],
			luz: "50",
			posteExtremo: "LUX80",
			soportesPosteExtremo: 5,
			grapasPosteExtremo: 36,
			posteIntermedio: "LUX80",
			soportePosteIntermedio: 5,
			grapasPosteIntermedio: 7,
			hiladasAlambre: 4,
			rolloMalla: 25,
		},
		{
			_id: "59f3269a7f936cd8bbf5d8e7",
			tipoPanel: "593a8596b040e6170cb9ae32",
			idRivisa: "EST0046-EST0046",
			altura: "4m00",
			altura3d: "3m00",
			alturaValor: 4000,
			color: ["595bb930060cda18c1334ed2"],
			luz: "50",
			posteExtremo: "LUX80",
			soportesPosteExtremo: 6,
			grapasPosteExtremo: 48,
			posteIntermedio: "LUX80",
			soportePosteIntermedio: 6,
			grapasPosteIntermedio: 9,
			hiladasAlambre: 5,
			rolloMalla: 25,
		},
		{
			_id: "5989e27453946237574295eb",
			tipoPanel: "5989e0f25394623757429599",
			idRivisa: "EST0057",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed2"],
			luz: "50",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 3,
			grapasPosteExtremo: 12,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 3,
			grapasPosteIntermedio: 4,
			hiladasAlambre: 2,
			rolloMalla: 25,
			placaBase: true,
		},
		{
			_id: "5989e27453946237574295ed",
			tipoPanel: "5989e0f25394623757429599",
			idRivisa: "EST0058",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed2"],
			luz: "50",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 4,
			grapasPosteExtremo: 18,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 4,
			grapasPosteIntermedio: 5,
			hiladasAlambre: 3,
			rolloMalla: 25,
			placaBase: true,
		},
		{
			_id: "5989e27453946237574295ef",
			tipoPanel: "5989e0f25394623757429599",
			idRivisa: "EST0059",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed2"],
			luz: "40",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 4,
			grapasPosteExtremo: 24,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 4,
			grapasPosteIntermedio: 5,
			hiladasAlambre: 3,
			rolloMalla: 15,
			placaBase: true,
		},
		{
			_id: "5989e27453946237574295f1",
			tipoPanel: "5989e0f25394623757429599",
			idRivisa: "EST0059-EST0057",
			altura: "3m00",
			altura3d: "3m00",
			alturaValor: 3000,
			color: ["595bb930060cda18c1334ed2"],
			luz: "50",
			posteExtremo: "LUX80",
			soportesPosteExtremo: 5,
			grapasPosteExtremo: 36,
			posteIntermedio: "LUX80",
			soportePosteIntermedio: 5,
			grapasPosteIntermedio: 7,
			hiladasAlambre: 4,
			rolloMalla: 15,
		},
		{
			_id: "59f3269a7f936cd8bbf5d8ed",
			tipoPanel: "5989e0f25394623757429599",
			idRivisa: "EST0059-EST0059",
			altura: "4m00",
			altura3d: "3m00",
			alturaValor: 4000,
			color: ["595bb930060cda18c1334ed2"],
			luz: "50",
			posteExtremo: "LUX80",
			soportesPosteExtremo: 6,
			grapasPosteExtremo: 48,
			posteIntermedio: "LUX80",
			soportePosteIntermedio: 6,
			grapasPosteIntermedio: 9,
			hiladasAlambre: 5,
			rolloMalla: 15,
		},
		{
			_id: "5989e27453946237574295f3",
			tipoPanel: "5989e0f2539462375742959b",
			idRivisa: "EST0054",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed2"],
			luz: "50",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 3,
			grapasPosteExtremo: 12,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 3,
			grapasPosteIntermedio: 4,
			hiladasAlambre: 2,
			rolloMalla: 25,
			placaBase: true,
		},
		{
			_id: "5989e27453946237574295f5",
			tipoPanel: "5989e0f2539462375742959b",
			idRivisa: "EST0055",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed2"],
			luz: "50",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 4,
			grapasPosteExtremo: 18,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 4,
			grapasPosteIntermedio: 5,
			hiladasAlambre: 3,
			rolloMalla: 25,
			placaBase: true,
		},
		{
			_id: "5989e27453946237574295f7",
			tipoPanel: "5989e0f2539462375742959b",
			idRivisa: "EST0056",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed2"],
			luz: "40",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 4,
			grapasPosteExtremo: 24,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 4,
			grapasPosteIntermedio: 5,
			hiladasAlambre: 3,
			rolloMalla: 15,
			placaBase: true,
		},
		{
			_id: "5989e27453946237574295f9",
			tipoPanel: "5989e0f2539462375742959b",
			idRivisa: "EST0056-EST0054",
			altura: "3m00",
			altura3d: "3m00",
			alturaValor: 3000,
			color: ["595bb930060cda18c1334ed2"],
			luz: "50",
			posteExtremo: "LUX80",
			soportesPosteExtremo: 5,
			grapasPosteExtremo: 36,
			posteIntermedio: "LUX80",
			soportePosteIntermedio: 5,
			grapasPosteIntermedio: 7,
			hiladasAlambre: 4,
			rolloMalla: 15,
		},
		{
			_id: "59f3269a7f936cd8bbf5d8f3",
			tipoPanel: "5989e0f2539462375742959b",
			idRivisa: "EST0056-EST0056",
			altura: "4m00",
			altura3d: "3m00",
			alturaValor: 4000,
			color: ["595bb930060cda18c1334ed2"],
			luz: "50",
			posteExtremo: "LUX80",
			soportesPosteExtremo: 6,
			grapasPosteExtremo: 48,
			posteIntermedio: "LUX80",
			soportePosteIntermedio: 6,
			grapasPosteIntermedio: 9,
			hiladasAlambre: 5,
			rolloMalla: 15,
		},
		{
			_id: "5942562c85e50bd508b490ff",
			tipoPanel: "593a8596b040e6170cb9ae34",
			idRivisa: "MEL0001",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed2"],
			medidaMalla: "100x50",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 3,
			grapasPosteExtremo: 22,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 3,
			grapasPosteIntermedio: 4,
			posteIntermedioDes: "LUX50",
			posteExtremoDes: "LUX50",
			rolloMalla: 25,
		},
		{
			_id: "5942563a85e50bd508b49101",
			tipoPanel: "593a8596b040e6170cb9ae34",
			idRivisa: "MEL0002",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed2"],
			medidaMalla: "100x50",
			posteExtremo: "LUX80",
			soportesPosteExtremo: 4,
			grapasPosteExtremo: 33,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 4,
			grapasPosteIntermedio: 5,
			posteIntermedioDes: "LUX80",
			posteExtremoDes: "LUX50",
			rolloMalla: 25,
		},
		{
			_id: "5942564a85e50bd508b49107",
			tipoPanel: "593a8596b040e6170cb9ae34",
			idRivisa: "MEL0003",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed2"],
			medidaMalla: "100x50",
			posteExtremo: "LUX80",
			soportesPosteExtremo: 4,
			grapasPosteExtremo: 44,
			posteIntermedio: "LUX80",
			soportePosteIntermedio: 4,
			grapasPosteIntermedio: 5,
			posteIntermedioDes: "LUX80",
			posteExtremoDes: "LUX80",
			rolloMalla: 25,
		},
		{
			_id: "594256cf85e50bd508b4911b",
			tipoPanel: "593a8596b040e6170cb9ae38",
			idRivisa: "MAN0001",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			distAlambresVert: "15cm",
			numHilosHoriz: "8",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 1,
			grapasPosteExtremo: 0,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 1,
			grapasPosteIntermedio: 4,
			color: ["595bb930060cda18c1334ed0"],
			medidaMalla: "100-08-15",
			posteIntermedioDes: "LUX50",
			posteExtremoDes: "LUX50",
			rolloMalla: 25,
		},
		{
			_id: "5a131ab5eca42d00a0883eb1",
			tipoPanel: "593a8596b040e6170cb9ae3a",
			idRivisa: "MAN0002",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			distAlambresVert: "30cm",
			numHilosHoriz: "8",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 1,
			grapasPosteExtremo: 0,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 1,
			grapasPosteIntermedio: 4,
			color: ["595bb930060cda18c1334ed0"],
			medidaMalla: "100-08-30",
			posteIntermedioDes: "LUX50",
			posteExtremoDes: "LUX50",
			rolloMalla: 25,
		},
		{
			_id: "594256cf85e50bd508b4911d",
			tipoPanel: "593a8596b040e6170cb9ae3c",
			idRivisa: "MAN0004",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			distAlambresVert: "15cm",
			numHilosHoriz: "18",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 1,
			grapasPosteExtremo: 0,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 1,
			grapasPosteIntermedio: 5,
			color: ["595bb930060cda18c1334ed0"],
			medidaMalla: "148-18-15",
			posteIntermedioDes: "LUX50",
			posteExtremoDes: "LUX50",
			rolloMalla: 25,
		},
		{
			_id: "594256cf85e50bd508b4911f",
			tipoPanel: "593a8596b040e6170cb9ae3e",
			idRivisa: "MAN0005",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			distAlambresVert: "30cm",
			numHilosHoriz: "18",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 1,
			grapasPosteExtremo: 0,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 1,
			grapasPosteIntermedio: 5,
			color: ["595bb930060cda18c1334ed0"],
			medidaMalla: "148-18-30",
			posteIntermedioDes: "LUX50",
			posteExtremoDes: "LUX50",
			rolloMalla: 25,
		},
		{
			_id: "594256cf85e50bd508b49121",
			tipoPanel: "593a8596b040e6170cb9ae40",
			idRivisa: "MAN0008",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			distAlambresVert: "15cm",
			numHilosHoriz: "20",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 1,
			grapasPosteExtremo: 0,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 1,
			grapasPosteIntermedio: 5,
			color: ["595bb930060cda18c1334ed0"],
			medidaMalla: "200-20-15",
			posteIntermedioDes: "LUX80",
			posteExtremoDes: "LUX80",
			rolloMalla: 25,
		},
		{
			_id: "594256cf85e50bd508b49123",
			tipoPanel: "593a8596b040e6170cb9ae42",
			idRivisa: "MAN0009",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			distAlambresVert: "30cm",
			numHilosHoriz: "20",
			posteExtremo: "LUX50",
			soportesPosteExtremo: 1,
			grapasPosteExtremo: 0,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 1,
			grapasPosteIntermedio: 5,
			color: ["595bb930060cda18c1334ed0"],
			medidaMalla: "200-20-30",
			posteIntermedioDes: "LUX80",
			posteExtremoDes: "LUX80",
			rolloMalla: 25,
		},

		{
			_id: "5b1e674dca1df794edfce348",
			idRivisa: "BFA0135",
			tipoPanel: "5b212e7eca1df794edfeaa36",
			modelo: "FAX",
			posteExtremo: "LUX80",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16ab91ca1df794edf82088"],
			colorStr: "Blanco",
			bayoneta: { id: "5b447c00ca1df794ed16da7c", idRivisa: "BAY0003" },
			bayonetaDoble: {
				id: "6238409bc631a51514e6152e",
				idRivisa: "BAY0015",
			},
		},
		{
			_id: "5b1e677bca1df794edfce36b",
			idRivisa: "BFA0125",
			tipoPanel: "5b212e7eca1df794edfeaa36",
			modelo: "FAX",
			posteExtremo: "LUX80",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed2"],
			colorStr: "Verde",
			bayoneta: { id: "5b447c6cca1df794ed16dae9", idRivisa: "BAY0001" },
			bayonetaDoble: {
				id: "62382763c631a51514e6152d",
				idRivisa: "BAY0016",
			},
		},
		{
			_id: "5b1e678eca1df794edfce37a",
			idRivisa: "BFA0145",
			tipoPanel: "5b212e7eca1df794edfeaa36",
			modelo: "FAX",
			posteExtremo: "LUX80",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			colorStr: "RAL",
			bayoneta: { id: "5b447ce0ca1df794ed16db5a", idRivisa: "BAY0007" },
			bayonetaDoble: {
				id: "5be405afca1df794ed7c61e6",
				idRivisa: "BAY0019",
			},
		},

		{
			_id: "5b1e674dca1df794edfce333",
			idRivisa: "BFA0235",
			tipoPanel: "5b212e7eca1df794edfeaa33",
			modelo: "FAX",
			posteExtremo: "LUX80",
			altura: "2m03",
			altura3d: "2m03",
			alturaValor: 2030,
			color: ["5b16ab91ca1df794edf82088"],
			colorStr: "Blanco",
			bayoneta: { id: "5b447c00ca1df794ed16da7c", idRivisa: "BAY0003" },
			bayonetaDoble: {
				id: "6238409bc631a51514e6152e",
				idRivisa: "BAY0015",
			},
		},
		{
			_id: "5b1e677bca1df794edfce666",
			idRivisa: "BFA0225",
			tipoPanel: "5b212e7eca1df794edfeaa33",
			modelo: "FAX",
			posteExtremo: "LUX80",
			altura: "2m03",
			altura3d: "2m03",
			alturaValor: 2030,
			color: ["595bb930060cda18c1334ed2"],
			colorStr: "Verde",
			bayoneta: { id: "5b447c6cca1df794ed16dae9", idRivisa: "BAY0001" },
			bayonetaDoble: {
				id: "62382763c631a51514e6152d",
				idRivisa: "BAY0016",
			},
		},
		{
			_id: "5b1e678eca1df794edfceaaa",
			idRivisa: "BFA0245",
			tipoPanel: "5b212e7eca1df794edfeaa33",
			modelo: "FAX",
			posteExtremo: "LUX80",
			altura: "2m03",
			altura3d: "2m03",
			alturaValor: 2030,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			colorStr: "RAL",
			bayoneta: { id: "5b447ce0ca1df794ed16db5a", idRivisa: "BAY0007" },
			bayonetaDoble: {
				id: "5be405afca1df794ed7c61e6",
				idRivisa: "BAY0019",
			},
		},
		{
			_id: "5b1e678eca1df794edfceabb",
			idRivisa: "BFA0257",
			tipoPanel: "5b212e7eca1df794edfeaa33",
			modelo: "FAX",
			posteExtremo: "LUX80",
			altura: "2m03",
			altura3d: "2m03",
			alturaValor: 2030,
			color: ["5b16acd5ca1df794edf82198"],
			colorStr: "RAL",
			bayoneta: { id: "5b447ce0ca1df794ed16db5a", idRivisa: "BAY0010" },
			bayonetaDoble: {
				id: "5be405afca1df794ed7c61e6",
				idRivisa: "BAY0018",
			},
		},

		{
			_id: "5b1e674dca1df794edfce444",
			idRivisa: "BFA0136",
			tipoPanel: "5b212e7eca1df794edfeaa77",
			modelo: "FAX",
			posteExtremo: "LUX80",
			altura: "2m40",
			altura3d: "2m40",
			alturaValor: 2400,
			color: ["5b16ab91ca1df794edf82088"],
			colorStr: "Blanco",
			bayoneta: { id: "5b447c00ca1df794ed16da7c", idRivisa: "BAY0003" },
			bayonetaDoble: {
				id: "6238409bc631a51514e6152e",
				idRivisa: "BAY0015",
			},
		},
		{
			_id: "5b1e677bca1df794edfce777",
			idRivisa: "BFA0126",
			tipoPanel: "5b212e7eca1df794edfeaa77",
			modelo: "FAX",
			posteExtremo: "LUX80",
			altura: "2m40",
			altura3d: "2m40",
			alturaValor: 2400,
			color: ["595bb930060cda18c1334ed2"],
			colorStr: "Verde",
			bayoneta: { id: "5b447c6cca1df794ed16dae9", idRivisa: "BAY0001" },
			bayonetaDoble: {
				id: "62382763c631a51514e6152d",
				idRivisa: "BAY0016",
			},
		},
		{
			_id: "5b1e678eca1df794edfcebbb",
			idRivisa: "BFA0146",
			tipoPanel: "5b212e7eca1df794edfeaa77",
			modelo: "FAX",
			posteExtremo: "LUX80",
			altura: "2m40",
			altura3d: "2m40",
			alturaValor: 2400,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			colorStr: "RAL",
			bayoneta: { id: "5b447ce0ca1df794ed16db5a", idRivisa: "BAY0007" },
			bayonetaDoble: {
				id: "5be405afca1df794ed7c61e6",
				idRivisa: "BAY0019",
			},
		},
		{
			_id: "5b1e678eca1df794edfcebdd",
			idRivisa: "BFA0258",
			tipoPanel: "5b212e7eca1df794edfeaa77",
			modelo: "FAX",
			posteExtremo: "LUX80",
			altura: "2m40",
			altura3d: "2m40",
			alturaValor: 2400,
			color: ["5b16acd5ca1df794edf82198"],
			colorStr: "RAL",
			bayoneta: { id: "5b447ce0ca1df794ed16db5a", idRivisa: "BAY0010" },
			bayonetaDoble: {
				id: "5be405afca1df794ed7c61e6",
				idRivisa: "BAY0018",
			},
		},

		{
			_id: "6231984846d79e1e8c060943",
			idRivisa: "BFA0145",
			tipoPanel: "5b212e7eca1df794edfeaa36",
			modelo: "FAX",
			posteExtremo: "LUX80",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16acd5ca1df794edf82198"],
			colorStr: "Antracita",
			bayoneta: {
				id: "622b713628778806f0a4c7dd",
				idRivisa: "BAY0010",
			},
			bayonetaDoble: {
				id: "622b714328778806f0a4c7de",
				idRivisa: "BAY0018",
			},
		},

		{
			_id: "5b1e6996ca1df794edfce4f8",
			idRivisa: "BFA0130",
			tipoPanel: "5b212e4eca1df794edfeaa08",
			modelo: "FAX",
			posteExtremo: "LUX50",
			altura: "0m60",
			altura3d: "1m00",
			alturaValor: 600,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b1e69a7ca1df794edfce506",
			idRivisa: "BFA0120",
			tipoPanel: "5b212e4eca1df794edfeaa08",
			modelo: "FAX",
			posteExtremo: "LUX50",
			altura: "0m60",
			altura3d: "1m00",
			alturaValor: 600,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b1e69b4ca1df794edfce513",
			idRivisa: "BFA0140",
			tipoPanel: "5b212e4eca1df794edfeaa08",
			modelo: "FAX",
			posteExtremo: "LUX50",
			altura: "0m60",
			altura3d: "1m00",
			alturaValor: 600,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b1e69c7ca1df794edfce520",
			idRivisa: "BFA0131",
			tipoPanel: "5b212e57ca1df794edfeaa11",
			modelo: "FAX",
			posteExtremo: "LUX50",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b1e69deca1df794edfce533",
			tipoPanel: "5b212e57ca1df794edfeaa11",
			idRivisa: "BFA0121",
			modelo: "FAX",
			posteExtremo: "LUX50",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b1e69f0ca1df794edfce543",
			tipoPanel: "5b212e57ca1df794edfeaa11",
			idRivisa: "BFA0141",
			modelo: "FAX",
			posteExtremo: "LUX50",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b1e6a04ca1df794edfce551",
			tipoPanel: "5b212e60ca1df794edfeaa1a",
			idRivisa: "BFA0132",
			modelo: "FAX",
			posteExtremo: "LUX50",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b1e6a1aca1df794edfce563",
			tipoPanel: "5b212e60ca1df794edfeaa1a",
			idRivisa: "BFA0122",
			modelo: "FAX",
			posteExtremo: "LUX50",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b1e6a26ca1df794edfce56e",
			tipoPanel: "5b212e60ca1df794edfeaa1a",
			idRivisa: "BFA0142",
			modelo: "FAX",
			posteExtremo: "LUX50",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},

		{
			_id: "5b1e6a38ca1df794edfce577",
			tipoPanel: "5b212e6aca1df794edfeaa25",
			idRivisa: "BFA0133",
			modelo: "FAX",
			posteExtremo: "LUX50",
			altura: "1m43",
			altura3d: "1m00",
			alturaValor: 1430,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b1e6a43ca1df794edfce588",
			tipoPanel: "5b212e6aca1df794edfeaa25",
			idRivisa: "BFA0123",
			modelo: "FAX",
			posteExtremo: "LUX50",
			altura: "1m43",
			altura3d: "1m00",
			alturaValor: 1430,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b1e6a50ca1df794edfce599",
			tipoPanel: "5b212e6aca1df794edfeaa25",
			idRivisa: "BFA0143",
			modelo: "FAX",
			posteExtremo: "LUX50",
			altura: "1m43",
			altura3d: "1m00",
			alturaValor: 1430,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
		},
		{
			_id: "5b1e6a50ca1df794edfce501",
			tipoPanel: "5b212e6aca1df794edfeaa25",
			idRivisa: "BFA0253",
			modelo: "FAX",
			posteExtremo: "LUX50",
			altura: "1m43",
			altura3d: "1m00",
			alturaValor: 1430,
			color: ["5b16acd5ca1df794edf82198"],
		},

		{
			_id: "5b1e6a38ca1df794edfce57d",
			tipoPanel: "5b212e6aca1df794edfeaa24",
			idRivisa: "BFA0233",
			modelo: "FAX",
			posteExtremo: "LUX50",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b1e6a43ca1df794edfce585",
			tipoPanel: "5b212e6aca1df794edfeaa24",
			idRivisa: "BFA0223",
			modelo: "FAX",
			posteExtremo: "LUX50",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b1e6a50ca1df794edfce591",
			tipoPanel: "5b212e6aca1df794edfeaa24",
			idRivisa: "BFA0243",
			modelo: "FAX",
			posteExtremo: "LUX50",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},

		{
			_id: "5b1e6a38ca1df794edfce544",
			tipoPanel: "5b212e6aca1df794edfeaa48",
			idRivisa: "BFA0233",
			modelo: "FAX",
			posteExtremo: "LUX80",
			altura: "1m51",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b1e6a43ca1df794edfce555",
			tipoPanel: "5b212e6aca1df794edfeaa48",
			idRivisa: "BFA0223",
			modelo: "FAX",
			posteExtremo: "LUX80",
			altura: "1m51",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b1e6a50ca1df794edfce566",
			tipoPanel: "5b212e6aca1df794edfeaa48",
			idRivisa: "BFA0243",
			modelo: "FAX",
			posteExtremo: "LUX80",
			altura: "1m51",
			altura3d: "1m00",
			alturaValor: 1500,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},

		{
			_id: "5b1e6a62ca1df794edfce5a0",
			tipoPanel: "5b212e74ca1df794edfeaa2c",
			idRivisa: "BFA0134",
			modelo: "FAX",
			posteExtremo: "LUX80",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: ["5b16ab91ca1df794edf82088"],
			colorStr: "Blanco",
			bayoneta: { id: "5b447c00ca1df794ed16da7c", idRivisa: "BAY0003" },
			bayonetaDoble: {
				id: "5be40773ca1df794ed7c6359",
				idRivisa: "BAY0017",
			},
		},
		{
			_id: "5b1e6a71ca1df794edfce5ac",
			tipoPanel: "5b212e74ca1df794edfeaa2c",
			idRivisa: "BFA0124",
			modelo: "FAX",
			posteExtremo: "LUX80",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: ["595bb930060cda18c1334ed2"],
			colorStr: "Verde",
			bayoneta: { id: "5b447c6cca1df794ed16dae9", idRivisa: "BAY0001" },
			bayonetaDoble: {
				id: "62382763c631a51514e6152d",
				idRivisa: "BAY0016",
			},
		},
		{
			_id: "5b1e6a7bca1df794edfce5b4",
			tipoPanel: "5b212e74ca1df794edfeaa2c",
			idRivisa: "BFA0144",
			modelo: "FAX",
			posteExtremo: "LUX80",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			colorStr: "RAL",
			bayoneta: { id: "5b447ce0ca1df794ed16db5a", idRivisa: "BAY0007" },
			bayonetaDoble: {
				id: "5be405afca1df794ed7c61e6",
				idRivisa: "BAY0019",
			},
		},
		{
			_id: "62308f3746d79e1e8c060942",
			tipoPanel: "5b212e74ca1df794edfeaa2c",
			idRivisa: "BFA0144",
			modelo: "FAX",
			posteExtremo: "LUX80",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: ["5b16acd5ca1df794edf82198"],
			colorStr: "Antracita",
			bayoneta: { id: "622b713628778806f0a4c7dd", idRivisa: "BAY0010" },
			bayonetaDoble: {
				id: "622b714328778806f0a4c7de",
				idRivisa: "BAY0018",
			},
		},
		{
			_id: "5b1e6ab8ca1df794edfce5e3",
			tipoPanel: "5b2110cbca1df794edfe93e7",
			idRivisa: "BBR000805",
			modelo: "BRICO-FAX",
			posteExtremo: "LUX50",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b1e6ac1ca1df794edfce5ea",
			tipoPanel: "5b2110cbca1df794edfe93e7",
			idRivisa: "BBR000505",
			modelo: "BRICO-FAX",
			posteExtremo: "LUX50",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b1e6ad3ca1df794edfce5f9",
			tipoPanel: "5b2110cbca1df794edfe93e7",
			idRivisa: "BBR001105",
			modelo: "BRICO-FAX",
			posteExtremo: "LUX50",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b1e6ae8ca1df794edfce60b",
			tipoPanel: "5b2110c3ca1df794edfe93e0",
			idRivisa: "BBR000705",
			modelo: "BRICO-FAX",
			posteExtremo: "LUX50",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b1e6af9ca1df794edfce617",
			tipoPanel: "5b2110c3ca1df794edfe93e0",
			idRivisa: "BBR000405",
			modelo: "BRICO-FAX",
			posteExtremo: "LUX50",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b1e6b08ca1df794edfce624",
			tipoPanel: "5b2110c3ca1df794edfe93e0",
			idRivisa: "BBR001005",
			modelo: "BRICO-FAX",
			posteExtremo: "LUX50",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b1e6b16ca1df794edfce631",
			tipoPanel: "5b2110baca1df794edfe93d7",
			idRivisa: "BBR0007",
			modelo: "BRICO-FAX",
			posteExtremo: "LUX50",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b1e6b23ca1df794edfce63d",
			tipoPanel: "5b2110baca1df794edfe93d7",
			idRivisa: "BBR0004",
			modelo: "BRICO-FAX",
			posteExtremo: "LUX50",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b1e6b2fca1df794edfce645",
			tipoPanel: "5b2110baca1df794edfe93d7",
			idRivisa: "BBR0010",
			modelo: "BRICO-FAX",
			posteExtremo: "LUX50",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b1e6c4cca1df794edfce719",
			tipoPanel: "5b34b00cca1df794ed0b47fa",
			idRivisa: "BDH0135",
			modelo: "FAX DH",
			hilo: "8/6/8",
			posteExtremo: "LUX80",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16ab91ca1df794edf82088"],
			bayoneta: { id: "5b447c00ca1df794ed16da7c", idRivisa: "BAY0003" },
			bayonetaDoble: {
				id: "5be40773ca1df794ed7c6359",
				idRivisa: "BAY0017",
			},
		},
		{
			_id: "5b1e6c57ca1df794edfce723",
			tipoPanel: "5b34b00cca1df794ed0b47fa",
			idRivisa: "BDH0125",
			modelo: "FAX DH",
			hilo: "8/6/8",
			posteExtremo: "LUX80",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed2"],
			bayoneta: { id: "5b447c6cca1df794ed16dae9", idRivisa: "BAY0001" },
			bayonetaDoble: {
				id: "62382763c631a51514e6152d",
				idRivisa: "BAY0016",
			},
		},
		{
			_id: "5b1e6c62ca1df794edfce72b",
			tipoPanel: "5b34b00cca1df794ed0b47fa",
			idRivisa: "BDH0145",
			modelo: "FAX DH",
			hilo: "8/6/8",
			posteExtremo: "LUX80",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			colorStr: "RAL",
			bayoneta: { id: "5b447ce0ca1df794ed16db5a", idRivisa: "BAY0007" },
			bayonetaDoble: {
				id: "5be405afca1df794ed7c61e6",
				idRivisa: "BAY0019",
			},
		},

		{
			_id: "5b1e6c62ca1df794edfce799",
			tipoPanel: "5b34b00cca1df794ed0b47fa",
			idRivisa: "BDH0145",
			modelo: "FAX DH",
			hilo: "8/6/8",
			posteExtremo: "LUX80",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16acd5ca1df794edf82198"],
			bayoneta: { id: "622b713628778806f0a4c7dd", idRivisa: "BAY0010" },
			bayonetaDoble: {
				id: "622b714328778806f0a4c7de",
				idRivisa: "BAY0018",
			},
		},
		{
			_id: "5b1e6c79ca1df794edfce73c",
			tipoPanel: "5b34afefca1df794ed0b47da",
			idRivisa: "BDH0134",
			modelo: "FAX DH",
			hilo: "8/6/8",
			posteExtremo: "LUX80",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: ["5b16ab91ca1df794edf82088"],
			bayoneta: { id: "5b447c00ca1df794ed16da7c", idRivisa: "BAY0003" },
			bayonetaDoble: {
				id: "5be40773ca1df794ed7c6359",
				idRivisa: "BAY0017",
			},
		},
		{
			_id: "5b1e6c83ca1df794edfce749",
			tipoPanel: "5b34afefca1df794ed0b47da",
			idRivisa: "BDH0124",
			modelo: "FAX DH",
			hilo: "8/6/8",
			posteExtremo: "LUX80",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: ["595bb930060cda18c1334ed2"],
			bayoneta: { id: "5b447c6cca1df794ed16dae9", idRivisa: "BAY0001" },
			bayonetaDoble: {
				id: "62382763c631a51514e6152d",
				idRivisa: "BAY0016",
			},
		},
		{
			_id: "5b1e6c8eca1df794edfce752",
			tipoPanel: "5b34afefca1df794ed0b47da",
			idRivisa: "BDH0144",
			modelo: "FAX DH",
			hilo: "8/6/8",
			posteExtremo: "LUX80",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			colorStr: "RAL",
			bayoneta: { id: "5b447ce0ca1df794ed16db5a", idRivisa: "BAY0007" },
			bayonetaDoble: {
				id: "5be405afca1df794ed7c61e6",
				idRivisa: "BAY0019",
			},
		},
		{
			_id: "6231986446d79e1e8c060944",
			tipoPanel: "5b34b00cca1df794ed0b47fa",
			idRivisa: "BDH0145",
			modelo: "FAX DH",
			hilo: "8/6/8",
			posteExtremo: "LUX80",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16acd5ca1df794edf82198"],
			colorStr: "Antracita",
			bayoneta: {
				id: "622b713628778806f0a4c7dd",
				idRivisa: "BAY0010",
			},
			bayonetaDoble: {
				id: "622b714328778806f0a4c7de",
				idRivisa: "BAY0018",
			},
		},
		{
			_id: "6231a58646d79e1e8c060949",
			tipoPanel: "5b34afefca1df794ed0b47da",
			idRivisa: "BDH0144",
			modelo: "FAX DH",
			hilo: "8/6/8",
			posteExtremo: "LUX80",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: ["5b16acd5ca1df794edf82198"],
			colorStr: "Antracita",
			bayoneta: {
				id: "622b713628778806f0a4c7dd",
				idRivisa: "BAY0010",
			},
			bayonetaDoble: {
				id: "622b714328778806f0a4c7de",
				idRivisa: "BAY0018",
			},
		},
		{
			_id: "5b1e6c9fca1df794edfce75e",
			tipoPanel: "5b34afcaca1df794ed0b479f",
			idRivisa: "BDH0133",
			modelo: "FAX DH",
			hilo: "8/6/8",
			posteExtremo: "LUX80",
			altura: "1m60",
			altura3d: "2m00",
			alturaValor: 1600,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b1e6caaca1df794edfce768",
			tipoPanel: "5b34afcaca1df794ed0b479f",
			idRivisa: "BDH0123",
			modelo: "FAX DH",
			hilo: "8/6/8",
			posteExtremo: "LUX80",
			altura: "1m60",
			altura3d: "2m00",
			alturaValor: 1600,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b1e6cb4ca1df794edfce770",
			tipoPanel: "5b34afcaca1df794ed0b479f",
			idRivisa: "BDH0143",
			modelo: "FAX DH",
			hilo: "8/6/8",
			posteExtremo: "LUX80",
			altura: "1m60",
			altura3d: "2m00",
			alturaValor: 1600,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b1e6cc3ca1df794edfce77f",
			tipoPanel: "5b34afa5ca1df794ed0b4760",
			idRivisa: "BDH0132",
			modelo: "FAX DH",
			hilo: "8/6/8",
			posteExtremo: "LUX80",
			altura: "1m40",
			altura3d: "1m00",
			alturaValor: 1400,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b1e6cccca1df794edfce787",
			tipoPanel: "5b34afa5ca1df794ed0b4760",
			idRivisa: "BDH0122",
			modelo: "FAX DH",
			hilo: "8/6/8",
			posteExtremo: "LUX80",
			altura: "1m40",
			altura3d: "1m00",
			alturaValor: 1400,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b1e6cd7ca1df794edfce78f",
			tipoPanel: "5b34afa5ca1df794ed0b4760",
			idRivisa: "BDH0142",
			modelo: "FAX DH",
			hilo: "8/6/8",
			posteExtremo: "LUX80",
			altura: "1m40",
			altura3d: "1m00",
			alturaValor: 1400,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b1e6ceeca1df794edfce7a2",
			tipoPanel: "5b34af75ca1df794ed0b4735",
			idRivisa: "BDH0131",
			modelo: "FAX DH",
			hilo: "8/6/8",
			posteExtremo: "LUX50",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b1e6cfbca1df794edfce7af",
			tipoPanel: "5b34af75ca1df794ed0b4735",
			idRivisa: "BDH0121",
			modelo: "FAX DH",
			hilo: "8/6/8",
			posteExtremo: "LUX50",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b1e6d07ca1df794edfce7b8",
			tipoPanel: "5b34af75ca1df794ed0b4735",
			idRivisa: "BDH0141",
			modelo: "FAX DH",
			hilo: "8/6/8",
			posteExtremo: "LUX50",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b1e6d1bca1df794edfce7c7",
			tipoPanel: "5b34ad17ca1df794ed0b44a1",
			idRivisa: "BDH0130",
			modelo: "FAX DH",
			hilo: "8/6/8",
			posteExtremo: "LUX50",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b1e6d27ca1df794edfce7d1",
			tipoPanel: "5b34ad17ca1df794ed0b44a1",
			idRivisa: "BDH0120",
			modelo: "FAX DH",
			hilo: "8/6/8",
			posteExtremo: "LUX50",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b1e6d31ca1df794edfce7db",
			tipoPanel: "5b34ad17ca1df794ed0b44a1",
			idRivisa: "BDH0140",
			modelo: "FAX DH",
			hilo: "8/6/8",
			posteExtremo: "LUX50",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b1e6d42ca1df794edfce7ea",
			tipoPanel: "5b2217cfca1df794edff3a13",
			idRivisa: "BDH0035",
			modelo: "FAX DH",
			hilo: "6/5/6",
			posteExtremo: "LUX80",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16ab91ca1df794edf82088"],
			bayoneta: { id: "5b447c00ca1df794ed16da7c", idRivisa: "BAY0003" },
			bayonetaDoble: {
				id: "5be40773ca1df794ed7c6359",
				idRivisa: "BAY0017",
			},
		},
		{
			_id: "5b1e6d4cca1df794edfce7f2",
			tipoPanel: "5b2217cfca1df794edff3a13",
			idRivisa: "BDH0025",
			modelo: "FAX DH",
			hilo: "6/5/6",
			posteExtremo: "LUX80",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed2"],
			bayoneta: { id: "5b447c6cca1df794ed16dae9", idRivisa: "BAY0001" },
			bayonetaDoble: {
				id: "62382763c631a51514e6152d",
				idRivisa: "BAY0016",
			},
		},
		{
			_id: "5b1e6d58ca1df794edfce7fb",
			tipoPanel: "5b2217cfca1df794edff3a13",
			idRivisa: "BDH0045",
			modelo: "FAX DH",
			hilo: "6/5/6",
			posteExtremo: "LUX80",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			colorStr: "RAL",
			bayoneta: { id: "5b447ce0ca1df794ed16db5a", idRivisa: "BAY0007" },
			bayonetaDoble: {
				id: "5be405afca1df794ed7c61e6",
				idRivisa: "BAY0019",
			},
		},
		{
			_id: "6231987146d79e1e8c060945",
			tipoPanel: "5b2217cfca1df794edff3a13",
			idRivisa: "BDH0045",
			modelo: "FAX DH",
			hilo: "6/5/6",
			posteExtremo: "LUX80",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16acd5ca1df794edf82198"],
			colorStr: "Antracita",
			bayoneta: {
				id: "622b713628778806f0a4c7dd",
				idRivisa: "BAY0010",
			},
			bayonetaDoble: {
				id: "622b714328778806f0a4c7de",
				idRivisa: "BAY0018",
			},
		},
		{
			_id: "5b1e6d65ca1df794edfce807",
			tipoPanel: "5b2217c7ca1df794edff3a0d",
			idRivisa: "BDH0034",
			modelo: "FAX DH",
			hilo: "6/5/6",
			posteExtremo: "LUX80",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: ["5b16ab91ca1df794edf82088"],
			bayoneta: { id: "5b447c00ca1df794ed16da7c", idRivisa: "BAY0003" },
			bayonetaDoble: {
				id: "5be40773ca1df794ed7c6359",
				idRivisa: "BAY0017",
			},
		},
		{
			_id: "5b1e6d6eca1df794edfce810",
			tipoPanel: "5b2217c7ca1df794edff3a0d",
			idRivisa: "BDH0024",
			modelo: "FAX DH",
			hilo: "6/5/6",
			posteExtremo: "LUX80",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: ["595bb930060cda18c1334ed2"],
			bayoneta: { id: "5b447c6cca1df794ed16dae9", idRivisa: "BAY0001" },
			bayonetaDoble: {
				id: "62382763c631a51514e6152d",
				idRivisa: "BAY0016",
			},
		},
		{
			_id: "5b1e6d78ca1df794edfce819",
			tipoPanel: "5b2217c7ca1df794edff3a0d",
			idRivisa: "BDH0044",
			modelo: "FAX DH",
			hilo: "6/5/6",
			posteExtremo: "LUX80",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			colorStr: "RAL",
			bayoneta: { id: "5b447ce0ca1df794ed16db5a", idRivisa: "BAY0007" },
			bayonetaDoble: {
				id: "5be405afca1df794ed7c61e6",
				idRivisa: "BAY0019",
			},
		},
		{
			_id: "6231987e46d79e1e8c060946",
			tipoPanel: "5b2217c7ca1df794edff3a0d",
			idRivisa: "BDH0044",
			modelo: "FAX DH",
			hilo: "6/5/6",
			posteExtremo: "LUX80",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: ["5b16acd5ca1df794edf82198"],
			colorStr: "Antracita",
			bayoneta: {
				id: "622b713628778806f0a4c7dd",
				idRivisa: "BAY0010",
			},
			bayonetaDoble: {
				id: "622b714328778806f0a4c7de",
				idRivisa: "BAY0018",
			},
		},

		{
			_id: "5b1e6d89ca1df794edfce826",
			tipoPanel: "5b2217beca1df794edff3a03",
			idRivisa: "BDH0033",
			modelo: "FAX DH",
			hilo: "6/5/6",
			posteExtremo: "LUX80",
			altura: "1m60",
			altura3d: "2m00",
			alturaValor: 1600,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b1e6d95ca1df794edfce82f",
			tipoPanel: "5b2217beca1df794edff3a03",
			idRivisa: "BDH0023",
			modelo: "FAX DH",
			hilo: "6/5/6",
			posteExtremo: "LUX80",
			altura: "1m60",
			altura3d: "2m00",
			alturaValor: 1600,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b1e6d9fca1df794edfce839",
			tipoPanel: "5b2217beca1df794edff3a03",
			idRivisa: "BDH0043",
			modelo: "FAX DH",
			hilo: "6/5/6",
			posteExtremo: "LUX80",
			altura: "1m60",
			altura3d: "2m00",
			alturaValor: 1600,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b1e6db1ca1df794edfce84a",
			tipoPanel: "5b2217b6ca1df794edff39fa",
			idRivisa: "BDH0032",
			modelo: "FAX DH",
			hilo: "6/5/6",
			posteExtremo: "LUX80",
			altura: "1m40",
			altura3d: "1m00",
			alturaValor: 1400,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b1e6db9ca1df794edfce850",
			tipoPanel: "5b2217b6ca1df794edff39fa",
			idRivisa: "BDH0022",
			modelo: "FAX DH",
			hilo: "6/5/6",
			posteExtremo: "LUX80",
			altura: "1m40",
			altura3d: "1m00",
			alturaValor: 1400,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b1e6dc2ca1df794edfce858",
			tipoPanel: "5b2217b6ca1df794edff39fa",
			idRivisa: "BDH0042",
			modelo: "FAX DH",
			hilo: "6/5/6",
			posteExtremo: "LUX80",
			altura: "1m40",
			altura3d: "1m00",
			alturaValor: 1400,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b1e6dcfca1df794edfce862",
			tipoPanel: "5b221875ca1df794edff3aa3",
			idRivisa: "BDH0031",
			modelo: "FAX DH",
			hilo: "6/5/6",
			posteExtremo: "LUX50",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b1e6dd7ca1df794edfce86a",
			tipoPanel: "5b221875ca1df794edff3aa3",
			idRivisa: "BDH0021",
			modelo: "FAX DH",
			hilo: "6/5/6",
			posteExtremo: "LUX50",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b1e6de0ca1df794edfce872",
			tipoPanel: "5b221875ca1df794edff3aa3",
			idRivisa: "BDH0041",
			modelo: "FAX DH",
			hilo: "6/5/6",
			posteExtremo: "LUX50",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b1e6df4ca1df794edfce884",
			tipoPanel: "5b2217a2ca1df794edff39e9",
			idRivisa: "BDH0030",
			modelo: "FAX DH",
			hilo: "6/5/6",
			posteExtremo: "LUX50",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b1e6dfdca1df794edfce88c",
			tipoPanel: "5b2217a2ca1df794edff39e9",
			idRivisa: "BDH0020",
			modelo: "FAX DH",
			hilo: "6/5/6",
			posteExtremo: "LUX50",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b1e6e07ca1df794edfce894",
			tipoPanel: "5b2217a2ca1df794edff39e9",
			idRivisa: "BDH0040",
			modelo: "FAX DH",
			hilo: "6/5/6",
			posteExtremo: "LUX50",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b1e6fadca1df794edfce9e4",
			tipoPanel: "5b221f6eca1df794edff4049",
			idRivisa: "BSF0060",
			modelo: "MAXI FAX",
			posteExtremo: "LUX80",
			altura: "2m40",
			altura3d: "2m00",
			alturaValor: 2400,
			color: ["5b16ab91ca1df794edf82088"],
			bayoneta: { id: "5b447c00ca1df794ed16da7c", idRivisa: "BAY0003" },
			bayonetaDoble: {
				id: "5be40773ca1df794ed7c6359",
				idRivisa: "BAY0017",
			},
		},
		{
			_id: "5b1e6fb7ca1df794edfce9ee",
			tipoPanel: "5b221f6eca1df794edff4049",
			idRivisa: "BSF0040",
			modelo: "MAXI FAX",
			posteExtremo: "LUX80",
			altura: "2m40",
			altura3d: "2m00",
			alturaValor: 2400,
			color: ["595bb930060cda18c1334ed2"],
			bayoneta: { id: "5b447c6cca1df794ed16dae9", idRivisa: "BAY0001" },
			bayonetaDoble: {
				id: "62382763c631a51514e6152d",
				idRivisa: "BAY0016",
			},
		},
		{
			_id: "5b1e6fc2ca1df794edfce9f8",
			tipoPanel: "5b221f6eca1df794edff4049",
			idRivisa: "BSF0080",
			modelo: "MAXI FAX",
			posteExtremo: "LUX80",
			altura: "2m40",
			altura3d: "2m00",
			alturaValor: 2400,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			colorStr: "RAL",
			bayoneta: { id: "5b447ce0ca1df794ed16db5a", idRivisa: "BAY0007" },
			bayonetaDoble: {
				id: "5be405afca1df794ed7c61e6",
				idRivisa: "BAY0019",
			},
		},
		{
			_id: "6231988846d79e1e8c060947",
			tipoPanel: "5b221f6eca1df794edff4049",
			idRivisa: "BSF0080",
			modelo: "MAXI FAX",
			posteExtremo: "LUX80",
			altura: "2m40",
			altura3d: "2m00",
			alturaValor: 2400,
			color: ["5b16acd5ca1df794edf82198"],
			colorStr: "Antracita",
			bayoneta: {
				id: "622b713628778806f0a4c7dd",
				idRivisa: "BAY0010",
			},
			bayonetaDoble: {
				id: "622b714328778806f0a4c7de",
				idRivisa: "BAY0018",
			},
		},

		{
			_id: "5b1e6fd4ca1df794edfcea04",
			tipoPanel: "5b221f67ca1df794edff4040",
			idRivisa: "BSF0055",
			modelo: "MAXI FAX",
			posteExtremo: "LUX80",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16ab91ca1df794edf82088"],
			bayoneta: { id: "5b447c00ca1df794ed16da7c", idRivisa: "BAY0003" },
			bayonetaDoble: {
				id: "5be40773ca1df794ed7c6359",
				idRivisa: "BAY0017",
			},
		},
		{
			_id: "5b1e6fe5ca1df794edfcea10",
			tipoPanel: "5b221f67ca1df794edff4040",
			idRivisa: "BSF0035",
			modelo: "MAXI FAX",
			posteExtremo: "LUX80",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed2"],
			bayoneta: { id: "5b447c6cca1df794ed16dae9", idRivisa: "BAY0001" },
			bayonetaDoble: {
				id: "62382763c631a51514e6152d",
				idRivisa: "BAY0016",
			},
		},
		{
			_id: "5b1e6fefca1df794edfcea1b",
			tipoPanel: "5b221f67ca1df794edff4040",
			idRivisa: "BSF0075",
			modelo: "MAXI FAX",
			posteExtremo: "LUX80",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			colorStr: "RAL",
			bayoneta: { id: "5b447ce0ca1df794ed16db5a", idRivisa: "BAY0007" },
			bayonetaDoble: {
				id: "5be405afca1df794ed7c61e6",
				idRivisa: "BAY0019",
			},
		},
		{
			_id: "6231989646d79e1e8c060948",
			tipoPanel: "5b221f67ca1df794edff4040",
			idRivisa: "BSF0075",
			modelo: "MAXI FAX",
			posteExtremo: "LUX80",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16acd5ca1df794edf82198"],
			colorStr: "Antracita",
			bayoneta: {
				id: "622b713628778806f0a4c7dd",
				idRivisa: "BAY0010",
			},
			bayonetaDoble: {
				id: "622b714328778806f0a4c7de",
				idRivisa: "BAY0018",
			},
		},

		{
			_id: "5b1e7008ca1df794edfcea2b",
			tipoPanel: "5b221f5fca1df794edff403a",
			idRivisa: "BSF0050",
			modelo: "MAXI FAX",
			posteExtremo: "LUX80",
			altura: "1m50",
			altura3d: "2m00",
			alturaValor: 1500,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b1e7012ca1df794edfcea33",
			tipoPanel: "5b221f5fca1df794edff403a",
			idRivisa: "BSF0030",
			modelo: "MAXI FAX",
			posteExtremo: "LUX80",
			altura: "1m50",
			altura3d: "2m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b1e701aca1df794edfcea45",
			tipoPanel: "5b221f5fca1df794edff403a",
			idRivisa: "BSF0070",
			modelo: "MAXI FAX",
			posteExtremo: "LUX80",
			altura: "1m50",
			altura3d: "2m00",
			alturaValor: 1500,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b1e7028ca1df794edfcea55",
			idRivisa: "BSF0045",
			modelo: "MAXI FAX",
			altura: "0m60",
			posteExtremo: "LUX80",
			altura3d: "0m60",
			alturaValor: 600,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b1e7032ca1df794edfcea61",
			idRivisa: "BSF0025",
			modelo: "MAXI FAX",
			altura: "0m60",
			altura3d: "0m60",
			posteExtremo: "LUX80",
			alturaValor: 600,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b1e703bca1df794edfcea68",
			idRivisa: "BSF0065",
			modelo: "MAXI FAX",
			posteExtremo: "LUX80",
			altura: "0m60",
			altura3d: "0m60",
			alturaValor: 600,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b1e704eca1df794edfcea84",
			idRivisa: "BSF0044",
			modelo: "MAXI FAX",
			posteExtremo: "LUX80",
			altura: "0m40",
			altura3d: "0m40",
			alturaValor: 400,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b1e7057ca1df794edfcea92",
			idRivisa: "BSF0024",
			modelo: "MAXI FAX",
			posteExtremo: "LUX80",
			altura: "0m40",
			altura3d: "0m40",
			alturaValor: 400,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b1e7061ca1df794edfceaa1",
			idRivisa: "BSF0064",
			modelo: "MAXI FAX",
			posteExtremo: "LUX80",
			altura: "0m40",
			altura3d: "0m40",
			alturaValor: 400,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b20f787ca1df794edfe8182",
			tipoPanel: "5b222453ca1df794edff4459",
			idRivisa: "BRI0036",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "2m40",
			altura3d: "2m00",
			alturaValor: 2400,
			color: ["5b16ab91ca1df794edf82088"],
			bayoneta: { id: "5b447d5eca1df794ed16dbd6", idRivisa: "BAY0057" },
		},
		{
			_id: "5b20f79aca1df794edfe818f",
			tipoPanel: "5b222453ca1df794edff4459",
			idRivisa: "BRI0026",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "2m40",
			altura3d: "2m00",
			alturaValor: 2400,
			color: ["595bb930060cda18c1334ed2"],
			bayoneta: { id: "5b447dc8ca1df794ed16dc3f", idRivisa: "BAY0056" },
		},
		{
			_id: "5b20f7a4ca1df794edfe8199",
			tipoPanel: "5b222453ca1df794edff4459",
			idRivisa: "BRI0046",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "2m40",
			altura3d: "2m00",
			alturaValor: 2400,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			bayoneta: { id: "5b447e2bca1df794ed16dca1", idRivisa: "BAY0058" },
		},
		{
			_id: "62385bdac631a51514e6152f",
			tipoPanel: "5b222453ca1df794edff4459",
			idRivisa: "BRI0026",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "2m40",
			altura3d: "2m00",
			alturaValor: 2400,
			color: ["5b16acd5ca1df794edf82198"],
			bayoneta: { id: "622b715c28778806f0a4c7e0", idRivisa: "BAY0059" },
		},

		{
			_id: "5b20f7cbca1df794edfe81b4",
			tipoPanel: "5b22244cca1df794edff4453",
			idRivisa: "BRI0035",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16ab91ca1df794edf82088"],
			bayoneta: { id: "5b447d5eca1df794ed16dbd6", idRivisa: "BAY0057" },
		},
		{
			_id: "5b20f7d8ca1df794edfe81bd",
			tipoPanel: "5b22244cca1df794edff4453",
			idRivisa: "BRI0025",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed2"],
			bayoneta: { id: "5b447dc8ca1df794ed16dc3f", idRivisa: "BAY0056" },
		},
		{
			_id: "5b20f7e2ca1df794edfe81c7",
			tipoPanel: "5b22244cca1df794edff4453",
			idRivisa: "BRI0045",
			modelo: "RITMO",
			altura: "2m00",
			posteExtremo: "RITMO",
			altura3d: "2m00",
			alturaValor: 2000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			bayoneta: { id: "5b447e2bca1df794ed16dca1", idRivisa: "BAY0058" },
		},
		{
			_id: "62385debc631a51514e61531",
			tipoPanel: "5b22244cca1df794edff4453",
			idRivisa: "BRI0025",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16acd5ca1df794edf82198"],
			bayoneta: { id: "622b715c28778806f0a4c7e0", idRivisa: "BAY0059" },
		},

		{
			_id: "5b20f7cbca1df794edfe81b4",
			tipoPanel: "5b22244cca1df794edff4477",
			idRivisa: "BRIT026",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "2m01",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16ab91ca1df794edf82088"],
			bayoneta: { id: "5b447d5eca1df794ed16dbd6", idRivisa: "BAY0057" },
		},
		{
			_id: "5b20f7d8ca1df794edfe81bd",
			tipoPanel: "5b22244cca1df794edff4477",
			idRivisa: "BRIT016",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "2m01",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed2"],
			bayoneta: { id: "5b447dc8ca1df794ed16dc3f", idRivisa: "BAY0056" },
		},
		{
			_id: "5b20f7e2ca1df794edfe81c7",
			tipoPanel: "5b22244cca1df794edff4477",
			idRivisa: "BRIT036",
			modelo: "RITMO",
			altura: "2m01",
			posteExtremo: "RITMO",
			altura3d: "2m00",
			alturaValor: 2000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			bayoneta: { id: "5b447e2bca1df794ed16dca1", idRivisa: "BAY0058" },
		},
		{
			_id: "62385debc631a51514e61531",
			tipoPanel: "5b22244cca1df794edff4477",
			idRivisa: "BRIT046",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "2m01",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16acd5ca1df794edf82198"],
			bayoneta: { id: "622b715c28778806f0a4c7e0", idRivisa: "BAY0059" },
		},

		{
			_id: "5b20f7cbca1df794edfe8114",
			tipoPanel: "5b22244cca1df794edff4455",
			idRivisa: "BRI003501",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "2m03",
			altura3d: "2m03",
			alturaValor: 2030,
			color: ["5b16ab91ca1df794edf82088"],
			bayoneta: { id: "5b447d5eca1df794ed16dbd6", idRivisa: "BAY0057" },
		},
		{
			_id: "5b20f7d8ca1df794edfe811d",
			tipoPanel: "5b22244cca1df794edff4455",
			idRivisa: "BRI002501",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "2m03",
			altura3d: "2m03",
			alturaValor: 2030,
			color: ["595bb930060cda18c1334ed2"],
			bayoneta: { id: "5b447dc8ca1df794ed16dc3f", idRivisa: "BAY0056" },
		},
		{
			_id: "5b20f7e2ca1df794edfe8117",
			tipoPanel: "5b22244cca1df794edff4455",
			idRivisa: "BRI004501",
			modelo: "RITMO",
			altura: "2m03",
			posteExtremo: "RITMO",
			altura3d: "2m03",
			alturaValor: 2030,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			bayoneta: { id: "5b447e2bca1df794ed16dca1", idRivisa: "BAY0058" },
		},
		{
			_id: "62385debc631a51514e61551",
			tipoPanel: "5b22244cca1df794edff4455",
			idRivisa: "BRI005501",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "2m03",
			altura3d: "2m03",
			alturaValor: 2030,
			color: ["5b16acd5ca1df794edf82198"],
			bayoneta: { id: "622b715c28778806f0a4c7e0", idRivisa: "BAY0059" },
		},

		{
			_id: "5b20f7f5ca1df794edfe81d5",
			tipoPanel: "5b222444ca1df794edff4449",
			idRivisa: "BRI0034",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: ["5b16ab91ca1df794edf82088"],
			bayoneta: { id: "5b447d5eca1df794ed16dbd6", idRivisa: "BAY0057" },
		},
		{
			_id: "5b20f7ffca1df794edfe81dc",
			tipoPanel: "5b222444ca1df794edff4449",
			idRivisa: "BRI0024",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: ["595bb930060cda18c1334ed2"],
			bayoneta: { id: "5b447dc8ca1df794ed16dc3f", idRivisa: "BAY0056" },
		},
		{
			_id: "5b20f80aca1df794edfe81e5",
			tipoPanel: "5b222444ca1df794edff4449",
			idRivisa: "BRI0044",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			bayoneta: { id: "5b447e2bca1df794ed16dca1", idRivisa: "BAY0058" },
		},
		{
			_id: "62385ec6c631a51514e61532",
			tipoPanel: "5b222444ca1df794edff4449",
			idRivisa: "BRI0024",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: ["5b16acd5ca1df794edf82198"],
			bayoneta: { id: "622b715c28778806f0a4c7e0", idRivisa: "BAY0059" },
		},

		{
			_id: "5b20f7f5ca1df794edfe81dd",
			tipoPanel: "5b222444ca1df794edff4666",
			idRivisa: "BRIT025",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m81",
			altura3d: "2m00",
			alturaValor: 1800,
			color: ["5b16ab91ca1df794edf82088"],
			bayoneta: { id: "5b447d5eca1df794ed16dbd6", idRivisa: "BAY0057" },
		},
		{
			_id: "5b20f7ffca1df794edfe81dd",
			tipoPanel: "5b222444ca1df794edff4666",
			idRivisa: "BRIT015",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m81",
			altura3d: "2m00",
			alturaValor: 1800,
			color: ["595bb930060cda18c1334ed2"],
			bayoneta: { id: "5b447dc8ca1df794ed16dc3f", idRivisa: "BAY0056" },
		},
		{
			_id: "5b20f80aca1df794edfe81ee",
			tipoPanel: "5b222444ca1df794edff4666",
			idRivisa: "BRIT035",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m81",
			altura3d: "2m00",
			alturaValor: 1800,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			bayoneta: { id: "5b447e2bca1df794ed16dca1", idRivisa: "BAY0058" },
		},
		{
			_id: "62385ec6c631a51514e61533",
			tipoPanel: "5b222444ca1df794edff4666",
			idRivisa: "BRIT045",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m81",
			altura3d: "2m00",
			alturaValor: 1800,
			color: ["5b16acd5ca1df794edf82198"],
			bayoneta: { id: "622b715c28778806f0a4c7e0", idRivisa: "BAY0059" },
		},

		{
			_id: "5b20f81bca1df794edfe8133",
			tipoPanel: "5b222438ca1df794edff4433",
			idRivisa: "BRI0033",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m43",
			altura3d: "1m43",
			alturaValor: 1430,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b20f826ca1df794edfe81cc",
			tipoPanel: "5b222438ca1df794edff4433",
			idRivisa: "BRI0023",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m43",
			altura3d: "1m43",
			alturaValor: 1430,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b20f830ca1df794edfe8244",
			tipoPanel: "5b222438ca1df794edff4433",
			idRivisa: "BRI0043",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m43",
			altura3d: "1m43",
			alturaValor: 1430,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},

		{
			_id: "5b20f81bca1df794edfe81f3",
			tipoPanel: "5b222438ca1df794edff443f",
			idRivisa: "BRI0135",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m50",
			altura3d: "1m50",
			alturaValor: 1500,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b20f826ca1df794edfe81fc",
			tipoPanel: "5b222438ca1df794edff443f",
			idRivisa: "BRI0125",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m50",
			altura3d: "1m50",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b20f830ca1df794edfe8204",
			tipoPanel: "5b222438ca1df794edff443f",
			idRivisa: "BRI0145",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m50",
			altura3d: "1m50",
			alturaValor: 1500,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
		},
		{
			_id: "5b20f830ca1df794edfe8236",
			tipoPanel: "5b222438ca1df794edff443f",
			idRivisa: "BRI0155",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m50",
			altura3d: "1m50",
			alturaValor: 1500,
			color: ["5b16acd5ca1df794edf82198"],
		},

		{
			_id: "5b20f81bca1df794edfe81f4",
			tipoPanel: "5b222438ca1df794edff4555",
			idRivisa: "BRIT024",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m51",
			altura3d: "1m50",
			alturaValor: 1500,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b20f826ca1df794edfe81fd",
			tipoPanel: "5b222438ca1df794edff4555",
			idRivisa: "BRIT014",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m51",
			altura3d: "1m50",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b20f830ca1df794edfe820",
			tipoPanel: "5b222438ca1df794edff4555",
			idRivisa: "BRIT034",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m51",
			altura3d: "1m50",
			alturaValor: 1500,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
		},
		{
			_id: "5b20f830ca1df794edfe825",
			tipoPanel: "5b222438ca1df794edff4555",
			idRivisa: "BRIT044",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m51",
			altura3d: "1m50",
			alturaValor: 1500,
			color: ["5b16acd5ca1df794edf82198"],
		},

		{
			_id: "5b20f841ca1df794edfe8210",
			tipoPanel: "5b222430ca1df794edff4435",
			idRivisa: "BRI0032",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b20f84bca1df794edfe8218",
			tipoPanel: "5b222430ca1df794edff4435",
			idRivisa: "BRI0022",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b20f857ca1df794edfe8224",
			tipoPanel: "5b222430ca1df794edff4435",
			idRivisa: "BRI0042",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},

		{
			_id: "5b20f841ca1df794edfe8232",
			tipoPanel: "5b222430ca1df794edff4555",
			idRivisa: "BRIT022",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m21",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b20f84bca1df794edfe8233",
			tipoPanel: "5b222430ca1df794edff4555",
			idRivisa: "BRIT012",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m21",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b20f857ca1df794edfe8234",
			tipoPanel: "5b222430ca1df794edff4555",
			idRivisa: "BRIT032",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m21",
			altura3d: "1m00",
			alturaValor: 1200,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
		},
		{
			_id: "5b20f857ca1df794edfe8235",
			tipoPanel: "5b222430ca1df794edff4555",
			idRivisa: "BRIT042",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m21",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["5b16acd5ca1df794edf82198"],
		},

		{
			_id: "5b20f869ca1df794edfe8230",
			tipoPanel: "5b222428ca1df794edff442f",
			idRivisa: "BRI0031",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b20f874ca1df794edfe8238",
			tipoPanel: "5b222428ca1df794edff442f",
			idRivisa: "BRI0021",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b20f87eca1df794edfe8241",
			tipoPanel: "5b222428ca1df794edff442f",
			idRivisa: "BRI0041",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},

		{
			_id: "5b20f869ca1df794edfe8242",
			tipoPanel: "5b222428ca1df794edff4fff",
			idRivisa: "BRIT021",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m01",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b20f874ca1df794edfe8244",
			tipoPanel: "5b222428ca1df794edff4fff",
			idRivisa: "BRIT011",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m01",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b20f87eca1df794edfe8246",
			tipoPanel: "5b222428ca1df794edff4fff",
			idRivisa: "BRIT031",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m01",
			altura3d: "1m00",
			alturaValor: 1000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
		},
		{
			_id: "5b20f87eca1df794edfe8248",
			tipoPanel: "5b222428ca1df794edff4fff",
			idRivisa: "BRIT041",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "1m01",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["5b16acd5ca1df794edf82198"],
		},

		{
			_id: "5b20f891ca1df794edfe824e",
			tipoPanel: "5b222420ca1df794edff4426",
			idRivisa: "BRI003005",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "0m80",
			altura3d: "1m00",
			alturaValor: 800,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b20f89fca1df794edfe825b",
			tipoPanel: "5b222420ca1df794edff4426",
			idRivisa: "BRI002005",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "0m80",
			altura3d: "1m00",
			alturaValor: 800,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b20f8aaca1df794edfe8263",
			tipoPanel: "5b222420ca1df794edff4426",
			idRivisa: "BRI004005",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "0m80",
			altura3d: "1m00",
			alturaValor: 800,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b20f8bbca1df794edfe826f",
			tipoPanel: "5b222418ca1df794edff441e",
			idRivisa: "BRI0030",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "0m60",
			altura3d: "0m60",
			alturaValor: 600,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b20f8c8ca1df794edfe8279",
			tipoPanel: "5b222418ca1df794edff441e",
			idRivisa: "BRI0020",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "0m60",
			altura3d: "0m60",
			alturaValor: 600,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b20f8d1ca1df794edfe8283",
			tipoPanel: "5b222418ca1df794edff441e",
			idRivisa: "BRI0040",
			modelo: "RITMO",
			posteExtremo: "RITMO",
			altura: "0m60",
			altura3d: "0m60",
			alturaValor: 600,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b20f9e1ca1df794edfe8349",
			tipoPanel: "5b22273bca1df794edff46d1",
			idRivisa: "BDH0034",
			modelo: "RITMO DH",
			posteExtremo: "RITMO",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: ["5b16ab91ca1df794edf82088"],
			bayoneta: { id: "5b447d5eca1df794ed16dbd6", idRivisa: "BAY0057" },
		},
		{
			_id: "5b20f9eaca1df794edfe8351",
			tipoPanel: "5b22273bca1df794edff46d1",
			idRivisa: "BDH0024",
			modelo: "RITMO DH",
			posteExtremo: "RITMO",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: ["595bb930060cda18c1334ed2"],
			bayoneta: { id: "5b447dc8ca1df794ed16dc3f", idRivisa: "BAY0056" },
		},
		{
			_id: "5b20f9f4ca1df794edfe8359",
			tipoPanel: "5b22273bca1df794edff46d1",
			idRivisa: "BDH0044",
			modelo: "RITMO DH",
			posteExtremo: "RITMO",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			bayoneta: { id: "5b447e2bca1df794ed16dca1", idRivisa: "BAY0058" },
		},
		{
			_id: "6238605ac631a51514e61533",
			tipoPanel: "5b22273bca1df794edff46d1",
			idRivisa: "BDH0024",
			modelo: "RITMO DH",
			posteExtremo: "RITMO",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: ["5b16acd5ca1df794edf82198"],
			bayoneta: { id: "622b715c28778806f0a4c7e0", idRivisa: "BAY0059" },
		},
		{
			_id: "5b20fa05ca1df794edfe8367",
			tipoPanel: "5b222732ca1df794edff46c7",
			idRivisa: "BDH0033",
			modelo: "RITMO DH",
			posteExtremo: "RITMO",
			altura: "1m60",
			altura3d: "2m00",
			alturaValor: 1600,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b20fa0fca1df794edfe836f",
			tipoPanel: "5b222732ca1df794edff46c7",
			idRivisa: "BDH0023",
			modelo: "RITMO DH",
			posteExtremo: "RITMO",
			altura: "1m60",
			altura3d: "2m00",
			alturaValor: 1600,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b20fa1bca1df794edfe8378",
			tipoPanel: "5b222732ca1df794edff46c7",
			idRivisa: "BDH0043",
			modelo: "RITMO DH",
			posteExtremo: "RITMO",
			altura: "1m60",
			altura3d: "2m00",
			alturaValor: 1600,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b20fa2dca1df794edfe8385",
			tipoPanel: "5b222729ca1df794edff46c0",
			idRivisa: "BDH0032",
			modelo: "RITMO DH",
			posteExtremo: "RITMO",
			altura: "1m40",
			altura3d: "1m00",
			alturaValor: 1400,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b20fa38ca1df794edfe8390",
			tipoPanel: "5b222729ca1df794edff46c0",
			idRivisa: "BDH0022",
			modelo: "RITMO DH",
			posteExtremo: "RITMO",
			altura: "1m40",
			altura3d: "1m00",
			alturaValor: 1400,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b20fa41ca1df794edfe8397",
			tipoPanel: "5b222729ca1df794edff46c0",
			idRivisa: "BDH0042",
			modelo: "RITMO DH",
			posteExtremo: "RITMO",
			altura: "1m40",
			altura3d: "1m00",
			alturaValor: 1400,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b20fa4eca1df794edfe83a1",
			tipoPanel: "5b222721ca1df794edff46b8",
			idRivisa: "BDH0031",
			modelo: "RITMO DH",
			posteExtremo: "RITMO",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b20fa57ca1df794edfe83a8",
			tipoPanel: "5b222721ca1df794edff46b8",
			idRivisa: "BDH0021",
			modelo: "RITMO DH",
			posteExtremo: "RITMO",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b20fa60ca1df794edfe83b0",
			tipoPanel: "5b222721ca1df794edff46b8",
			idRivisa: "BDH0041",
			modelo: "RITMO DH",
			posteExtremo: "RITMO",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b20fa6eca1df794edfe83ba",
			tipoPanel: "5b222718ca1df794edff46b0",
			idRivisa: "BDH0030",
			modelo: "RITMO DH",
			posteExtremo: "RITMO",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b20fa78ca1df794edfe83c4",
			tipoPanel: "5b222718ca1df794edff46b0",
			idRivisa: "BDH0020",
			modelo: "RITMO DH",
			posteExtremo: "RITMO",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b20fa82ca1df794edfe83cc",
			tipoPanel: "5b222718ca1df794edff46b0",
			idRivisa: "BDH0040",
			modelo: "RITMO DH",
			posteExtremo: "RITMO",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b20fb49ca1df794edfe8462",
			tipoPanel: "5b222744ca1df794edff46db",
			idRivisa: "BDH0035",
			modelo: "RITMO DH",
			posteExtremo: "RITMO",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16ab91ca1df794edf82088"],
			bayoneta: { id: "5b447d5eca1df794ed16dbd6", idRivisa: "BAY0057" },
		},
		{
			_id: "5b20fb5aca1df794edfe846e",
			tipoPanel: "5b222744ca1df794edff46db",
			idRivisa: "BDH0025",
			modelo: "RITMO DH",
			posteExtremo: "RITMO",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed2"],
			bayoneta: { id: "5b447dc8ca1df794ed16dc3f", idRivisa: "BAY0056" },
		},
		{
			_id: "5b20fb66ca1df794edfe8479",
			tipoPanel: "5b222744ca1df794edff46db",
			idRivisa: "BDH0045",
			modelo: "RITMO DH",
			posteExtremo: "RITMO",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			bayoneta: { id: "5b447e2bca1df794ed16dca1", idRivisa: "BAY0058" },
		},
		{
			_id: "62386232c631a51514e61534",
			tipoPanel: "5b222744ca1df794edff46db",
			idRivisa: "BDH0025",
			modelo: "RITMO DH",
			posteExtremo: "RITMO",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16acd5ca1df794edf82198"],
			bayoneta: { id: "622b715c28778806f0a4c7e0", idRivisa: "BAY0059" },
		},
		{
			_id: "5b20fb87ca1df794edfe848f",
			tipoPanel: "5b222a5aca1df794edff4968",
			idRivisa: "BFA0134",
			modelo: "RITMO CLIP",
			posteExtremo: "RITMO",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: ["5b16ab91ca1df794edf82088"],
			bayoneta: { id: "5b447d5eca1df794ed16dbd6", idRivisa: "BAY0057" },
		},
		{
			_id: "5b20fb91ca1df794edfe8497",
			tipoPanel: "5b222a5aca1df794edff4968",
			idRivisa: "BFA0124",
			modelo: "RITMO CLIP",
			posteExtremo: "RITMO",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: ["595bb930060cda18c1334ed2"],
			bayoneta: { id: "5b447dc8ca1df794ed16dc3f", idRivisa: "BAY0056" },
		},
		{
			_id: "5b20fb9cca1df794edfe849f",
			tipoPanel: "5b222a5aca1df794edff4968",
			idRivisa: "BFA0144",
			modelo: "RITMO CLIP",
			posteExtremo: "RITMO",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			bayoneta: { id: "5b447e2bca1df794ed16dca1", idRivisa: "BAY0058" },
		},
		{
			_id: "623866fcc631a51514e61535",
			tipoPanel: "5b222a5aca1df794edff4968",
			idRivisa: "BFA0124",
			modelo: "RITMO CLIP",
			posteExtremo: "RITMO",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: ["5b16acd5ca1df794edf82198"],
			bayoneta: { id: "622b715c28778806f0a4c7e0", idRivisa: "BAY0059" },
		},
		{
			_id: "5b20fbacca1df794edfe84ad",
			tipoPanel: "5b222a51ca1df794edff4961",
			idRivisa: "BFA0133",
			modelo: "RITMO CLIP",
			posteExtremo: "RITMO",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b20fbb4ca1df794edfe84b4",
			tipoPanel: "5b222a51ca1df794edff4961",
			idRivisa: "BFA0123",
			modelo: "RITMO CLIP",
			posteExtremo: "RITMO",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b20fbbcca1df794edfe84bb",
			tipoPanel: "5b222a51ca1df794edff4961",
			idRivisa: "BFA0143",
			modelo: "RITMO CLIP",
			posteExtremo: "RITMO",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b20fbc6ca1df794edfe84c2",
			tipoPanel: "5b222a49ca1df794edff4958",
			idRivisa: "BFA0132",
			modelo: "RITMO CLIP",
			posteExtremo: "RITMO",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b20fbd2ca1df794edfe84cc",
			tipoPanel: "5b222a49ca1df794edff4958",
			idRivisa: "BFA0122",
			modelo: "RITMO CLIP",
			posteExtremo: "RITMO",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b20fbddca1df794edfe84d6",
			tipoPanel: "5b222a49ca1df794edff4958",
			idRivisa: "BFA0142",
			modelo: "RITMO CLIP",
			posteExtremo: "RITMO",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b20fbecca1df794edfe84e1",
			tipoPanel: "5b222a41ca1df794edff4951",
			idRivisa: "BFA0131",
			modelo: "RITMO CLIP",
			posteExtremo: "RITMO",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b20fbf2ca1df794edfe84e7",
			tipoPanel: "5b222a41ca1df794edff4951",
			idRivisa: "BFA0121",
			modelo: "RITMO CLIP",
			posteExtremo: "RITMO",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b20fbfcca1df794edfe84ef",
			tipoPanel: "5b222a41ca1df794edff4951",
			idRivisa: "BFA0141",
			modelo: "RITMO CLIP",
			posteExtremo: "RITMO",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b20fc09ca1df794edfe84f9",
			tipoPanel: "5b222a38ca1df794edff4948",
			idRivisa: "BFA0130",
			modelo: "RITMO CLIP",
			posteExtremo: "RITMO",
			altura: "0m60",
			altura3d: "0m60",
			alturaValor: 600,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b20fc13ca1df794edfe8501",
			tipoPanel: "5b222a38ca1df794edff4948",
			idRivisa: "BFA0120",
			modelo: "RITMO CLIP",
			posteExtremo: "RITMO",
			altura: "0m60",
			altura3d: "0m60",
			alturaValor: 600,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b20fc1cca1df794edfe850b",
			tipoPanel: "5b222a38ca1df794edff4948",
			idRivisa: "BFA0140",
			modelo: "RITMO CLIP",
			posteExtremo: "RITMO",
			altura: "0m60",
			altura3d: "0m60",
			alturaValor: 600,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b20fd29ca1df794edfe85de",
			tipoPanel: "5b222a64ca1df794edff4975",
			idRivisa: "BFA0135",
			modelo: "RITMO CLIP",
			posteExtremo: "RITMO",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16ab91ca1df794edf82088"],
			bayoneta: { id: "5b447d5eca1df794ed16dbd6", idRivisa: "BAY0057" },
		},
		{
			_id: "5b20fd38ca1df794edfe85ea",
			tipoPanel: "5b222a64ca1df794edff4975",
			idRivisa: "BFA0125",
			modelo: "RITMO CLIP",
			posteExtremo: "RITMO",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed2"],
			bayoneta: { id: "5b447dc8ca1df794ed16dc3f", idRivisa: "BAY0056" },
		},
		{
			_id: "5b20fd46ca1df794edfe85f6",
			tipoPanel: "5b222a64ca1df794edff4975",
			idRivisa: "BFA0145",
			modelo: "RITMO CLIP",
			posteExtremo: "RITMO",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			bayoneta: { id: "5b447e2bca1df794ed16dca1", idRivisa: "BAY0058" },
		},
		{
			_id: "623871c2c631a51514e61538",
			tipoPanel: "5b222a64ca1df794edff4975",
			idRivisa: "BFA0125",
			modelo: "RITMO CLIP",
			posteExtremo: "RITMO",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16acd5ca1df794edf82198"],
			bayoneta: { id: "622b715c28778806f0a4c7e0", idRivisa: "BAY0059" },
		},
		{
			_id: "5b3b7f26ca1df794ed0ff2df",
			tipoPanel: "5b47640fca1df794ed196492",
			idRivisa: "BCS0013",
			modelo: "CLASSIC",
			altura: "0m60",
			altura3d: "1m00",
			alturaValor: 600,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b3b7f6aca1df794ed0ff326",
			tipoPanel: "5b47640fca1df794ed196492",
			idRivisa: "BCS0009",
			modelo: "CLASSIC",
			altura: "0m60",
			altura3d: "1m00",
			alturaValor: 600,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b3b7f85ca1df794ed0ff33f",
			tipoPanel: "5b47640fca1df794ed196492",
			idRivisa: "BCS0029",
			modelo: "CLASSIC",
			altura: "0m60",
			altura3d: "1m00",
			alturaValor: 600,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b3b7fbbca1df794ed0ff376",
			tipoPanel: "5b47645aca1df794ed1964e8",
			idRivisa: "BCS0014",
			modelo: "CLASSIC",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b3b7febca1df794ed0ff3a8",
			tipoPanel: "5b47645aca1df794ed1964e8",
			idRivisa: "BCS0010",
			modelo: "CLASSIC",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b3b8007ca1df794ed0ff3c4",
			tipoPanel: "5b47645aca1df794ed1964e8",
			idRivisa: "BCS0030",
			modelo: "CLASSIC",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b3b802bca1df794ed0ff3e7",
			tipoPanel: "5b47646bca1df794ed1964f8",
			idRivisa: "BCS0015",
			modelo: "CLASSIC",
			altura: "1m50",
			altura3d: "2m00",
			alturaValor: 1500,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b3b8049ca1df794ed0ff409",
			tipoPanel: "5b47646bca1df794ed1964f8",
			idRivisa: "BCS0011",
			modelo: "CLASSIC",
			altura: "1m50",
			altura3d: "2m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b3b8063ca1df794ed0ff426",
			tipoPanel: "5b47646bca1df794ed1964f8",
			idRivisa: "BCS0031",
			modelo: "CLASSIC",
			altura: "1m50",
			altura3d: "2m00",
			alturaValor: 1500,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b3b8087ca1df794ed0ff44c",
			tipoPanel: "5b476482ca1df794ed196518",
			idRivisa: "BCS0016",
			modelo: "CLASSIC",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b3b80a0ca1df794ed0ff468",
			tipoPanel: "5b476482ca1df794ed196518",
			idRivisa: "BCS0012",
			modelo: "CLASSIC",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b3b80b9ca1df794ed0ff489",
			tipoPanel: "5b476482ca1df794ed196518",
			idRivisa: "BCS0032",
			modelo: "CLASSIC",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b3b811cca1df794ed0ff4ee",
			tipoPanel: "5b4767e5ca1df794ed1968ee",
			idRivisa: "BCX0010",
			modelo: "CALITAX",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b3b8149ca1df794ed0ff51c",
			tipoPanel: "5b4767e5ca1df794ed1968ee",
			idRivisa: "BCX0007",
			modelo: "CALITAX",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b3b816aca1df794ed0ff53d",
			tipoPanel: "5b4767e5ca1df794ed1968ee",
			idRivisa: "BCX0022",
			modelo: "CALITAX",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},

		{
			_id: "62b58078af08dcedc94ac124",
			tipoPanel: "62b55c60af08dcedc94ac105",
			idRivisa: "BCX001005",
			modelo: "CALITAX",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "62b580b2af08dcedc94ac125",
			tipoPanel: "62b55c60af08dcedc94ac105",
			idRivisa: "BCX000705",
			modelo: "CALITAX",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "62b580c6af08dcedc94ac126",
			tipoPanel: "62b55c60af08dcedc94ac105",
			idRivisa: "BCX002205",
			modelo: "CALITAX",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
		},

		{
			_id: "62c566fc969ac33111ffe7d9",
			tipoPanel: "62b55c60af08dcedc94ac105",
			idRivisa: "BCX002605",
			modelo: "CALITAX",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["5b16acd5ca1df794edf82198"],
		},

		{
			_id: "5b3b8183ca1df794ed0ff557",
			tipoPanel: "5b476892ca1df794ed19699f",
			idRivisa: "BCX0011",
			modelo: "CALITAX",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b3b81a0ca1df794ed0ff577",
			tipoPanel: "5b476892ca1df794ed19699f",
			idRivisa: "BCX0008",
			modelo: "CALITAX",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b3b81c1ca1df794ed0ff59b",
			tipoPanel: "5b476892ca1df794ed19699f",
			idRivisa: "BCX0023",
			modelo: "CALITAX",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "62b563faaf08dcedc94ac10d",
			tipoPanel: "62b55cb7af08dcedc94ac106",
			idRivisa: "BCX001105",
			modelo: "CALITAX",
			altura: "1m80",
			altura3d: "1m00",
			alturaValor: 1800,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "62b5640faf08dcedc94ac10f",
			tipoPanel: "62b55cb7af08dcedc94ac106",
			idRivisa: "BCX000805",
			modelo: "CALITAX",
			altura: "1m80",
			altura3d: "1m00",
			alturaValor: 1800,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "62b5641daf08dcedc94ac110",
			tipoPanel: "62b55cb7af08dcedc94ac106",
			idRivisa: "BCX002305",
			modelo: "CALITAX",
			altura: "1m80",
			altura3d: "1m00",
			alturaValor: 1800,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
		},

		{
			_id: "62c56735969ac33111ffe7da",
			tipoPanel: "62b55cb7af08dcedc94ac106",
			idRivisa: "BCX002705",
			modelo: "CALITAX",
			altura: "1m80",
			altura3d: "1m00",
			alturaValor: 1800,
			color: ["5b16acd5ca1df794edf82198"],
		},

		{
			_id: "5b3b81eeca1df794ed0ff5ca",
			tipoPanel: "5b476899ca1df794ed1969a6",
			idRivisa: "BCX0012",
			modelo: "CALITAX",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b3b8210ca1df794ed0ff5ec",
			tipoPanel: "5b476899ca1df794ed1969a6",
			idRivisa: "BCX0009",
			modelo: "CALITAX",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b3b823fca1df794ed0ff626",
			tipoPanel: "5b476899ca1df794ed1969a6",
			idRivisa: "BCX0024",
			modelo: "CALITAX",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b3b828cca1df794ed0ff685",
			tipoPanel: "5b4768dfca1df794ed1969f0",
			idRivisa: "BNO0021",
			modelo: "NOVE",
			altura: "0m60",
			altura3d: "1m00",
			alturaValor: 600,
			color: ["595bb930060cda18c1334eda"],
		},
		{
			_id: "5b3b82d2ca1df794ed0ff6c8",
			tipoPanel: "5b4768dfca1df794ed1969f0",
			idRivisa: "BNO0009",
			modelo: "NOVE",
			altura: "0m60",
			altura3d: "1m00",
			alturaValor: 600,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b3b82efca1df794ed0ff6e8",
			tipoPanel: "5b4768dfca1df794ed1969f0",
			idRivisa: "BNO0018",
			modelo: "NOVE",
			altura: "0m60",
			altura3d: "1m00",
			alturaValor: 600,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b3b8331ca1df794ed0ff729",
			tipoPanel: "5b4768e9ca1df794ed196a00",
			idRivisa: "BNO0022",
			modelo: "NOVE",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334eda"],
		},
		{
			_id: "5b3b8352ca1df794ed0ff74c",
			tipoPanel: "5b4768e9ca1df794ed196a00",
			idRivisa: "BNO0010",
			modelo: "NOVE",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b3b83a4ca1df794ed0ff79b",
			tipoPanel: "5b4768e9ca1df794ed196a00",
			idRivisa: "BNO0019",
			modelo: "NOVE",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},

		{
			_id: "62b59030af08dcedc94ac131",
			tipoPanel: "62b574e4af08dcedc94ac11c",
			idRivisa: "BNO001305",
			modelo: "NOVE",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["595bb930060cda18c1334eda"],
		},
		{
			_id: "62b5903daf08dcedc94ac132",
			tipoPanel: "62b574e4af08dcedc94ac11c",
			idRivisa: "BNO001005",
			modelo: "NOVE",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "62b59048af08dcedc94ac133",
			tipoPanel: "62b574e4af08dcedc94ac11c",
			idRivisa: "BNO001905",
			modelo: "NOVE",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
		},
		{
			_id: "62c567e0969ac33111ffe7db",
			tipoPanel: "62b574e4af08dcedc94ac11c",
			idRivisa: "BNO002505",
			modelo: "NOVE",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["5b16acd5ca1df794edf82198"],
		},

		{
			_id: "5b3b83c5ca1df794ed0ff7bd",
			tipoPanel: "5b4768f1ca1df794ed196a0b",
			idRivisa: "BNO0023",
			modelo: "NOVE",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334eda"],
		},
		{
			_id: "5b3b83e7ca1df794ed0ff7e1",
			tipoPanel: "5b4768f1ca1df794ed196a0b",
			idRivisa: "BNO0011",
			modelo: "NOVE",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b3b8406ca1df794ed0ff804",
			tipoPanel: "5b4768f1ca1df794ed196a0b",
			idRivisa: "BNO0020",
			modelo: "NOVE",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b3b844fca1df794ed0ff849",
			tipoPanel: "5b476946ca1df794ed196a64",
			idRivisa: "BUL0010",
			modelo: "ULTRA",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["5b16ab91ca1df794edf82088"],
			topEdgeCut: 0,
		},
		{
			_id: "5b3b848fca1df794ed0ff88a",
			tipoPanel: "5b476946ca1df794ed196a64",
			idRivisa: "BUL0007",
			modelo: "ULTRA",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed2"],
			topEdgeCut: 0,
		},
		{
			_id: "5b3b84aeca1df794ed0ff8ac",
			tipoPanel: "5b476946ca1df794ed196a64",
			idRivisa: "BUL0022",
			modelo: "ULTRA",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
			topEdgeCut: 0,
		},
		{
			_id: "5b3b84caca1df794ed0ff8ca",
			tipoPanel: "5b476946ca1df794ed196a64",
			idRivisa: "BUL0004",
			modelo: "ULTRA",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed0"],
			topEdgeCut: 0,
		},
		{
			_id: "651e7dac9764d8f4882beeff",
			tipoPanel: "5b476946ca1df794ed196a64",
			idRivisa: "BULR0020",
			modelo: "ULTRA",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["5b16ab91ca1df794edf82088"],
			topEdgeCut: 1,
		},
		{
			_id: "651e80fa9764d8f4882bef00",
			tipoPanel: "5b476946ca1df794ed196a64",
			idRivisa: "BULR0010",
			modelo: "ULTRA",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed2"],
			topEdgeCut: 1,
		},
		{
			_id: "651e810a9764d8f4882bef01",
			tipoPanel: "5b476946ca1df794ed196a64",
			idRivisa: "BULR0050",
			modelo: "ULTRA",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"595bb930060cda18c1334ed0",
			],
			topEdgeCut: 1,
		},
		{
			_id: "651e81139764d8f4882bef02",
			tipoPanel: "5b476946ca1df794ed196a64",
			idRivisa: "BULR0030",
			modelo: "ULTRA",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["5b16acd5ca1df794edf82198"],
			topEdgeCut: 1,
		},
		{
			_id: "651e81139764d8f4882bef02",
			tipoPanel: "5b476946ca1df794ed196a64",
			idRivisa: "BULR0040",
			modelo: "ULTRA",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334eda"],
			topEdgeCut: 1,
		},
		{
			_id: "651fd764fc3e523f74dca6c0",
			tipoPanel: "5b476946ca1df794ed196a64",
			idRivisa: "BULD0020",
			modelo: "ULTRA",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["5b16ab91ca1df794edf82088"],
			topEdgeCut: 2,
		},
		{
			_id: "651fd764fc3e523f74dca6c1",
			tipoPanel: "5b476946ca1df794ed196a64",
			idRivisa: "BULD0010",
			modelo: "ULTRA",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed2"],
			topEdgeCut: 2,
		},
		{
			_id: "651fd764fc3e523f74dca6c2",
			tipoPanel: "5b476946ca1df794ed196a64",
			idRivisa: "BULD0050",
			modelo: "ULTRA",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"595bb930060cda18c1334ed0",
			],
			topEdgeCut: 2,
		},
		{
			_id: "651fd764fc3e523f74dca6c3",
			tipoPanel: "5b476946ca1df794ed196a64",
			idRivisa: "BULD0030",
			modelo: "ULTRA",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["5b16acd5ca1df794edf82198"],
			topEdgeCut: 2,
		},
		{
			_id: "651fd764fc3e523f74dca6c4",
			tipoPanel: "5b476946ca1df794ed196a64",
			idRivisa: "BULD0040",
			modelo: "ULTRA",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334eda"],
			topEdgeCut: 2,
		},
		{
			_id: "62b58a2aaf08dcedc94ac12a",
			tipoPanel: "62b56804af08dcedc94ac112",
			idRivisa: "BUL001005",
			modelo: "ULTRA",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["5b16ab91ca1df794edf82088"],
			topEdgeCut: 0,
		},
		{
			_id: "62b58a3faf08dcedc94ac12b",
			tipoPanel: "62b56804af08dcedc94ac112",
			idRivisa: "BUL000705",
			modelo: "ULTRA",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["595bb930060cda18c1334ed2"],
			topEdgeCut: 0,
		},
		{
			_id: "62b58a4caf08dcedc94ac12c",
			tipoPanel: "62b56804af08dcedc94ac112",
			idRivisa: "BUL002201",
			modelo: "ULTRA",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			topEdgeCut: 0,
		},
		{
			_id: "62b58a4caf08dcedc94ac12d",
			tipoPanel: "62b56804af08dcedc94ac112",
			idRivisa: "BUL002601",
			modelo: "ULTRA",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["5b16acd5ca1df794edf82198"],
			topEdgeCut: 0,
		},
		{
			_id: "651e9b839764d8f4882bef03",
			tipoPanel: "62b56804af08dcedc94ac112",
			idRivisa: "BULR0021",
			modelo: "ULTRA",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["5b16ab91ca1df794edf82088"],
			topEdgeCut: 1,
		},
		{
			_id: "651e9b839764d8f4882bef04",
			tipoPanel: "62b56804af08dcedc94ac112",
			idRivisa: "BULR0011",
			modelo: "ULTRA",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["595bb930060cda18c1334ed2"],
			topEdgeCut: 1,
		},
		{
			_id: "651e9b839764d8f4882bef05",
			tipoPanel: "62b56804af08dcedc94ac112",
			idRivisa: "BULR0051",
			modelo: "ULTRA",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"595bb930060cda18c1334ed0",
			],
			topEdgeCut: 1,
		},
		{
			_id: "651e9b839764d8f4882bef06",
			tipoPanel: "62b56804af08dcedc94ac112",
			idRivisa: "BULR0031",
			modelo: "ULTRA",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["5b16acd5ca1df794edf82198"],
			topEdgeCut: 1,
		},
		{
			_id: "651e9b839764d8f4882bef06",
			tipoPanel: "62b56804af08dcedc94ac112",
			idRivisa: "BULR0041",
			modelo: "ULTRA",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["595bb930060cda18c1334eda"],
			topEdgeCut: 1,
		},
		{
			_id: "651fd764fc3e523f74dca6c5",
			tipoPanel: "62b56804af08dcedc94ac112",
			idRivisa: "BULD0021",
			modelo: "ULTRA",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["5b16ab91ca1df794edf82088"],
			topEdgeCut: 2,
		},
		{
			_id: "651fd764fc3e523f74dca6c6",
			tipoPanel: "62b56804af08dcedc94ac112",
			idRivisa: "BULD0011",
			modelo: "ULTRA",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["595bb930060cda18c1334ed2"],
			topEdgeCut: 2,
		},
		{
			_id: "651fd764fc3e523f74dca6c7",
			tipoPanel: "62b56804af08dcedc94ac112",
			idRivisa: "BULD0051",
			modelo: "ULTRA",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"595bb930060cda18c1334ed0",
			],
			topEdgeCut: 2,
		},
		{
			_id: "651fd764fc3e523f74dca6c8",
			tipoPanel: "62b56804af08dcedc94ac112",
			idRivisa: "BULD0031",
			modelo: "ULTRA",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["5b16acd5ca1df794edf82198"],
			topEdgeCut: 2,
		},
		{
			_id: "651fd764fc3e523f74dca6c9",
			tipoPanel: "62b56804af08dcedc94ac112",
			idRivisa: "BULD0041",
			modelo: "ULTRA",
			altura: "1m20",
			altura3d: "1m00",
			alturaValor: 1200,
			color: ["595bb930060cda18c1334eda"],
			topEdgeCut: 2,
		},
		{
			_id: "5b3b8518ca1df794ed0ff917",
			tipoPanel: "5b47694eca1df794ed196a6c",
			idRivisa: "BUL0011",
			modelo: "ULTRA",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["5b16ab91ca1df794edf82088"],
			topEdgeCut: 0,
		},
		{
			_id: "5b3b8534ca1df794ed0ff93e",
			tipoPanel: "5b47694eca1df794ed196a6c",
			idRivisa: "BUL0008",
			modelo: "ULTRA",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed2"],
			topEdgeCut: 0,
		},
		{
			_id: "5b3b855aca1df794ed0ff974",
			tipoPanel: "5b47694eca1df794ed196a6c",
			idRivisa: "BUL0023",
			modelo: "ULTRA",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
			topEdgeCut: 0,
		},
		{
			_id: "5b3b8574ca1df794ed0ff99a",
			tipoPanel: "5b47694eca1df794ed196a6c",
			idRivisa: "BUL0005",
			modelo: "ULTRA",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed0"],
			topEdgeCut: 0,
		},
		{
			_id: "651eb7f29764d8f4882bef05",
			tipoPanel: "5b47694eca1df794ed196a6c",
			idRivisa: "BULR0022",
			modelo: "ULTRA",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["5b16ab91ca1df794edf82088"],
			topEdgeCut: 1,
		},
		{
			_id: "651eb7f29764d8f4882bef06",
			tipoPanel: "5b47694eca1df794ed196a6c",
			idRivisa: "BULR0012",
			modelo: "ULTRA",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed2"],
			topEdgeCut: 1,
		},
		{
			_id: "651eb7f29764d8f4882bef07",
			tipoPanel: "5b47694eca1df794ed196a6c",
			idRivisa: "BULR0052",
			modelo: "ULTRA",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"595bb930060cda18c1334ed0",
			],
			topEdgeCut: 1,
		},
		{
			_id: "651eb7f29764d8f4882bef08",
			tipoPanel: "5b47694eca1df794ed196a6c",
			idRivisa: "BULR0032",
			modelo: "ULTRA",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["5b16acd5ca1df794edf82198"],
			topEdgeCut: 1,
		},
		{
			_id: "651eb7f29764d8f4882bef09",
			tipoPanel: "5b47694eca1df794ed196a6c",
			idRivisa: "BULR0042",
			modelo: "ULTRA",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334eda"],
			topEdgeCut: 1,
		},
		{
			_id: "651eb7f29764d8f4882bef05",
			tipoPanel: "5b47694eca1df794ed196a6c",
			idRivisa: "BULD0022",
			modelo: "ULTRA",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["5b16ab91ca1df794edf82088"],
			topEdgeCut: 2,
		},
		{
			_id: "651fd764fc3e523f74dca6ca",
			tipoPanel: "5b47694eca1df794ed196a6c",
			idRivisa: "BULD0012",
			modelo: "ULTRA",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed2"],
			topEdgeCut: 2,
		},
		{
			_id: "651fd764fc3e523f74dca6cb",
			tipoPanel: "5b47694eca1df794ed196a6c",
			idRivisa: "BULD0052",
			modelo: "ULTRA",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"595bb930060cda18c1334ed0",
			],
			topEdgeCut: 2,
		},
		{
			_id: "651fd764fc3e523f74dca6cc",
			tipoPanel: "5b47694eca1df794ed196a6c",
			idRivisa: "BULD0032",
			modelo: "ULTRA",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["5b16acd5ca1df794edf82198"],
			topEdgeCut: 2,
		},
		{
			_id: "651fd764fc3e523f74dca6cd",
			tipoPanel: "5b47694eca1df794ed196a6c",
			idRivisa: "BULD0042",
			modelo: "ULTRA",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334eda"],
			topEdgeCut: 2,
		},
		{
			_id: "62b58d78af08dcedc94ac12d",
			tipoPanel: "62b5688baf08dcedc94ac113",
			idRivisa: "BUL001105",
			modelo: "ULTRA",
			altura: "1m80",
			altura3d: "1m00",
			alturaValor: 1800,
			color: ["5b16ab91ca1df794edf82088"],
			topEdgeCut: 0,
		},
		{
			_id: "62b58d83af08dcedc94ac12e",
			tipoPanel: "62b5688baf08dcedc94ac113",
			idRivisa: "BUL000805",
			modelo: "ULTRA",
			altura: "1m80",
			altura3d: "1m00",
			alturaValor: 1800,
			color: ["595bb930060cda18c1334ed2"],
			topEdgeCut: 0,
		},
		{
			_id: "62b58d90af08dcedc94ac12f",
			tipoPanel: "62b5688baf08dcedc94ac113",
			idRivisa: "BUL002301",
			modelo: "ULTRA",
			altura: "1m80",
			altura3d: "1m00",
			alturaValor: 1800,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			topEdgeCut: 0,
		},
		{
			_id: "651ebff9fc3e523f74dca68e",
			tipoPanel: "62b5688baf08dcedc94ac113",
			idRivisa: "BUL002701",
			modelo: "ULTRA",
			altura: "1m80",
			altura3d: "1m00",
			alturaValor: 1800,
			color: ["5b16acd5ca1df794edf82198"],
			topEdgeCut: 0,
		},
		{
			_id: "651ec3e3fc3e523f74dca68f",
			tipoPanel: "62b5688baf08dcedc94ac113",
			idRivisa: "BULR0023",
			modelo: "ULTRA",
			altura: "1m80",
			altura3d: "1m00",
			alturaValor: 1800,
			color: ["5b16ab91ca1df794edf82088"],
			topEdgeCut: 1,
		},
		{
			_id: "651ec407fc3e523f74dca690",
			tipoPanel: "62b5688baf08dcedc94ac113",
			idRivisa: "BULR0013",
			modelo: "ULTRA",
			altura: "1m80",
			altura3d: "1m00",
			alturaValor: 1800,
			color: ["595bb930060cda18c1334ed2"],
			topEdgeCut: 1,
		},
		{
			_id: "651ec407fc3e523f74dca691",
			tipoPanel: "62b5688baf08dcedc94ac113",
			idRivisa: "BULR0053",
			modelo: "ULTRA",
			altura: "1m80",
			altura3d: "1m00",
			alturaValor: 1800,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334ed0",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			topEdgeCut: 1,
		},
		{
			_id: "651ec407fc3e523f74dca692",
			tipoPanel: "62b5688baf08dcedc94ac113",
			idRivisa: "BULR0033",
			modelo: "ULTRA",
			altura: "1m80",
			altura3d: "1m00",
			alturaValor: 1800,
			color: ["5b16acd5ca1df794edf82198"],
			topEdgeCut: 1,
		},
		{
			_id: "651ec407fc3e523f74dca693",
			tipoPanel: "62b5688baf08dcedc94ac113",
			idRivisa: "BULR0043",
			modelo: "ULTRA",
			altura: "1m80",
			altura3d: "1m00",
			alturaValor: 1800,
			color: ["595bb930060cda18c1334eda"],
			topEdgeCut: 1,
		},
		{
			_id: "651fd764fc3e523f74dca6ce",
			tipoPanel: "62b5688baf08dcedc94ac113",
			idRivisa: "BULD0023",
			modelo: "ULTRA",
			altura: "1m80",
			altura3d: "1m00",
			alturaValor: 1800,
			color: ["5b16ab91ca1df794edf82088"],
			topEdgeCut: 2,
		},
		{
			_id: "651fd764fc3e523f74dca6cf",
			tipoPanel: "62b5688baf08dcedc94ac113",
			idRivisa: "BULD0013",
			modelo: "ULTRA",
			altura: "1m80",
			altura3d: "1m00",
			alturaValor: 1800,
			color: ["595bb930060cda18c1334ed2"],
			topEdgeCut: 2,
		},
		{
			_id: "651fd764fc3e523f74dca6d0",
			tipoPanel: "62b5688baf08dcedc94ac113",
			idRivisa: "BULD0053",
			modelo: "ULTRA",
			altura: "1m80",
			altura3d: "1m00",
			alturaValor: 1800,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334ed0",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			topEdgeCut: 2,
		},
		{
			_id: "651fd764fc3e523f74dca6d1",
			tipoPanel: "62b5688baf08dcedc94ac113",
			idRivisa: "BULD0033",
			modelo: "ULTRA",
			altura: "1m80",
			altura3d: "1m00",
			alturaValor: 1800,
			color: ["5b16acd5ca1df794edf82198"],
			topEdgeCut: 2,
		},
		{
			_id: "651fd764fc3e523f74dca6d2",
			tipoPanel: "62b5688baf08dcedc94ac113",
			idRivisa: "BULD0043",
			modelo: "ULTRA",
			altura: "1m80",
			altura3d: "1m00",
			alturaValor: 1800,
			color: ["595bb930060cda18c1334eda"],
			topEdgeCut: 2,
		},
		{
			_id: "5b3b8595ca1df794ed0ff9bd",
			tipoPanel: "5b476956ca1df794ed196a76",
			idRivisa: "BUL0012",
			modelo: "ULTRA",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16ab91ca1df794edf82088"],
			topEdgeCut: 0,
		},
		{
			_id: "5b3b85afca1df794ed0ff9e2",
			tipoPanel: "5b476956ca1df794ed196a76",
			idRivisa: "BUL0009",
			modelo: "ULTRA",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed2"],
			topEdgeCut: 0,
		},
		{
			_id: "5b3b85ceca1df794ed0ffa00",
			tipoPanel: "5b476956ca1df794ed196a76",
			idRivisa: "BUL0024",
			modelo: "ULTRA",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
			topEdgeCut: 0,
		},
		{
			_id: "5b3b85ebca1df794ed0ffa21",
			tipoPanel: "5b476956ca1df794ed196a76",
			idRivisa: "BUL0006",
			modelo: "ULTRA",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed0"],
			topEdgeCut: 0,
		},
		{
			_id: "651ec407fc3e523f74dca694",
			tipoPanel: "5b476956ca1df794ed196a76",
			idRivisa: "BULR0024",
			modelo: "ULTRA",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16ab91ca1df794edf82088"],
			topEdgeCut: 1,
		},
		{
			_id: "651ec407fc3e523f74dca695",
			tipoPanel: "5b476956ca1df794ed196a76",
			idRivisa: "BULR0014",
			modelo: "ULTRA",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed2"],
			topEdgeCut: 1,
		},
		{
			_id: "651ec407fc3e523f74dca696",
			tipoPanel: "5b476956ca1df794ed196a76",
			idRivisa: "BULR0054",
			modelo: "ULTRA",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334ed0",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			topEdgeCut: 1,
		},
		{
			_id: "651ec407fc3e523f74dca697",
			tipoPanel: "5b476956ca1df794ed196a76",
			idRivisa: "BULR0044",
			modelo: "ULTRA",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334eda"],
			topEdgeCut: 1,
		},
		{
			_id: "651ec407fc3e523f74dca698",
			tipoPanel: "5b476956ca1df794ed196a76",
			idRivisa: "BULR0034",
			modelo: "ULTRA",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16acd5ca1df794edf82198"],
			topEdgeCut: 1,
		},
		{
			_id: "651fd764fc3e523f74dca6d3",
			tipoPanel: "5b476956ca1df794ed196a76",
			idRivisa: "BULD0024",
			modelo: "ULTRA",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16ab91ca1df794edf82088"],
			topEdgeCut: 2,
		},
		{
			_id: "651fd764fc3e523f74dca6d4",
			tipoPanel: "5b476956ca1df794ed196a76",
			idRivisa: "BULD0014",
			modelo: "ULTRA",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed2"],
			topEdgeCut: 2,
		},
		{
			_id: "651fd764fc3e523f74dca6d5",
			tipoPanel: "5b476956ca1df794ed196a76",
			idRivisa: "BULD0054",
			modelo: "ULTRA",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334ed0",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
			],
			topEdgeCut: 2,
		},
		{
			_id: "651fd764fc3e523f74dca6d6",
			tipoPanel: "5b476956ca1df794ed196a76",
			idRivisa: "BULD0044",
			modelo: "ULTRA",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334eda"],
			topEdgeCut: 2,
		},
		{
			_id: "651fd764fc3e523f74dca6d7",
			tipoPanel: "5b476956ca1df794ed196a76",
			idRivisa: "BULD0034",
			modelo: "ULTRA",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16acd5ca1df794edf82198"],
			topEdgeCut: 2,
		},
		{
			_id: "5b3b8d9bca1df794ed1001b4",
			tipoPanel: "5b4769bcca1df794ed196ae2",
			idRivisa: "BDC0005",
			modelo: "DECOR",
			altura: "0m60",
			altura3d: "1m00",
			alturaValor: 600,
			color: ["5b16ab91ca1df794edf82088"],
			colorStr: "BLANCO",
		},
		{
			_id: "5b3b8db4ca1df794ed1001cd",
			tipoPanel: "5b4769bcca1df794ed196ae2",
			idRivisa: "BDC0001",
			modelo: "DECOR",
			altura: "0m60",
			altura3d: "1m00",
			alturaValor: 600,
			color: ["595bb930060cda18c1334ed2"],
			colorStr: "VERDE",
		},
		{
			_id: "5b3b8dceca1df794ed1001eb",
			tipoPanel: "5b4769bcca1df794ed196ae2",
			idRivisa: "BDC0013",
			modelo: "DECOR",
			altura: "0m60",
			altura3d: "1m00",
			alturaValor: 600,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
			colorStr: "RAL",
		},
		{
			_id: "5b3b8de7ca1df794ed100212",
			tipoPanel: "5b4769bcca1df794ed196ae2",
			idRivisa: "BDC0022",
			modelo: "DECOR",
			altura: "0m60",
			altura3d: "1m00",
			alturaValor: 600,
			color: ["595bb930060cda18c1334ed0"],
			colorStr: "GALVANIZADO",
		},
		{
			_id: "5b3b8e10ca1df794ed10023d",
			tipoPanel: "5b4769c7ca1df794ed196aed",
			idRivisa: "BDC0006",
			modelo: "DECOR",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["5b16ab91ca1df794edf82088"],
			colorStr: "BLANCO",
		},
		{
			_id: "5b3b8e4bca1df794ed10028d",
			tipoPanel: "5b4769c7ca1df794ed196aed",
			idRivisa: "BDC0014",
			modelo: "DECOR",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
			colorStr: "RAL",
		},
		{
			_id: "5b3b8e64ca1df794ed1002a6",
			tipoPanel: "5b4769c7ca1df794ed196aed",
			idRivisa: "BDC0023",
			modelo: "DECOR",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed0"],
			colorStr: "GALVANIZADO",
		},
		{
			_id: "5b3b8e7eca1df794ed1002c7",
			tipoPanel: "5b4769ceca1df794ed196af6",
			idRivisa: "BDC0007",
			modelo: "DECOR",
			altura: "1m50",
			altura3d: "2m00",
			alturaValor: 1500,
			color: ["5b16ab91ca1df794edf82088"],
			colorStr: "BLANCO",
		},
		{
			_id: "5b3b8e99ca1df794ed1002f3",
			tipoPanel: "5b4769ceca1df794ed196af6",
			idRivisa: "BDC0003",
			modelo: "DECOR",
			altura: "1m50",
			altura3d: "2m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed2"],
			colorStr: "VERDE",
		},
		{
			_id: "5b3b8eb2ca1df794ed10030e",
			tipoPanel: "5b4769ceca1df794ed196af6",
			idRivisa: "BDC0015",
			modelo: "DECOR",
			altura: "1m50",
			altura3d: "2m00",
			alturaValor: 1500,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
			colorStr: "RAL",
		},
		{
			_id: "5b3b8ececa1df794ed100333",
			tipoPanel: "5b4769ceca1df794ed196af6",
			idRivisa: "BDC0024",
			modelo: "DECOR",
			altura: "1m50",
			altura3d: "2m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed0"],
			colorStr: "GALVANIZADO",
		},
		{
			_id: "5b3b8ef6ca1df794ed10035e",
			tipoPanel: "5b4769d5ca1df794ed196b02",
			idRivisa: "BDC0008",
			modelo: "DECOR",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16ab91ca1df794edf82088"],
			colorStr: "BLANCO",
		},
		{
			_id: "5b3b8f0eca1df794ed10038b",
			tipoPanel: "5b4769d5ca1df794ed196b02",
			idRivisa: "BDC0004",
			modelo: "DECOR",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed2"],
			colorStr: "VERDE",
		},
		{
			_id: "5b3b8f29ca1df794ed1003b8",
			tipoPanel: "5b4769d5ca1df794ed196b02",
			idRivisa: "BDC0016",
			modelo: "DECOR",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
			colorStr: "RAL",
		},
		{
			_id: "5b3b8f41ca1df794ed100408",
			tipoPanel: "5b4769d5ca1df794ed196b02",
			idRivisa: "BDC0025",
			modelo: "DECOR",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed0"],
			colorStr: "GALVANIZADO",
		},
		{
			_id: "5b3b8f79ca1df794ed100449",
			tipoPanel: "5b4766d3ca1df794ed1967b5",
			idRivisa: "BNA0013",
			modelo: "NATURE",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b3b8f8fca1df794ed100475",
			tipoPanel: "5b4766d3ca1df794ed1967b5",
			idRivisa: "BNA0008",
			modelo: "NATURE",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b3b8fb5ca1df794ed1004a8",
			tipoPanel: "5b4766d3ca1df794ed1967b5",
			idRivisa: "BNA0018",
			modelo: "NATURE",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},

		{
			_id: "5b3b8fceca1df794ed1004cb",
			tipoPanel: "5b4766dfca1df794ed1967c2",
			idRivisa: "BNA0015",
			modelo: "NATURE",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b3b8fe7ca1df794ed1004f2",
			tipoPanel: "5b4766dfca1df794ed1967c2",
			idRivisa: "BNA0010",
			modelo: "NATURE",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b3b9000ca1df794ed100512",
			tipoPanel: "5b4766dfca1df794ed1967c2",
			idRivisa: "BNA0020",
			modelo: "NATURE",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b3b9020ca1df794ed10053e",
			tipoPanel: "5b4766eeca1df794ed1967d3",
			idRivisa: "BNA0017",
			modelo: "NATURE",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5b3b9041ca1df794ed100566",
			tipoPanel: "5b4766eeca1df794ed1967d3",
			idRivisa: "BNA0012",
			modelo: "NATURE",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5b3b905bca1df794ed10058c",
			tipoPanel: "5b4766eeca1df794ed1967d3",
			idRivisa: "BNA0022",
			modelo: "NATURE",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5b3ddd481938cf17b0526073",
			tipoPanel: "5b3107ceca1df794ed08f30b",
			idRivisa: "MEL0002",
			altura: "1m50",
			altura3d: "1m00",
			alturaValor: 1500,
			color: ["595bb930060cda18c1334ed2"],
			medidaMalla: "50x50",
			posteExtremo: "LUX80",
			soportesPosteExtremo: 4,
			grapasPosteExtremo: 33,
			posteIntermedio: "LUX50",
			soportePosteIntermedio: 4,
			grapasPosteIntermedio: 5,
			posteIntermedioDes: "LUX80",
			posteExtremoDes: "LUX50",
			rolloMalla: 25,
		},
		{
			_id: "5b3ddfbd5cf1fb17b03999dd",
			tipoPanel: "5b3107ceca1df794ed08f30b",
			idRivisa: "MEL0003",
			altura: "2m00",
			altura3d: "2m00",
			alturaValor: 2000,
			color: ["595bb930060cda18c1334ed2"],
			medidaMalla: "50x50",
			posteExtremo: "LUX80",
			soportesPosteExtremo: 4,
			grapasPosteExtremo: 44,
			posteIntermedio: "LUX80",
			soportePosteIntermedio: 4,
			grapasPosteIntermedio: 5,
			posteIntermedioDes: "LUX80",
			posteExtremoDes: "LUX50",
			rolloMalla: 25,
		},
		{
			_id: "5b4f3cdbca1df794ed1eba92",
			tipoPanel: "5b4769c7ca1df794ed196aed",
			idRivisa: "BDC0002",
			modelo: "DECOR",
			altura: "1m00",
			altura3d: "1m00",
			alturaValor: 1000,
			color: ["595bb930060cda18c1334ed2"],
			colorStr: "VERDE",
		},
		{
			_id: "5bf7c580ca1df794ed89334e",
			tipoPanel: "5bf7c292ca1df794ed8930eb",
			idRivisa: "BNA0014",
			modelo: "NATURE",
			altura: "1m20",
			altura3d: "1m20",
			alturaValor: 1200,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5bf7c58dca1df794ed893359",
			tipoPanel: "5bf7c292ca1df794ed8930eb",
			idRivisa: "BNA0009",
			modelo: "NATURE",
			altura: "1m20",
			altura3d: "1m20",
			alturaValor: 1200,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5bf7c5a0ca1df794ed89336b",
			tipoPanel: "5bf7c292ca1df794ed8930eb",
			idRivisa: "BNA0019",
			modelo: "NATURE",
			altura: "1m20",
			altura3d: "1m20",
			alturaValor: 1200,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5bf7c63dca1df794ed8933e5",
			tipoPanel: "5bf7c2cbca1df794ed89311a",
			idRivisa: "BNA0016",
			modelo: "NATURE",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5bf7c646ca1df794ed8933ed",
			tipoPanel: "5bf7c2cbca1df794ed89311a",
			idRivisa: "BNA0011",
			modelo: "NATURE",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5bf7c652ca1df794ed8933f7",
			tipoPanel: "5bf7c2cbca1df794ed89311a",
			idRivisa: "BNA0021",
			modelo: "NATURE",
			altura: "1m80",
			altura3d: "2m00",
			alturaValor: 1800,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
		{
			_id: "5bf7c709ca1df794ed893482",
			tipoPanel: "5bf7c3abca1df794ed8931d3",
			idRivisa: "BNA001701",
			modelo: "NATURE",
			altura: "2m40",
			altura3d: "2m00",
			alturaValor: 2400,
			color: ["5b16ab91ca1df794edf82088"],
		},
		{
			_id: "5bf7c714ca1df794ed89348c",
			tipoPanel: "5bf7c3abca1df794ed8931d3",
			idRivisa: "BNA001201",
			modelo: "NATURE",
			altura: "2m40",
			altura3d: "2m00",
			alturaValor: 2400,
			color: ["595bb930060cda18c1334ed2"],
		},
		{
			_id: "5bf7c71cca1df794ed893497",
			tipoPanel: "5bf7c3abca1df794ed8931d3",
			idRivisa: "BNA002201",
			modelo: "NATURE",
			altura: "2m40",
			altura3d: "2m00",
			alturaValor: 2400,
			color: [
				"595bb930060cda18c1334ed4",
				"595bb930060cda18c1334ed6",
				"595bb930060cda18c1334ed8",
				"595bb930060cda18c1334eda",
				"595bb930060cda18c1334edc",
				"595bb930060cda18c1334ede",
				"595bb930060cda18c1334ee0",
				"595bb930060cda18c1334ee2",
				"5b16acd5ca1df794edf82198",
			],
		},
	];

	public readonly tipoPuertas = [
		{
			_id: "5b4dbccaca1df794ed1daccc",
			modeloPuerta: "5b4da863ca1df794ed1d9bab",
			desc: {
				es: "Classic",
				ca: "Classic",
				en: "Classic",
				fr: "Classic",
			},
			idUnity: "DESLIZANTE_CLASSIC",
		},
		{
			_id: "5b4dd00bca1df794ed1dbd4a",
			modeloPuerta: "5b4dad3aca1df794ed1d9fa6",
			desc: { es: "Decor", ca: "Decor", en: "Decor", fr: "Decor" },
			idUnity: "FUERTE_DECOR",
		},
		{
			_id: "5942729885e50bd508b49322",
			modeloPuerta: "5942708e85e50bd508b492fa",
			desc: {
				es: "Estándard",
				ca: "Estàndard",
				en: "Standard",
				fr: "Standard",
			},
			idUnity: "ESTANDAR",
		},
		{
			_id: "5b4dd3e0ca1df794ed1dc08b",
			modeloPuerta: "5b4dd4efca1df794ed1dc171",
			desc: { es: "Ultra", ca: "Ultra", en: "Ultra", fr: "Ultra" },
			idUnity: "DESLIZANTE_ULTRA",
		},
		{
			_id: "5b4dd42eca1df794ed1dc0cb",
			modeloPuerta: "5b4dd50cca1df794ed1dc18d",
			desc: { es: "Decor", ca: "Decor", en: "Decor", fr: "Decor" },
			idUnity: "DESLIZANTE_DECOR",
		},
		{
			_id: "5b4dd45dca1df794ed1dc0f6",
			modeloPuerta: "5b4dd52bca1df794ed1dc1a5",
			desc: { es: "Nové", ca: "Nové", en: "Nové", fr: "Nové" },
			idUnity: "DESLIZANTE_NOVE",
		},
		{
			_id: "5b4dce45ca1df794ed1dbbc1",
			modeloPuerta: "5b4da6f5ca1df794ed1d9a89",
			desc: {
				es: "Estándard",
				ca: "Estàndard",
				en: "Standard",
				fr: "Standard",
			},
			idUnity: "FUERTE",
		},
		{
			_id: "5b4dcfddca1df794ed1dbd26",
			modeloPuerta: "5b4dacfdca1df794ed1d9f76",
			desc: { es: "Ultra", ca: "Ultra", en: "Ultra", fr: "Ultra" },
			idUnity: "FUERTE_ULTRA",
		},
		{
			_id: "5b4dd3cfca1df794ed1dc077",
			modeloPuerta: "5b4dd4b1ca1df794ed1dc138",
			desc: {
				es: "Calitax",
				ca: "Calitax",
				en: "Calitax",
				fr: "Calitax",
			},
			idUnity: "DESLIZANTE_CALITAX",
		},
		{
			_id: "5b4dd034ca1df794ed1dbd6e",
			modeloPuerta: "5b4dacb0ca1df794ed1d9f39",
			desc: { es: "Nové", ca: "Nové", en: "Nové", fr: "Nové" },
			idUnity: "FUERTE_NOVE",
		},
		{
			_id: "6244089fc46bdbd9cbf1eb1a",
			modeloPuerta: "623db1ae5936a5aeff1c45a3",
			desc: {
				es: "Batiente Medium",
				ca: "Batiente Medium",
				en: "Batiente Medium",
				fr: "Batiente Medium",
			},
			idUnity: "BATIENTE_MEDIUM",
		},
		{
			_id: "624b00c99c74b94d80f60788",
			modeloPuerta: "623b3c8efaa5517a9913ce1e",
			desc: {
				es: "Batiente Nature",
				ca: "Batiente Nature",
				en: "Batiente Nature",
				fr: "Batiente Nature",
			},
			idUnity: "BATIENTE_NATURE",
		},
		{
			_id: "624bfd3253bacc2f1cda9a57",
			modeloPuerta: "623dd5fc5936a5aeff1c45ae",
			desc: {
				es: "Batiente Nature",
				ca: "Batiente Nature",
				en: "Nature sliding Door",
				fr: "Coulissante Nature",
			},
			idUnity: "DESLIZANTE_NATURE",
		},
	];
}
